import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          welcome: "Welcome! Choose your language:",
          level: "What is your English level?",
          purpose: "Why are you learning English?",
          videos: "Here are some videos for you:",
          register: "Sign up to continue",
          options: {
            beginner: "I don't know anything yet",
            elementary: "Beginner",
            intermediate: "Intermediate",
            advanced: "Advanced",
            travel: "Preparation for travel",
            job: "For job interviews",
            education: "Educational purposes",
            communication: "To communicate with people",
            fun: "For fun",
          },
          welcome: "Welcome to our website",
          aboutUs: "About Us",
          contact: "Contact",
          services: "Services",
          blog: "Blog",
          catalog: "Catalog",
          buyNow: "Buy Now",
          addToCart: "Add to Cart",
          checkout: "Checkout",
          totalPrice: "Total Price",
          search: "Search",
          enterYourEmail: "Enter your email",
          subscribe: "Subscribe",
          latestNews: "Latest News",
          readMore: "Read More",
          sendMessage: "Send Message",
          name: "Name",
          email: "Email",
          message: "Message",
          submit: "Submit",
          loading: "Loading...",
          "Loading...": "Loading...",
          success: "Success!",
          error: "An error occurred. Please try again.",
          signin: "Sign in",
          "Password": "Password",
          forgotpassword: "Forgot Password",
          oro: "or",
          account: "Don't have an account?",
          register: "Registration",
          login: "Log In",
          loading: "Loading",
          signup: "Sign Up",
          "Sign Up": "Sign Up",
          username: "Username",
          confirmpassword: "Confirm Password",
          haveac: "Already have an account?",
          logout: "Logout",
          registerforfree: "Register for free",
          "Start speaking with confidence from day one": "Start speaking with confidence from day one",
          "Start Learning Free": "Start Learning Free",
          "Choose your English level and topics that interest you": "Choose your English level and topics that interest you",
          "All Categories": "All Categories",
          "All Levels": "All Levels",
          "Search videos by title": "Search videos by title",
          watch: "Learn New Words",
          watchbig:
            "Build your personal vocabulary or let AI select the most useful words for you.",
          learn: "Watch Videos",
          learnBig:
            "Dive into real-life conversations tailored to your level and goals.",
          speak: "Discuss",
          speakBig:
            "Chat with AI – by text or voice – just like in real conversations.",
          discuss: "Get Feedback on Your Answers",
          discussBig:
            "AI checks your answers, explains mistakes, and helps you improve.",
          popularVideo: "Popular Video",
          allLevels: "Language Level",
          showAll: "Show all",
          filter: "Filter",
          chooseLanguage:
            "In which language would you like to view the website?",
          popupTitle: "Would you like to start learning?",
          startLearning: "Start",
          startyFirstTitle: "Speak the world",
          levelonea: "Beginner",
          leveltwoa: "Elementary",
          levevoneb: "Intermediate",
          lebeltwob: "Upper-Intermediate",
          levelonec: "Advanced",
          leveltwoc: "Proficient",
          levelBeginnerGroup: "Beginner",
          levelIntermediateGroup: "Intermediate",
          levelAdvancedGroup: "Advanced",
          allLevelsOption: "All Levels",
          contButton: "Continue",
          pojasn: "Explanation",
          pruklad: "Example of use",
          showMore: "Show More",
          showLess: "Show Less",
          searchPlaceholder: "Enter video title",
          videoNotFound: 'Video with the title "" not found',
          noVideosForFilters: "No videos found for selected filters",
          allVideos: "All Videos",
          grammar: {
            verb: "Verb",
            infinitive: "Infinitive",
            thirdPersonSingular: "Third person singular",
            pastTense: "Past tense",
            pastParticiple: "Past participle",

            adjective: "Adjective",
            adverb: "Adverb",
            comparative: "Comparative",
            superlative: "Superlative",

            pronoun: "Pronoun",
            reflexiveForm: "Reflexive form",
            objectForm: "Object form",
            possessiveForm: "Possessive form",

            determiner: "Determiner",
            singular: "Singular",
            plural: "Plural",

            number: "Number",

            abbreviation: "Abbreviation",
            fullForm: "Full form",
            yes: "yes",
            no: "no",
          },
          "English": "English",
          "Polski": "Polski",
          "Українська": "Ukrainian",
          "Polish": "Polish",
          "Ukrainian": "Ukrainian",
          "My learning": "My learning",
          "All Videos": "All Videos",
          "All videos": "All videos",
          "Words learned": "Words learned",
          "Videos completed": "Videos completed",
          "Questions answered correctly": "Questions answered correctly",
          "Dialogues role played successfully": "Dialogues role played successfully",
          "All My Videos": "All My Videos",
          "In Progress": "In progress",
          "Completed": "Completed",
          "❤️ Favorites": "❤️ Favorites",
          "Favorites": "Favorites",
          "words": "words",
          "word": "word",
          "Total Words": "Total Words",
          "Words in Dictionary": "Words in dictionary",
          "Watch Video": "Watch Video",
          "Watch the full lesson video": "Watch the full lesson video",
          "Study Words": "Study Words",
          "Learn vocabulary in context": "Learn vocabulary in context",
          "Check Understanding": "Check Understanding",
          "Check your understanding": "Check your understanding",
          "Test your comprehension": "Test your comprehension",
          "Practice Dialogues": "Practice Dialogues",
          "Real-life conversations": "Real-life conversations",
          "Common Mistakes": "Common Mistakes",
          "Example": "Example",
          "Log Out": "Log Out",
          "Log In": "Log in",
          "days remaining": "days remaining",
          "Welcome back": "Welcome back",
          "Language level": "Language level",
          "Travel": "Travel",
          "Education": "Education",
          "Work": "Work",
          "Health": "Health",
          "News & Technology": "News & Technology",
          "Leisure": "Leisure",
          "Daily Life": "Daily Life",
          "Beginner": "Beginner",
          "Elementary": "Elementary",
          "Intermediate": "Intermediate",
          "Upper-Intermediate": "Upper-Intermediate",
          "Advanced": "Advanced",
          "Proficiency": "Proficiency",
          "INF": "INF",
          "V2": "V2",
          "V3": "V3",
          "3 SG": "3 SG",
          "SG": "SG",
          "PL": "PL",
          "BASE": "BASE",
          "COMP": "COMP",
          "SUP": "SUP",
          "REFL": "REFL",
          "OBJ": "OBJ",
          "POSS": "POSS",
          "FULL": "FULL",
          "Master Your English!": "Master Your English!",
          "Start Testing": "Start Testing",
          "Choose your challenge:": "Choose your challenge:",
          "Yes/No Questions": "Yes/No Questions",
          "Watch Video": "Watch Video",
          "Learn Words": "Learn Words",
          "understanding2": 'Check Understanding',
          "practiceDialogues2": "Practice Dialogues",
          "Immerse yourself in authentic content featuring real-life videos with practical, everyday vocabulary you'll actually use.": "Immerse yourself in authentic content featuring real-life videos with practical, everyday vocabulary you'll actually use.",
          "Focus your energy efficiently by studying only the words from videos that are new to you, maximizing your learning time.": "Focus your energy efficiently by studying only the words from videos that are new to you, maximizing your learning time.",
          "Assess your comprehension through interactive questions, voice-based answers, and targeted review of new vocabulary.": "Assess your comprehension through interactive questions, voice-based answers, and targeted review of new vocabulary.",
          "Apply your knowledge in realistic conversations based on the videos you've watched, building confidence for real-world interactions.": "Apply your knowledge in realistic conversations based on the videos you've watched, building confidence for real-world interactions.",
          "Text/Voice Response": "Text/Voice Response",
          "Drag & Drop": "Drag & Drop",
          "Attempts": "Attempts",
          "attempts": "attempts",
          "Click any question to jump directly to it!": "Click any question to jump directly to it!",
          "View Results": "View Results",
          "Question": "Question",
          "Hint": "Hint",
          "Next Question": "Next Question",
          "Finish Test": "Finish Test",
          "Please select at least one test type!": "Please select at least one test type!",
          "No questions available!": "No questions available!",
          "Loading questions...": "Loading questions...",
          "This may take 5-10 seconds for new content": "This may take 5-10 seconds for new content",
          "of": "of",
          "of": "of",
          "Select your answer – it will be checked automatically": "Select your answer – it will be checked automatically",
          "YES": "YES",
          "NO": "NO",
          "Correct": "Correct",
          "Partial": "Partial",
          "Partially Correct": "Partially Correct",
          "Incorrect": "Incorrect",
          "Next Question": "Next Question",
          "Answer by Text or Voice": "Answer by Text or Voice",
          "Type your answer below or click the microphone to record your voice": "Type your answer below or click the microphone to record your voice",
          "Type your answer here…": "Type your answer here…",
          "Ready": "Ready",
          "Answered": "Answered",
          "Check Answer": "Check Answer",
          "Recording...": "Recording...",
          "Your answer:": "Your answer:",
          "Drag the words to complete the sentence:": "Drag the words to complete the sentence:",
          "Your answer will be checked automatically when all gaps are filled": "Your answer will be checked automatically when all gaps are filled",
          "Try Again": "Try Again",
          "Scroll down to see your detailed error analysis": "Scroll down to see your detailed error analysis",
          "Outstanding!": "Outstanding!",
          "Keep Growing!": "Keep Growing!",
          "Great Job!": "Great Job!",
          "Good Effort!": "Good Effort!",
          "Error Analysis": "Error Analysis",
          "Understanding your mistakes helps you learn better": "Understanding your mistakes helps you learn better",
          "Key Areas for Improvement": "Key Areas for Improvement",
          "Incorrect Answers": "Incorrect Answers",
          "Partially Correct Answers": "Partially Correct Answers",
          "Correct answer:": "Correct answer:",
          "You've mastered this material! Your understanding is exceptional.": "You've mastered this material! Your understanding is exceptional.",
          "Every expert was once a beginner. Keep practicing and you'll get there!": "Every expert was once a beginner. Keep practicing and you'll get there!",
          "You've completed your": "You've completed your",
          "You're doing really well! Keep up the excellent work.": "You're doing really well! Keep up the excellent work.",
          "You're making progress! A little more practice will help you improve.": "You're making progress! A little more practice will help you improve.",
          "Focus on careful reading - multiple Yes/No questions were missed. Pay attention to keywords like 'not', 'only', or 'all'.": "Focus on careful reading - multiple Yes/No questions were missed. Pay attention to keywords like 'not', 'only', or 'all'.",
          "Practice word order and grammar structures - drag & drop questions show gaps in understanding sentence construction.": "Practice word order and grammar structures - drag & drop questions show gaps in understanding sentence construction.",
          "Work on expressing complete thoughts - text/voice answers need more detail and accuracy.": "Work on expressing complete thoughts - text/voice answers need more detail and accuracy.",
          "Consider reviewing the material more thoroughly before attempting again. Take notes on key concepts.": "Consider reviewing the material more thoroughly before attempting again. Take notes on key concepts.",
          "You're showing good understanding but need to refine some details. Focus on the specific areas mentioned above.": "You're showing good understanding but need to refine some details. Focus on the specific areas mentioned above.",
          "No answer": "No answer",
          "No answer provided": "No answer provided",
          "N/A": "N/A",
          "See explanation": "See explanation",
          "Review Your Answer": "Review Your Answer",
          "See your answer and the explanation for this question": "See your answer and the explanation for this question",
          "← Back to Results": "← Back to Results",
          "Review Mode": "Review Mode",
          "Review all your answers and explanations": "Review all your answers and explanations",
          "Previous": "Previous",
          "Next": "Next",
          "Next2": "Next",
          "Please provide an answer!": "Please provide an answer!",
          "Microphone access denied. Please type your answer.": "Microphone access denied. Please type your answer.",
          "Mic denied": "Mic denied",
          "Voice recording saved": "Voice recording saved",
          "Failed to submit your recording. Please try again.": "Failed to submit your recording. Please try again.",
          "Failed to play recording": "Failed to play recording",
          "Voice recording transcribed": "Voice recording transcribed",
          "Voice recording submitted": "Voice recording submitted",
          "Processing...": "Processing...",
          "Stopping in": "Stopping in",
          "Welcome to Dialogue Studio!": "Welcome to Dialogue Studio!",
          "firstPopDes": "Let's practice your English speaking skills. You'll need to use 5 target vocabulary words in our conversation.",
          "Yes, I'm Ready!": "Yes, I'm Ready!",
          "FINISH SESSION": "FINISH SESSION",
          "Word Treasury": "Word Treasury",
          "YOUR PROGRESS": "YOUR PROGRESS",
          "Words Used": "Words Used",
          "PRESS TO SPEAK": "PRESS TO SPEAK",
          "Listening to you...": "Listening to you...",
          "I don't understand the question": "I don't understand the question",
          "I can't answer": "I can't answer",
          "Time Invested": "Time Invested",
          "Time Spent": "Time Spent",
          "Welcome to your": "Welcome to your",
          "restFirstMessageT": "dialogue practice! I'm excited to explore this topic with you. Try using the 5 vocabulary words shown on the right.",
          "Exchanges": "Exchanges",
          "Words Mastered": "Words Mastered",
          "Brilliant Session!": "Brilliant Session!",
          "You've created something beautiful with words today": "You've created something beautiful with words today",
          "Your Achievements": "Your Achievements",
          "Perfect! You used all 5 vocabulary words brilliantly!": "Perfect! You used all 5 vocabulary words brilliantly!",
          "New Adventure": "New Adventure",
          "Exit": "Exit",
          "Welcome Back!": "Welcome Back!",
          "You have an unfinished dialogue session for": "You have an unfinished dialogue session for",
          "You've used": "You've used",
          "out of 5 vocabulary words.": "out of 5 vocabulary words.",
          "Continue Session": "Continue Session",
          "Start Over": "Start Over",
          "In which language would you like to view the website?": "In which language would you like to view the website?",
          "Take the test — get a program personalized to your goal and level": "Take the test — get a program personalized to your goal and level",
          "It will take less than 1 minute": "It will take less than 1 minute",
          "Quick & Easy": "Quick & Easy",
          "Step 1 of 2": "Step 1 of 2",
          "Step 2 of 2": "Step 2 of 2",
          "What is your current English level?": "What is your current English level?",
          "What's your main goal with English?": "What's your main goal with English?",
          "Great! We've prepared your personalized learning path": "Great! We've prepared your personalized learning path",
          "Finish test": "Finish test",
          "English Learning Journey": "English Learning Journey",
          "Lower Level": "Lower Level",
          "Add Plan": "Add Plan",
          "Raise Level": "Raise Level",
          "Learning Progress": "Learning Progress",
          "Current Level": "Current Level",
          "Basics": "Basics",
          "Conversations": "Conversations",
          "Introduction": "Introduction",
          "Greetings": "Greetings",
          "Practice": "Practice",
          "Daily Talk": "Daily Talk",
          "Questions": "Questions",
          "Social": "Social",
          "Business": "Business",
          "Emails": "Emails",
          "Meetings": "Meetings",
          "Airport": "Airport",
          "Hotels": "Hotels",
          "Dining": "Dining",
          "Grammar": "Grammar",
          "Idioms": "Idioms",
          "Fluency": "Fluency",
          "I want to choose the video myself": "I want to choose the video myself",
          "Continue Learning": "Continue Learning",
          "TRY 2-MIN DEMO": "TRY 2-MIN DEMO",
          "WHY CHOOSE AI LINGUA?": "WHY CHOOSE AI LINGUA?",
          "REAL-LIFE VIDEOS": "REAL-LIFE VIDEOS",
          "AI-POWERED PRACTICE": "AI-POWERED PRACTICE",
          "ALL LEVELS WELCOME": "ALL LEVELS WELCOME",
          // Level descriptions
          "Preparatory course. Ideal for beginners": "Preparatory course. Ideal for beginners",
          "I am starting to learn English.": "I am starting to learn English.",
          "I already know some words": "I already know some words",
          "I can already speak a little": "I can already speak a little",
          "I confidently speak on various topics": "I confidently speak on various topics",
          "I can discuss various topics in detail": "I can discuss various topics in detail",
          "Enter your credentials to access your account": "Enter your credentials to access your account",
          "coming soon": "coming soon",
          "Login successful": "Login successful",
          "Login failed": "Login failed",
          "Create your account to get started": "Create your account to get started",
          "Plans that fit your needs": "Plans that fit your needs",
          "Simple, scalable pricing that grows with you.": "Simple, scalable pricing that grows with you.",
          "Free": "Free",
          "Get Started": "Get Started",
          "Free for everyone": "Free for everyone",
          "Watch learning videos": "Watch learning videos",
          "Add words to personal vocabulary": "Add words to personal vocabulary",
          "Study & review words": "Study & review words",
          "Video comprehension checks": "Video comprehension checks",
          "AI voice dialogues": "AI voice dialogues",
          "Certificate upon completion": "Certificate upon completion",
          "Priority support": "Priority support",
          "Cancel & Refund Policy": "Cancel & Refund Policy",
          "Pro": "Pro",
          "Popular": "Popular",
          "Pricing": "Pricing",
          "AI voice dialogues — 10 per day": "AI voice dialogues — 10 per day",
          "Unlimited AI voice dialogues": "Unlimited AI voice dialogues",
          "All Pro features included": "All Pro features included",
          "Per-user progress reports": "Per-user progress reports",
          "Training reminders for learners": "Training reminders for learners",
          "Custom branding options": "Custom branding options",
          "Dedicated account manager": "Dedicated account manager",
          "Volume discounts available": "Volume discounts available",
          "API access & integrations": "API access & integrations",
          "All rights reserved": "All rights reserved",
          "Terms of Use": "Terms of Use",
          "Privacy Policy": "Privacy Policy",
          "Cookie Settings": "Cookie Settings",
          "Terms of Use2": "Terms of Use",
          "Last updated": "Last updated",
          "temrs1Text": "AI Lingua is an online platform for learning English (video lessons, dictionary, comprehension tests, and AI-powered dialogue practice). Access is provided in digital form only; no physical goods are supplied.",
          "terms2": "Payments are processed by Paddle.com; invoices/receipts and applicable taxes are administered by Paddle.",
          "terms3": "Service owner: Sole Proprietor Alona Oleksandrivna Korchynska (FOP Korchynska Alona Oleksandrivna)",
          "terms4": "| Jurisdiction: Ukraine",
          "terms5": "Postal address: Starokostiantyniv, Khmelnytskyi Oblast, 31100, Ukraine",
          "terms6": "The minimum user age is 13; individuals under 13 may not use the Service. If you reside in an EU/EEA country or the United Kingdom and you are under 16, verified parental/guardian consent is required (if the law of your country allows a lower age of consent, we will honor that). You are responsible for keeping your login credentials confidential and not sharing access with third parties.",
          "terms7": "Paddle.com Acting as Merchant of Record.",
          "terms8": "Payments are accepted and invoices/receipts are issued by Paddle.com as the seller/merchant of record, including the calculation and collection of applicable taxes/VAT. Plans and prices are published on the pricing page and may change with prior notice where they affect future billing periods. Subscriptions renew automatically unless cancelled in your account dashboard (auto‑renewal is disabled upon cancellation; access continues until the end of the already‑paid period).",
          "terms9": "The trial period is 7 days. If you purchase a subscription during the trial, paid access begins immediately while the trial continues until the end of the 7 days (overall access is not doubled). A free version with limited functionality is available.",
          "terms10": "Refunds after subscription payment are not provided, including partial/prorated amounts, except where required by mandatory applicable law or under our exceptions policy.",
          "terms11": "Prohibited: violations of law; aggressive, discriminatory, or harmful content; attempts at unauthorized access, interference with the Service, or reverse engineering; automated mass data collection; payment fraud; account sharing by multiple individuals; uploading or inputting materials that infringe third‑party IP rights. Accounts that violate these Terms may be restricted or closed after notice where reasonably possible.",
          "terms12": "Service materials (including videos, tests, software code, design, texts) are protected by intellectual property rights. We grant you a limited, non‑exclusive, non‑transferable license to use the Service for personal, non‑commercial purposes. Content uploaded by users remains their property; users grant the Service a limited license to use such content for the purposes of providing and improving the Service.",
          "terms13": "We engage third‑party providers (hosting, analytics, and LLM models for AI dialogues). Data is processed solely to provide, support, and improve the Service. We do not use your content to train providers' general models unless we explicitly state otherwise and obtain your consent. The list of key providers and server locations is set out in the Privacy Policy.",
          "terms14": "We may update features, prices, and terms. We provide at least 7 days' notice (email/in‑account banner) of material changes that affect payment or access. Continued use after the effective date constitutes acceptance of the updated terms.",
          "terms15": "We may suspend or terminate a user's access in case of a breach of these Terms or for security/legal reasons, with reasonable notice where possible. Upon termination, you may export your data within 30 days (except where legal restrictions apply).",
          "terms16": "The Service is provided \"as is\" and \"as available.\" To the extent permitted by law, no implied warranties of fitness or suitability for a particular purpose are provided. The Service owner's aggregate liability to a user is limited to the amounts paid by that user in the last 12 months.",
          "terms17": "These Terms are governed by the laws of Ukraine; disputes are subject to the competent courts of Ukraine unless mandatory norms provide otherwise.",
          "terms18": "Questions regarding the Service and billing (including subscription cancellation):",
          "About Us": "About Us",
          "Accounts and Age": "Accounts and Age",
          "Subscriptions, Pricing, and Billing": "Subscriptions, Pricing, and Billing",
          "Trial Period and Free Version": "Trial Period and Free Version",
          "Refunds": "Refunds",
          "Acceptable Use": "Acceptable Use",
          "Intellectual Property Rights": "Intellectual Property Rights",
          "Third-Party Technologies and AI": "Third-Party Technologies and AI",
          "Service Availability and Changes": "Service Availability and Changes to the Service and Prices",
          "Termination of Access": "Termination of Access",
          "Warranty Disclaimer": "Warranty Disclaimer and Limitation of Liability",
          "Governing Law and Contact": "Governing Law, Jurisdiction, and Contact",
          "October": "October",
          "Who We Are": "Who We Are",
          "privacy1": "Sole Proprietor Alona Oleksandrivna Korchynska is the data controller for AI Lingua. Contacts:",
          "Data We Process": "Data We Process",
          "privacy2": "email, password (hashed), name/pseudonym.",
          "privacy3": "progress, test results, settings, activity logs.",
          "privacy4": "processed by Paddle.com (we receive transaction/subscription status and Order ID; we do not store full card details).",
          "privacy5": "cookies/telemetry for site operation, security, and analytics.",
          "Purposes": "Purposes",
          "privacy6": "Providing the Service, billing, support, security, analytics/improvements, compliance with legal obligations.",
          "Legal Bases": "Legal Bases",
          "privacy7": "Performance of a contract; legitimate interests; consent (where required); legal obligation.",
          "Data Sharing": "Data Sharing",
          "privacy8": "With infrastructure/analytics providers and Paddle.com — subject to appropriate safeguards.",
          "privacy8.1": "With infrastructure/analytics providers and",
          "privacy8.2": "— subject to appropriate safeguards.",
          "Retention": "Retention",
          "privacy9": "For as long as the account is active; specific records may be retained longer where required by law (e.g., financial reporting).",
          "Data Subject Rights": "Data Subject Rights",
          "privacy10": "Send requests for access/erasure/portability/objection to ailinguaservice@gmail.com. We respond within 30 days. You also have the right to lodge a complaint with the Ukrainian Parliament Commissioner for Human Rights (Ombudsman) or the supervisory authority in your country of residence.",
          "International Transfers": "International Transfers",
          "privacy11": "When we transfer data outside Ukraine/the EU, we use Standard Contractual Clauses (SCCs) or other appropriate safeguards. The list of main providers and processing countries is provided in the relevant section/appendix.",
          "Cookies": "Cookies",
          "privacy12": "We use necessary cookies for site operation and analytics/marketing cookies only with your consent. You can change your choice at any time in the consent banner.",
          "Account": "Account",
          "Learning": "Learning",
          "Payments": "Payments",
          "Technical": "Technical",
          "Cancellation and Refund Policy": "Cancellation and Refund Policy",
          "refund1": "7 days. If a subscription is purchased during the trial, trial access continues until the end of the 7 days.",
          "refund2": "charged via Paddle; the subscription auto‑renews until cancelled.",
          "refund3": "at any time in your dashboard/through Paddle; after cancellation, access remains until the end of the already‑paid period.",
          "refund4": "not provided after subscription payment (including partial/prorated amounts), except where required by applicable law.",
          "refund5": "Billing/cancellation contact:",
          "Trial period:": "Trial period:",
          "Payment and auto-renewal:": "Payment and auto‑renewal:",
          "CNCL": "Cancellation:",
          "RFND": "Refunds:",
          "app-header-text": "Now we’ll practice the dialogue from the video. We’ll speak just like in the clip: the same words and the same topic. Let’s begin.",
          "Try saying it like this:": "Try saying it like this:",
          "Keep practicing!": "Keep practicing!",
          "Not bad!": "Not bad!",
          "Good job!": "Good job!",
          "Excellent result!": "Excellent result!",
          "Skip": "Skip",
          "Take a break and review!": "Take a break and review!",
          "You\'ve tried five times already - that\'s great persistence! But it seems like it would be worth refreshing the material so the dialogue goes easier.": "You\'ve tried five times already - that\'s great persistence! But it seems like it would be worth refreshing the material so the dialogue goes easier.",
          "Mistakes are part of learning": "Mistakes are part of learning",
          "Nothing scary, it happens!": "Nothing scary, it happens!",
          "It seems difficult to answer by voice for now. Let\'s first review the material again - after that it will be much easier!": "It seems difficult to answer by voice for now. Let\'s first review the material again - after that it will be much easier!",
          "One step back is two steps forward": "One step back is two steps forward",
          "We recommend returning to:": "We recommend returning to:",
          "Learn Words2": "Learn Words",
          "Review key words and phrases from the lesson": "Review key words and phrases from the lesson",
          "Watch Video2": "Watch Video",
          "Watch the dialogue again with subtitles": "Watch the dialogue again with subtitles",
          "I want to continue the dialogue": "I want to continue the dialogue",
          "Lesson completed": "Lesson completed",
          "Great! Lesson": "Great! Lesson",
          "completed!": "completed!",
          "You\'ve completed the dialogue practice for this video. You can now move on to the next lesson or review this one again.": "You\'ve completed the dialogue practice for this video. You can now move on to the next lesson or review this one again.",
          "Repeat Lesson": "Repeat Lesson",
          "Next Lesson": "Next Lesson",
          "Almost there!": "Almost there!",
          "Don't be sad": "Don't be sad",
          "Every attempt": "Every attempt",
          "is a step forward": "is a step forward",
          "This time the lesson": "This time the lesson",
          "was not completed — but that's okay. Mistakes are part of learning. Repeat the lesson or move on: your choice!": "This time the lesson was not completed — but that's okay. Mistakes are part of learning. Repeat the lesson or move on: your choice!",
          "Awesome plan for you": "Awesome plan for you",
          "Access to 30 video pack": "Access to 30 video pack",
          "Subscriptions": "Subscriptions",
          "Sign in to manage your subscription": "Sign in to manage your subscription",
          "Please log in to view and manage your subscription details, billing information, and account settings.": " Please log in to view and manage your subscription details, billing information, and account settings.",
          "You can manage your billing information and subscription here": "You can manage your billing information and subscription here",
          "You're on the": "You're on the",
          "plan": "plan",
          "Next renewal:": "Next renewal:",
          "Plan cost": "Plan cost:",
          "Status": "Status",
          "Auto-renewal": "Auto-renewal",
          "Cancel Subscription": "Cancel Subscription",
          "Upgrade your plan": "Upgrade your plan",
          "Processing payment": "Processing payment",
          "We are waiting for confirmation from the payment provider...": "We are waiting for confirmation from the payment provider...",
          "Your subscription plan": "Your subscription plan",
          "Activation progress": "Activation progress",
          "Do not close this page - we will notify you immediately": "Do not close this page - we will notify you immediately",
          "Successfully activated!": "Successfully activated!",
          "Your subscription plan": "Your subscription plan",
          "Do not waste time - let's learn together! All features of the plan": "Do not waste time - let's learn together! All features of the plan",
          "are already available in your account.": "are already available in your account.",
          "Thank you for trusting AI Lingua!": "Thank you for trusting AI Lingua!",
          "Subscription": "Subscription",
          "Tel": "Tel",
          "Custom Pricing": "Custom Pricing",
          "Стандарт": "Standard",
          "Premium": "Premium",
          "Contact Us": "Contact Us",
          "After registration, you'll get your personalized course and be able to track your progress.": "After registration, you'll get your personalized course and be able to track your progress.",
          "Start your language learning journey with AI-powered lessons tailored just for you!": "Start your language learning journey with AI-powered lessons tailored just for you!",
          "Welcome Back, aliona!": "Welcome Back, aliona!",
          "Let's continue studying together": "Let's continue studying together",
          "Learned Words": "Learned Words",
          "Completed Videos": "Completed Videos",
          "Correct Answers": "Correct Answers",
          "Successful Dialogues": "Successful Dialogues",
          "My Courses": "My Courses",
          "View all courses": "View all courses",
          "Business English": "Business English",
          "Intermediate": "Intermediate",
          "24 lessons": "24 lessons",
          "Progress": "Progress",
          "lessons done": "lessons done",
          "lessons left": "lessons left",
          "Conversational English": "Conversational English",
          "30 lessons": "30 lessons",
          "Travel English": "Travel English",
          "15 lessons": "15 lessons",
          "My Videos": "My Videos",
          "View all": "View all",
          "Name": "Name",
          "Email": "Email",
          "Phone": "Phone",
          "Message": "Message",
          "Submit": "Submit",
          "Please fill in all the fields!": "Please fill in all the fields!",
          "Completed Dialogs": "Completed Dialogs",
          "Введіть коректну адресу електронної пошти.": "Please enter a valid email address.",
          "The email address and/or password you specified are not correct.": "The email address and/or password you specified are not correct.",
          "Choose a username": "Choose a username",
          "Це поле обов'язкове.": "This field is required.",
          "A user is already registered with this email address.": "A user is already registered with this email address.",
          "Register to save your progress": "Register to save your progress",
          "Register": "Register",
          "Previous Lesson": "Previous Lesson",
          "Lesson Completed": "Lesson Completed",
          "Lesson Not Completed": "Lesson Not Completed",
          "Email must contain @": "Email must contain @",
          "Email must contain . (dot)": "Email must contain . (dot)",
          "Invalid email format (example@domain.com)": "Invalid email format (example@domain.com)",
          "At least 8 characters": "At least 8 characters",
          "Must contain letters": "Must contain letters",
          "Must contain numbers": "Must contain numbers",
          "Connecting...": "Connecting...",
          "Please wait while we establish the connection.": "Please wait while we establish the connection.",
          "Home": "Home",
          "Got it": "Got it",
          "Demo Limit Reached": "Demo Limit Reached",
          "Demo limit reached (5/5 dialogs today). Please register to continue.": "Demo limit reached (5/5 dialogs today). Please register to continue.",
          "Loading subscription details...": "Loading subscription details...",
          "No videos found": "No videos found",
          "AI-powered English platform": "AI-powered English platform",
          "Learn English with": "Learn English with",
          "real-life videos": "real-life videos",
          "and AI practice": "and AI practice",
          "Choose a short lesson, create a personal plan, or learn at your own pace.": "Choose a short lesson, create a personal plan, or learn at your own pace.",
          "Video": "Video",
          "Words": "Words",
          "Quiz": "Quiz",
          "Speaking": "Speaking",
          "Comprehension": "Comprehension",
          "Dialogues": "Dialogues",
          "Choose how to start learning": "Choose how to start learning",
          "2 minutes · No registration": "2 minutes · No registration",
          "Try a 2-minute lesson": "Try a 2-minute lesson",
          "Take a short real-life lesson and see how AI Lingua works — with no commitment.": "Take a short real-life lesson and see how AI Lingua works — with no commitment.",
          "Start quick lesson": "Start quick lesson",
          "Recommended": "Recommended",
          "Get a personal plan": "Get a personal plan",
          "Answer a few questions about your goal and level to receive a structured course created specifically for you.": "Answer a few questions about your goal and level to receive a structured course created specifically for you.",
          "Create my plan": "Create my plan",
          "Learn without a plan": "Learn without a plan",
          "Browse videos and choose topics to practice. Learn at a time that suits you.": "Browse videos and choose topics to practice. Learn at a time that suits you.",
          "Browse videos": "Browse videos",
          "Two ways to learn": "Two ways to learn",
          "Both paths include real-life video lessons and AI speaking practice.": "Both paths include real-life video lessons and AI speaking practice.",
          "Personal Plan": "Personal Plan",
          "Structured lessons in a clear order": "Structured lessons in a clear order",
          "Course based on your goal & level": "Course based on your goal & level",
          "Level test available if you need it": "Level test available if you need it",
          "Track your progress over time": "Track your progress over time",
          "Switch": "Switch",
          "anytime": "anytime",
          "Learn Without a Plan": "Learn Without a Plan",
          "Choose any video you like": "Choose any video you like",
          "Practice any topic freely": "Practice any topic freely",
          "No fixed order or schedule": "No fixed order or schedule",
          "Switch to a personal plan anytime": "Switch to a personal plan anytime",
          "What happens after the 2-minute lesson?": "What happens after the 2-minute lesson?",
          "Complete a quick demo, then choose your path forward.": "Complete a quick demo, then choose your path forward.",
          "Try quick lesson": "Try quick lesson",
          "2 minutes": "2 minutes",
          "Continue learning on my own": "Continue learning on my own",
          "Back to Home": "Back to Home",
          "Trial Lesson": "Trial Lesson",
          "Trial 2-minute lesson": "Trial 2-minute lesson",
          "Step": "Step",
          "of": "of",
          "What to do now": "What to do now",
          "Watch the video": "Watch the video",
          'Watch the short dialogue, then click "Next: words" to continue.': 'Watch the short dialogue, then click "Next: words" to continue.',
          "Study the words": "Study the words",
          'Learn new words from the video. Then click "Next".': 'Learn new words from the video. Then click "Next".',
          "Далі": "Next",
          "Check Understanding": "Check Understanding",
          'Check your understanding. Then click "Next".': 'Check your understanding. Then click "Next".',
          "Practice Dialogue": "Practice dialogue",
          "Practice dialogue": "Practice dialogue",
          "Practice the dialogue": "Practice the dialogue",
          "Talk to AI in English. This is the last step of the trial lesson!": "Talk to AI in English. This is the last step of the trial lesson!",
          "Далі: слова": "Next: words",
          "Після перегляду переходьте до слів": "After viewing, move on to the words",
          "Lesson steps": "Lesson steps",
          "Watch a short real-life dialogue in English.": "Watch a short real-life dialogue in English.",
          "Current Step": "Current Step",
          "Learn new words and phrases from videos in context.": "Learn new words and phrases from videos in context.",
          "Take a short test to check what you remember.": "Take a short test to check what you remember.",
          "Talk to AI in English in a real dialogue.": "Talk to AI in English in a real dialogue.",
          "Next: Quiz": "Next: Quiz",
          "Next: Words": "Next: Words",
          "Next: Speaking": "Next: Speaking",
          "Save progress": "Save progress",
          "Practice dialogue": "Practice dialogue",
          "My dictionary": "My dictionary",
          "Add words from the lesson and review them.": "Add words from the lesson and review them.",
          "Open": "Open",
          "Video transcript": "Video transcript",
          "Click an underlined word to see its translation and an example, and add it to your dictionary.": "Click an underlined word to see its translation and an example, and add it to your dictionary.",
          "from this lesson": "from this lesson",
          "from the entire course": "from the entire course",
          "No results found": "No results found",
          "Try another word or change the filter.": "Try another word or change the filter.",
          "Search for a word...": "Search for a word...",
          "Words you added during lessons.": "Words you added during lessons.",
          "Back to transcript": "Back to transcript",
          "All from course": "All from course",
          "From this lesson": "From this lesson",
          "All self-study words": "All self-study words",
          "From this video": "From this video",
          "Click the bookmark to save the word": "Click the bookmark to save the word",
          "In dictionary": "In dictionary",
          "No transcript available for this lesson.": "No transcript available for this lesson.",
          "Translation not available": "Translation not available",
          "Example not available": "Example not available",
          "Explanation not available": "Explanation not available",
          "Error fetching data": "Error fetching data",
          "Translation": "Translation",
          "Listen to word": "Listen to word",
          "Remove from dictionary": "Remove from dictionary",
          "Add to dictionary": "Add to dictionary",
          "Close": "Close",
          "Translation language": "Translation language",
          "Current lesson": "Current lesson",
          "Another lesson": "Another lesson",
          "CSRF token is missing": "CSRF token is missing",
          "Failed to receive data": "Failed to receive data",
          "Failed to update favorite status. Please try again.": "Failed to update favorite status. Please try again.",
          "Search words in section": "Search words in section",
          "Loading...": "Loading...",
          "How does AI Lingua work?": "How does AI Lingua work?",
          "Save progress?": "Save progress?",
          "In the full course, each lesson has the same structure: Video → Words → Quiz → Speaking.": "In the full course, each lesson has the same structure: Video → Words → Quiz → Speaking.",
          "Register so you don't lose your result.": "Register so you don't lose your result.",
          "Success": "Success",
          "You have successfully logged out.": "You have successfully logged out.",
          "Notice": "Notice",
          "Session has already ended or is invalid.": "Session has already ended or is invalid.",
          "Error": "Error",
          "Failed to log out.": "Failed to log out.",
          "An error occurred during logout.": "An error occurred during logout.",
          "Failed to add word to vocabulary": "Failed to add word to vocabulary",
          "Failed to remove word from vocabulary": "Failed to remove word from vocabulary",
          "Change level: higher": "Change level: higher",
          "Change level: lower": "Change level: lower",
          "Change learning topic": "Change learning topic",
          "Study with tutor": "Study with tutor",
          "Soon": "Soon",
          "Active": "Active",
          "Cancel": "Cancel",
          "Upgrade": "Upgrade",
          "Активна": "Active",
          "Fill in the blanks question": "Fill in the blanks question",
          "You were on the right track but needed more precision.": "You were on the right track but needed more precision.",
          "Choose the correct meaning of the word.": "Choose the correct meaning of the word.",
          "Profile updated successfully": "Profile updated successfully",
          "Error saving profile": "Error saving profile",
          "Please fill in all fields": "Please fill in all fields",
          "Passwords do not match": "Passwords do not match",
          "Password must be at least 8 characters": "Password must be at least 8 characters",
          "Password changed successfully": "Password changed successfully",
          "Error changing password": "Error changing password",
          "My profile": "My profile",
          "Subscription": "Subscription",
          "Support": "Support",
          "Log Out": "Log Out",
          "Personal cabinet": "Personal cabinet",
          "Manage your profile, subscription and support requests": "Manage your profile, subscription and support requests",
          "Name": "Name",
          "Interface language": "Interface language",
          "English level": "English level",
          "Edit profile": "Edit profile",
          "Change password": "Change password",
          "No active subscription": "No active subscription",
          "days remaining": "days remaining",
          "Change plan": "Change plan",
          "Get a plan": "Get a plan",
          "Write to us if you have questions about lessons, subscription or technical issues": "Write to us if you have questions about lessons, subscription or technical issues",
          "Subject": "Subject",
          "Subscription question": "Subscription question",
          "Payment issue": "Payment issue",
          "Lesson issue": "Lesson issue",
          "Technical issue": "Technical issue",
          "Other": "Other",
          "Message": "Message",
          "Describe your question or issue": "Describe your question or issue",
          "Send": "Send",
          "Thank you": "Thank you",
          "We received your request and will reply to your email": "We received your request and will reply to your email",
          "Report an issue": "Report an issue",
          "What is wrong with this video?": "What is wrong with this video?",
          "Incorrect translation": "Incorrect translation",
          "Incorrect video level": "Incorrect video level",
          "Video does not work": "Video does not work",
          "Describe the issue (optional)": "Describe the issue (optional)",
          "Thank you! We will check this video.": "Thank you! We will check this video.",
          "Update your personal details.": "Update your personal details.",
          "Email cannot be changed": "Email cannot be changed",
          "Name cannot be changed": "Name cannot be changed",
          "Cancel": "Cancel",
          "Save": "Save",
          "Saving...": "Saving...",
          "Enter your current and new password.": "Enter your current and new password.",
          "Current password": "Current password",
          "New password": "New password",
          "Repeat new password": "Repeat new password",
          "Update password": "Update password",
          "Log out of account?": "Log out of account?",
          "You can return to learning after logging in again": "You can return to learning after logging in again",
          "Continue learning from where you left off.": "Continue learning from where you left off.",
          "Enter a valid email address": "Enter a valid email address",
          "Enter your password": "Enter your password",
          "Forgot your password?": "Forgot your password?",
          "Don't have an account?": "Don't have an account?",
          "What you get after registration": "What you get after registration",
          "A course tailored to your goal and level.": "A course tailored to your goal and level.",
          "Real-life lessons": "Real-life lessons",
          "Each lesson: Video → Words → Quiz → AI Speaking.": "Each lesson: Video → Words → Quiz → AI Speaking.",
          "AI Speaking": "AI Speaking",
          "Practice real dialogues with AI.": "Practice real dialogues with AI.",
          "Personal dictionary": "Personal dictionary",
          "Save words you learn and review them anytime.": "Save words you learn and review them anytime.",
          "Learning progress": "Learning progress",
          "Track lessons, words, videos, and your learning streak.": "Track lessons, words, videos, and your learning streak.",
          "Your password": "Your password",
          'Create Account': 'Create Account',
          "Already have an account?": "Already have an account?",
          "Register to save your progress and get a personal learning plan.": "Register to save your progress and get a personal learning plan.",
          "Your name": "Your name",
          "Enter your name": "Enter your name",
          "Minimum 8 characters.": "Minimum 8 characters.",
          "Password must contain at least 8 characters": "Password must contain at least 8 characters",
          "I agree to the": "I agree to the",
          "Terms of Use": "Terms of Use",
          "Terms of Use2": "Terms of Use",
          "and": "and",
          "Privacy Policy": "Privacy Policy",
          "Privacy Policy2": "Privacy Policy",
          'You must agree to the Terms of Use and Privacy Policy': 'You must agree to the Terms of Use and Privacy Policy',
          'Creating account…': 'Creating account…',
          'Logging in…': 'Logging in…',
          "Created based on your goal and level": "Created based on your goal and level",      
          "lessons": "lessons",
          "completed": "completed",
          "hours": "hours",
          "Manage plan": "Manage plan",
          "Course completed": "Course completed",
          "Lessons completed": "Lessons completed",
          "Lessons remaining": "Lessons remaining",
          "Day streak": "Day streak",
          "Lesson": "Lesson",
          "You stopped at the step": "You stopped at the step",
          "We will return you to where you left off.": "We will return you to where you left off.",
          "Learning path": "Learning path",
          "The next lesson unlocks after you pass the previous one.": "The next lesson unlocks after you pass the previous one.",
          "Repeat": "Repeat",
          "Blocked": "Blocked",
          "Continue": "Continue",
          "You are here": "You are here",
          "Complete lesson": "Complete lesson",
          "Would you like to learn without a fixed plan?": "Would you like to learn without a fixed plan?",
          "Go to self-study": "Go to self-study",
          "Available after completing the lesson": "Available after completing the lesson",
          "Personal learning plans with level-based progress.": "Personal learning plans with level-based progress.",
          "Would you like more structure?": "Would you like more structure?",
          "A personal plan will help you complete lessons in the right order and track your progress by level.": "A personal plan will help you complete lessons in the right order and track your progress by level.",
          "Create plan": "Create plan",
          "Self-study will remain available": "Self-study will remain available",
          "Start": "Start",
          "AI says": "AI says",
          "Repeat the phrases from the video. AI will check your pronunciation and the content of your answer.": "Repeat the phrases from the video. AI will check your pronunciation and the content of your answer.",
          "Finish lesson": "Finish lesson",
          "Your answer": "Your answer",
          "Record answer": "Record answer",
          "Click to start recording": "Click to start recording",
          "Try saying:": "Try saying:",
          "Plans tailored to your needs": "Plans tailored to your needs",
          "Choose your learning plan": "Choose your learning plan",
          "Start for free, unlock full access to lessons, or choose AI Lingua for your team.": "Start for free, unlock full access to lessons, or choose AI Lingua for your team.",
          "Most popular": "Most popular",
          "For individual learning": "For individual learning",
          "UAH / month": "грн / місяць",
          "billed monthly": "billed monthly",
          "Personal learning plan": "Personal learning plan",
          "All video lessons": "All video lessons",
          "2-minute trial lesson": "2-minute trial lesson",
          "Limited access to video lessons": "Limited access to video lessons",
          "Add words to dictionary": "Add words to dictionary",
          "Basic progress saving": "Basic progress saving",
          "AI Speaking — limited": "AI Speaking — limited",
          "Personal plan — unavailable": "Personal plan — unavailable",
          "Full catalog — unavailable": "Full catalog — unavailable",
          "AI dialogue practice": "AI dialogue practice",
          "Personal dictionary": "Personal dictionary",
          "Progress saving": "Progress saving",
          "Review completed lessons": "Review completed lessons",
          "Self-study without a plan": "Self-study without a plan",
          "Saved videos and statistics": "Saved videos and statistics",
          "To try the platform": "To try the platform",
          "UAH": "UAH",
          "free forever": "free forever",
          "Start for free": "Start for free",
          "For companies, schools, and universities": "For companies, schools, and universities",
          "Custom pricing": "Custom pricing",
          "tailored to your team's needs": "tailored to your team's needs",
          "All Premium features": "All Premium features",
          "Access for a group of users": "Access for a group of users",
          "Each learner's progress": "Each learner's progress",
          "Admin reports": "Admin reports",
          "Learning tailored to company goals": "Learning tailored to company goals",
          "Dedicated manager support": "Dedicated manager support",
          "Volume discounts": "Volume discounts",
          "Contact us": "Contact us",
          "Subscribe": "Subscribe",
          "Renew subscription": "Renew subscription",
          "Plan comparison": "Plan comparison",
          "Feature": "Feature",
          "Group access": "Group access",
          "Admin reports": "Admin reports",
          "Dedicated manager support": "Dedicated manager support",
          "limited": "limited",
          "basic": "basic",
          "Frequently asked questions": "Frequently asked questions",
          "Can I start for free?": "Can I start for free?",
          "What is included in Premium?": "What is included in Premium?",
          "Can I cancel my subscription?": "Can I cancel my subscription?",
          "What is Business?": "What is Business?",
          "Will my progress be saved after changing plans?": "Will my progress be saved after changing plans?",
          "Yes. You can try the platform for free and take a trial lesson. Registration does not require payment.": "Yes. You can try the platform for free and take a trial lesson. Registration does not require payment.",
          "Premium includes a personal plan, all video lessons, AI speaking practice, a dictionary, progress saving, and detailed learning statistics.": "Premium includes a personal plan, all video lessons, AI speaking practice, a dictionary, progress saving, and detailed learning statistics.",
          "Yes. You can cancel your subscription at any time in your account. Access will remain active until the end of the paid period.": "Yes. You can cancel your subscription at any time in your account. Access will remain active until the end of the paid period.",
          "Business offers custom terms for companies, schools, and universities, including group access, reports, and dedicated manager support.": "Business offers custom terms for companies, schools, and universities, including group access, reports, and dedicated manager support.",
          "Yes. Your progress is saved in your account regardless of your plan.": "Yes. Your progress is saved in your account regardless of your plan.",
          "Choose any videos, complete lessons at your own pace, and practice speaking with AI": "Choose any videos, complete lessons at your own pace, and practice speaking with AI",
          "There is no fixed order in this mode — you choose what to learn.": "There is no fixed order in this mode — you choose what to learn.",
          "Would you like a structured learning plan?": "Would you like a structured learning plan?",
          "Get a personal plan tailored to your goal and level": "Get a personal plan tailored to your goal and level",
          "Learn with a teacher": "Learn with a teacher",
          "A teacher will help you practice words, pronunciation, and video dialogues.": "A teacher will help you practice words, pronunciation, and video dialogues.",
          "Search videos": "Search videos",
          "Level": "Level",
          "All": "All",
          "Topics": "Topics",
          "Clear filters": "Clear filters",
          "This is self-study: you choose the videos yourself. To follow a structured path, create a personal plan.": "This is self-study: you choose the videos yourself. To follow a structured path, create a personal plan.",
          "No video found. Try changing filters.": "No video found. Try changing filters.",
          "Watch a short real-life dialogue, then move on to the words.": "Watch a short real-life dialogue, then move on to the words.",
          "Add words from the lesson and review them.": "Add words from the lesson and review them.",
          'Learn new words from the video, then click "Next."': 'Learn new words from the video, then click "Next."',
          'Check your understanding, then click "Next."': 'Check your understanding, then click "Next."',
          "Speak to AI in English. This is the last step of the lesson!": "Speak to AI in English. This is the last step of the lesson!",
          "Recommended order: Video → Words → Quiz → Speaking. Complete the steps in order.": "Recommended order: Video → Words → Quiz → Speaking. Complete the steps in order.",
          "Search word...": "Search word...",
          "Take a short 10-question quiz to check what you remember from the video.": "Take a short 10-question quiz to check what you remember from the video.",
          "10 questions": "10 questions",
          "3 question types": "3 question types",
          "3–5 minutes": "3–5 minutes",
          "What the quiz includes": "What the quiz includes",
          "Word meaning": "Word meaning",
          "Choose the meaning of a word or phrase.": "Choose the meaning of a word or phrase.",
          "\"from\" means \"from\" or \"because\"": "\"from\" means \"from\" or \"because\"",
          "Fill in the blank": "Fill in the blank",
          "Fill in the missing word.": "Fill in the missing word.",
          "\"My ___ is Anna.\"": "\"My ___ is Anna.\"",
          "Build the phrase": "Build the phrase",
          "Build the English phrase from the given words.": "Build the English phrase from the given words.",
          "\"Check, please\" → Check / please / Card": "\"Check, please\" → Check / please / Card",
          "Start quiz": "Start quiz",
          "The quiz includes several question types and will take a few minutes.": "The quiz includes several question types and will take a few minutes.",
          "Choose the correct meaning of the word.": "Choose the correct meaning of the word.",
          "means": "means",
          "Choose the word that correctly completes the sentence.": "Choose the word that correctly completes the sentence.",
          "Tap the words in the correct order to build the English phrase.": "Tap the words in the correct order to build the English phrase.",
          "Your phrase": "Your phrase",
          "Tap the words below to build the phrase.": "Tap the words below to build the phrase.",
          "Words": "Words",
          "Clear": "Clear",
          "Checking...": "Checking...",
          "Check phrase": "Check phrase",
          "True / False": "True / False",
          "Determine if the statement is correct.": "Determine if the statement is correct.",
          "Open Answer": "Open Answer",
          "Answer the question.": "Answer the question.",
          "Type your answer here...": "Type your answer here...",
          "Submit answer": "Submit answer",
          "Correct!": "Correct!",
          "Not quite": "Not quite",
          "Correct answer": "Correct answer",
          "Great job!": "Great job!",
          "Try rearranging the words in a different order.": "Try rearranging the words in a different order.",
          "Try to review the video material again.": "Try to review the video material again.",
          "Finish quiz": "Finish quiz",
          "Next question": "Next question",
          "Choose an answer": "Choose an answer",
          "Review mode": "Review mode",
          "Back to current": "Back to current",
          "No questions available.": "No questions available.",
          "Replay": "Replay",
          "Slower": "Slower",
          "Translate": "Translate",
          "Save your progress!": "Save your progress!",
          "You are currently learning as a guest. Create a free account to save learned words, completed lessons, and your personal plan.": "You are currently learning as a guest. Create a free account to save learned words, completed lessons, and your personal plan.",
          "Personal account": "Personal account",
          "Personal plan": "Personal plan",
          "Progress saving": "Progress saving",
          "Register for free": "Register for free",
          "Continue as guest": "Continue as guest",
          "Creating your personal plan": "Creating your personal plan",
          "This will take less than 1 minute. Your answers will help us create the right plan.": "This will take less than 1 minute. Your answers will help us create the right plan.",
          "Step {{step}} of {{total}}": "Step {{step}} of {{total}}",
          "Which language would you like to use for the interface?": "Which language would you like to use for the interface?",
          "Choose the interface language for learning.": "Choose the interface language for learning.",
          "Back": "Back",
          "Why are you learning English?": "Why are you learning English?",
          "We will select lesson topics based on your goal.": "We will select lesson topics based on your goal.",
          "Airport, hotel, café, and meeting people abroad.": "Airport, hotel, café, and meeting people abroad.",
          "Job interviews, meetings, correspondence, and workplace dialogues.": "Job interviews, meetings, correspondence, and workplace dialogues.",
          "Educational topics, explanations, and academic vocabulary.": "Educational topics, explanations, and academic vocabulary.",
          "Socializing": "Socializing",
          "Small talk, meeting people, and everyday conversations.": "Small talk, meeting people, and everyday conversations.",
          "Everyday topics, hobbies, and light practice.": "Everyday topics, hobbies, and light practice.",
          "Choose the level to start learning.": "Choose the level to start learning.",
          "Loading levels...": "Loading levels...",
          "Failed to load levels. Please try again.": "Failed to load levels. Please try again.",
          "Not sure? Choose an approximate level — you can change it later.": "Not sure? Choose an approximate level — you can change it later.",
          "Failed to save results. Please try again.": "Failed to save results. Please try again.",
          "Your personal plan is ready": "Your personal plan is ready",
          "We created a course based on your goal and level.": "We created a course based on your goal and level.",
          "Goal": "Goal",
          "Start first lesson": "Start first lesson",
          "Change answers": "Change answers",
          "You can change the level or learning topic later in the plan settings.": "You can change the level or learning topic later in the plan settings.",
          "Study": "Study",
          "For yourself": "For yourself",
          "Create an account to save words, videos, and personal plans.": "Create an account to save words, videos, and personal plans.",
          "In the full course, every lesson follows the same structure: Video → Words → Quiz → AI Speaking.": "In the full course, every lesson follows the same structure: Video → Words → Quiz → AI Speaking.",
          "Great job! You completed the trial lesson.": "Great job! You completed the trial lesson.",
          "Now choose how you would like to continue learning.": "Now choose how you would like to continue learning.",
          "We will create a course based on your goal, level, and learning pace.": "We will create a course based on your goal, level, and learning pace.",
          "If you do not know your level, we will offer a short test while creating your plan.": "If you do not know your level, we will offer a short test while creating your plan.",
          "You can switch between these modes later.": "You can switch between these modes later.",
          "Payment successful!": "Payment successful!",
          "Your Premium plan has been activated. All AI Lingua features are now available.": "Your Premium plan has been activated. All AI Lingua features are now available.",
          "Subscription details": "Subscription details",
          "Plan": "Plan",
          "Active": "Active",
          "Amount": "Amount",
          "299 UAH / month": "299 UAH / month",
          "Next charge": "Next charge",
          "Payment method": "Payment method",
          "Account2": "Account",
          "Manage": "Manage",
          "How would you like to start learning?": "How would you like to start learning?",
          "Choose a convenient format: a personal plan or self-study with videos.": "Choose a convenient format: a personal plan or self-study with videos.",
          "Recommended": "Recommended",
          "Get a personal plan": "Get a personal plan",
          "Create a course based on your goal and level. We will select the lessons and their order.": "Create a course based on your goal and level. We will select the lessons and their order.",
          "This will take less than 1 minute": "This will take less than 1 minute",
          "Create my plan": "Create my plan",
          "Learn without a plan": "Learn without a plan",
          "Choose any videos and practice at your own pace without a fixed order.": "Choose any videos and practice at your own pace without a fixed order.",
          "You can create a plan later at any time.": "You can create a plan later at any time.",
          "Go to all videos": "Go to all videos",
          "You can switch between these modes at any time.": "You can switch between these modes at any time.",
          "What is available now": "What is available now",
          "Personal plan": "Personal plan",
          "A course based on your goal and level.": "A course based on your goal and level.",
          "All video lessons": "All video lessons",
          "Full video catalog without limits.": "Full video catalog without limits.",
          "Practice dialogues with AI.": "Practice dialogues with AI.",
          "Personal dictionary": "Personal dictionary",
          "Save words and review them.": "Save words and review them.",
          "Learning progress": "Learning progress",
          "Lessons, words, videos, and streak.": "Lessons, words, videos, and streak.",
          "Self-study": "Self-study",
          "Any videos without a plan.": "Any videos without a plan.",
          "Questions about payment?": "Questions about payment?",
          "Contact support": "Contact support",
          "All rights reserved.": "All rights reserved.",
          "Terms of Use": "Terms of Use",
          "Privacy Policy": "Privacy Policy",
          "Refund policy": "Refund policy",
          "Manage subscription": "Manage subscription",
          "Payment failed": "Payment failed",
          "We could not activate Premium. Check your payment details or try another method.": "We could not activate Premium. Check your payment details or try another method.",
          "If you were charged, contact support — we will help.": "If you were charged, contact support — we will help.",
          "Payment attempt details": "Payment attempt details",
          "Attempt": "Attempt",
          "Not paid": "Not paid",
          "Reason: the payment was not confirmed by the bank": "Reason: the payment was not confirmed by the bank",
          "Try again": "Try again",
          "Choose another payment method": "Choose another payment method",
          "Return to pricing": "Return to pricing",
          "What could have happened?": "What could have happened?",
          "Insufficient funds on the card": "Insufficient funds on the card",
          "The bank declined the payment": "The bank declined the payment",
          "Incorrect card details": "Incorrect card details",
          "Payment confirmation was not completed (3D Secure)": "Payment confirmation was not completed (3D Secure)",
          "Temporary payment system error": "Temporary payment system error",
          "Need help?": "Need help?",
          "Contact us if the payment fails again or if you were charged.": "Contact us if the payment fails again or if you were charged.",
          "Continue without Premium": "Continue without Premium",
          "Support request": "Support request",
          "Describe the payment issue and we will help.": "Describe the payment issue and we will help.",
          "Subject: Payment issue": "Subject: Payment issue",
          "Describe what happened with the payment…": "Describe what happened with the payment…",
          "Thank you! We received your request.": "Thank you! We received your request.",
          "Password recovery": "Password recovery",
          "Enter your email, and we will send password recovery instructions.": "Enter your email, and we will send password recovery instructions.",
          "We will send an email if an account with this email exists.": "We will send an email if an account with this email exists.",
          "Send instructions": "Send instructions",
          "Return to login": "Return to login",
          "Sending...": "Sending...",
          "Quiz progress": "Quiz progress",
          "Question": "Question",
          "Result": "Result",
          "Type": "Type",
          "Review this question": "Review this question",
          "Lesson steps": "Lesson steps",
          "Video": "Video",
          "completed": "completed",
          "Words": "Words",
          "Quiz": "Quiz",
          "in progress": "in progress",
          "Speaking": "Speaking",
          "next": "next",
          "Quiz completed!": "Quiz completed!",
          "Great job! You checked your understanding of the video.": "Great job! You checked your understanding of the video.",
          "Continue to Speaking": "Continue to Speaking",
          "Review answers": "Review answers",
          "Result": "Result",
          "Review this question": "Review this question",
          "Almost correct": "Almost correct",
          "Build the English phrase from the given words. Click the words in the correct order.": "Build the English phrase from the given words. Click the words in the correct order.",
          "Click the words below to build the phrase.": "Click the words below to build the phrase.",
          "Correct answer:": "Correct answer:",
          "Congratulations! Your account has been created": "Congratulations! Your account has been created",
          "Congratulations,": "Congratulations,",
          "Your account has been created": "Your account has been created",
          "Your progress, dictionary, and learning plans will now be saved in your account.": "Your progress, dictionary, and learning plans will now be saved in your account.",
          "Choose how you would like to start learning.": "Choose how you would like to start learning.",
          "How would you like to learn?": "How would you like to learn?",
          "You can start with a structured plan or choose videos yourself.": "You can start with a structured plan or choose videos yourself.",
          "Structured lesson path": "Structured lesson path",
          "Progress and results are saved": "Progress and results are saved",
          "Any topic": "Any topic",
          "No fixed order": "No fixed order",
          "You can switch to a plan later": "You can switch to a plan later",
          "You can change the mode later.": "You can change the mode later.",
          "If you start without a plan, you can create a personal course at any time.": "If you start without a plan, you can create a personal course at any time.",
          "If you create a plan, you can still watch videos independently.": "If you create a plan, you can still watch videos independently.",
          "Great job! Lesson passed": "Great job! Lesson passed",
          "You did a great job — the next lesson is now unlocked.": "You did a great job — the next lesson is now unlocked.",
          "One more step toward confident English.": "One more step toward confident English.",
          "Required to pass:": "Required to pass:",
          "Passed": "Passed",
          "Next lesson unlocked": "Next lesson unlocked",
          "Go": "Go",
          "Watched": "Watched",
          "Learned words": "Learned words",
          "All words from this lesson dialogue.": "All words from this lesson dialogue.",
          "Words in dictionary": "Words in dictionary",
          "Words added to your dictionary.": "Words added to your dictionary.",
          "Return to plan": "Return to plan",
          "Was this lesson useful?": "Was this lesson useful?",
          "Almost there!": "Almost there!",
          "To pass the lesson, you need to meet two requirements. See what to repeat.": "To pass the lesson, you need to meet two requirements. See what to repeat.",
          "Not passed": "Not passed",
          "You need at least": "You need at least",
          "correct answers": "correct answers",
          "You need": "You need",
          "correct replies": "correct replies",
          "Repeat quiz": "Repeat quiz",
          "Repeat AI Speaking": "Repeat AI Speaking",
          "Return to course": "Return to course",
          "That is okay!": "That is okay!",
          "Repetition is the best way to remember. Repeat the required steps, and the lesson will be passed.": "Repetition is the best way to remember. Repeat the required steps, and the lesson will be passed.",
          // Course Complete
          "Congratulations! Course completed": "Congratulations! Course completed",
          "You successfully completed Travel English A0 → A1 and took a big step towards confident English.": "You successfully completed Travel English A0 → A1 and took a big step towards confident English.",
          "This is not the end — it is a new level of your English.": "This is not the end — it is a new level of your English.",
          "Average score": "Average score",
          "Dialogues": "Dialogues",
          "Days": "Days",
          "What next?": "What next?",
          "Raise level": "Raise level",
          "Continue Travel English at A1 → A2. New topics, vocabulary, and speaking.": "Continue Travel English at A1 → A2. New topics, vocabulary, and speaking.",
          "Start A1 → A2": "Start A1 → A2",
          "Learn a new topic": "Learn a new topic",
          "Choose another area: work, study, socializing, or something new.": "Choose another area: work, study, socializing, or something new.",
          "Choose a topic": "Choose a topic",
          "Watch something interesting": "Watch something interesting",
          "Browse videos on different topics and practice without a plan at your own pace.": "Browse videos on different topics and practice without a plan at your own pace.",
          "Choose a video": "Choose a video",
    
          // Create Course
          "What would you like to learn next?": "What would you like to learn next?",
          "Choose a topic and level for the new course. Completed courses will remain in your account.": "Choose a topic and level for the new course. Completed courses will remain in your account.",
          "Which topic would you like to study?": "Which topic would you like to study?",
          "We will select lessons based on your new learning area.": "We will select lessons based on your new learning area.",
          "Socializing": "Socializing",
          "Small talk, meeting people, and everyday conversations.": "Small talk, meeting people, and everyday conversations.",
          "For yourself": "For yourself",
          "Everyday topics, hobbies, and light practice.": "Everyday topics, hobbies, and light practice.",
          "News & Tech": "News & Tech",
          "Current topics, technology, news, and discussions.": "Current topics, technology, news, and discussions.",
          "Doctor visits, wellbeing, pharmacy, and basic situations.": "Doctor visits, wellbeing, pharmacy, and basic situations.",
          "Plans, weekends, leisure, and meetings.": "Plans, weekends, leisure, and meetings.",
          "Which level should this course start from?": "Which level should this course start from?",
          "Choose a level — you can change it later in the course settings.": "Choose a level — you can change it later in the course settings.",
          "Not sure? Choose an approximate level — you can change it later in the course settings.": "Not sure? Choose an approximate level — you can change it later in the course settings.",
          "New course": "New course",
          "Topic": "Topic",
          "Approximately": "Approximately",
          "18 lessons": "18 lessons",
          "The course will be added to “My courses”. Completed courses will remain available.": "The course will be added to “My courses”. Completed courses will remain available.",
          "Failed to create course. Please try again.": "Failed to create course. Please try again.",
          "Create course": "Create course",
          "Click underlined words in the text to see their translation and add them to your dictionary.": "Click underlined words in the text to see their translation and add them to your dictionary.",
          "Explanation": "Explanation",
          "Your answer sounds good.": "Your answer sounds good.",
          "Accepted": "Accepted",
          "Stop": "Stop",
          "reportProblemText": "Problem with a lesson? Report",
          "Report an issue": "Report an issue",
          "Choose what needs to be checked.": "Choose what needs to be checked.",
          "Issue with the video": "Issue with the video",
          "Issue with the word": "Issue with the word",
          "Issue with the question": "Issue with the question",
          "Issue with AI Speaking": "Issue with AI Speaking",
          "Other issue": "Other issue",
          "What exactly is wrong?": "What exactly is wrong?",
          "Video does not load": "Video does not load",
          "Video does not play": "Video does not play",
          "No sound": "No sound",
          "Subtitles are not displayed": "Subtitles are not displayed",
          "Incorrect subtitles": "Incorrect subtitles",
          "Incorrect translation": "Incorrect translation",
          "Translation is not displayed": "Translation is not displayed",
          "Incorrect explanation": "Incorrect explanation",
          "Incorrect example": "Incorrect example",
          "Audio does not work": "Audio does not work",
          "Incorrect question": "Incorrect question",
          "Incorrect answer marked as correct": "Incorrect answer marked as correct",
          "Incorrect answer options": "Incorrect answer options",
          "Translation error": "Translation error",
          "Question does not work": "Question does not work",
          "Voice recording does not work": "Voice recording does not work",
          "Recording does not stop": "Recording does not stop",
          "Recording does not play": "Recording does not play",
          "AI incorrectly recognized": "AI incorrectly recognized",
          "AI incorrectly assessed": "AI incorrectly assessed",
          "Incorrect hint": "Incorrect hint",
          "Technical error": "Technical error",
          "Page does not load": "Page does not load",
          "Something is displayed incorrectly": "Something is displayed incorrectly",
          "Which word?": "Which word?",
          "Type the word…": "Type the word…",
          "Question text": "Question text",
          "Describe or type the question…": "Describe or type the question…",
          "AI phrase": "AI phrase",
          "Type the phrase…": "Type the phrase…",
          "Comment — optional": "Comment — optional",
          "Describe what needs to be fixed…": "Describe what needs to be fixed…",
          "We received your report and will investigate the issue.": "We received your report and will investigate the issue.",
          "Lesson": "Lesson",
          "Continue self-study from where you left off.": "Continue self-study from where you left off.",
          "Start learning": "Start learning",
          "Pick a lesson to start with": "Pick a lesson to start with",
          "Browse the video catalog and choose a topic": "Browse the video catalog and choose a topic",
          "Go to videos": "Go to videos",
          "Videos you've added to your account.": "Videos you've added to your account.",
          "No videos in progress": "No videos in progress",
          "No completed videos": "No completed videos",
          "No favorite videos": "No favorite videos",
          "No added videos": "No added videos",
          "Like": "Like",
          "Dislike": "Dislike",
          "Remove from my videos": "Remove from my videos",
          "Remove video from cabinet?": "Remove video from cabinet?",
          "The video will be removed from the 'My videos' section. You can find it again on the 'All videos' page.": "The video will be removed from the 'My videos' section. You can find it again on the 'All videos' page.",
          "Cancel": "Cancel",
          "Delete": "Delete",
          "Total lessons": "Total lessons",
          "Completed lessons": "Completed lessons",
          "Choose the level for the next course. We will change your current plan.": "Choose the level for the next course. We will change your current plan.",
          "Current course": "Current course",
          "Not sure? Take a short test": "Not sure? Take a short test",
          "Change level": "Change level",
          "Choose a course that better matches your current level. We will change your current plan.": "Choose a course that better matches your current level. We will change your current plan.",
          "Choose a new topic": "Choose a new topic",
          "We will change the goal of your current course.": "We will change the goal of your current course.",
          "Next: choose level": "Next: choose level",
          "Which level to start from?": "Which level to start from?",
          "Choose a level for the new topic.": "Choose a level for the new topic.",
          "Not sure? Take a test": "Not sure? Take a test",
          "Updated plan": "Updated plan",
          "Your progress on the current course will be saved, only the topic/level of the plan will change.": "Your progress on the current course will be saved, only the topic/level of the plan will change.",
          "Change course": "Change course",
          "All self-learned words": "All self-learned words",
          "Back to text": "Back to text",
          "Confirming your email…": "Confirming your email…",
          "This will only take a moment": "This will only take a moment",
          "Email confirmed": "Email confirmed",
          "You're signed in, taking you to the app…": "You're signed in, taking you to the app…",
          "Continue to the app": "Continue to the app",
          "Sign in to start learning": "Sign in to start learning",
          "Sign in": "Sign in",
          "This link doesn't work": "This link doesn't work",
          "The link is broken or has expired – request a new confirmation email and try again": "The link is broken or has expired – request a new confirmation email and try again",
          "Back to home": "Back to home",
        },
      },
      uk: {
        translation: {
          welcome: "Ласкаво просимо! Виберіть вашу мову:",
          level: "Який у вас рівень англійської?",
          purpose: "Для чого ви вивчаєте англійську мову?",
          videos: "Ось деякі відео для вас:",
          register: "Зареєструйтесь, щоб продовжити",
          options: {
            beginner: "Новачок",
            elementary: "Початковий",
            intermediate: "Середній",
            advanced: "Просунутий",
            travel: "Подорожі",
            job: "Робота",
            education: "Освітна",
            communication: "Комунікації",
            fun: "Задля розваги",
          },
          aboutUs: "Про нас",
          contact: "Контакти",
          services: "Послуги",
          blog: "Блог",
          catalog: "Каталог",
          buyNow: "Купити зараз",
          addToCart: "Додати в кошик",
          checkout: "Оформити замовлення",
          totalPrice: "Загальна вартість",
          search: "Пошук",
          enterYourEmail: "Введіть ваш email",
          subscribe: "Підписатися",
          latestNews: "Останні новини",
          readMore: "Читати більше",
          sendMessage: "Надіслати повідомлення",
          name: "Ім'я",
          email: "Email",
          message: "Повідомлення",
          submit: "Надіслати",
          loading: "Завантаження...",
          "Loading...": "Завантаження...",
          success: "Успішно!",
          error: "Сталася помилка. Будь ласка, спробуйте ще раз.",
          signin: "Увійти",
          "Password": "Пароль",
          forgotpassword: "Забули пароль",
          oro: "або",
          account: "Немає акаунту?",
          register: "Реєстрація",
          login: "Увійти",
          loading: "Завантаження",
          signup: "Зареєструватися",
          username: "Ім'я користувача",
          confirmpassword: "Підтвердити пароль",
          haveac: "Вже маєте акаунт?",
          logout: "Вийти",
          registerforfree: "Зареєструватися безкоштовно",
          "Start speaking with confidence from day one": "Почніть говорити впевнено з першого дня",
          "Start Learning Free": "ПОЧНИ ВЧИТИСЯ БЕЗКОШТОВНО",
          "Choose your English level and topics that interest you": "Обери свій рівень англійської та теми, що тебе цікавлять",
          "All Categories": "Усі категорії",
          "All Levels": "Усі рівні",
          "Search videos by title": "Шукай відео за назвою",
          "Immerse yourself in authentic content featuring real-life videos with practical, everyday vocabulary you'll actually use.": "Поринь у справжній контент з реальними відео та практичною повсякденною лексикою, яку ти справді будеш використовувати.",
          "Learn Words": "Вивчай слова",
          "Focus your energy efficiently by studying only the words from videos that are new to you, maximizing your learning time.": "Використовуй свою енергію ефективно, вивчаючи лише ті слова з відео, які є новими для тебе, і таким чином максимально використовуючи час навчання.",
          "understanding2": "Перевір розуміння",
          "Assess your comprehension through interactive questions, voice-based answers, and targeted review of new vocabulary.": "Перевіряй розуміння за допомогою інтерактивних запитань, голосових відповідей і цільового повторення нової лексики.",
          "practiceDialogues2": "Практикуй діалоги",
          "Apply your knowledge in realistic conversations based on the videos you've watched, building confidence for real-world interactions.": "Застосовуй знання у реальних розмовах на основі переглянутих відео, набуваючи впевненості для справжніх ситуацій.",
          watch: "Вивчай нові слова",
          watchbig:
            "Складай персональний словник або вивчай слова, які підібрав AI – тільки найнеобхідніше для тебе.",
          learn: "Дивись відео",
          learnBig:
            "Занурюйся у живі діалоги, що відповідають твоєму рівню та цілям.",
          speak: "Обговорюй",
          speakBig:
            "Практикуй розмову з AI – текстом або голосом, як у справжньому спілкуванні.",
          discuss: "Отримай зворотний зв'язок на свої відповіді",
          discussBig:
            "AI перевіряє твої відповіді, пояснює помилки та допомагає їх виправити.",
          popularVideo: "Популярні відео",
          allLevels: "Рівень мови",
          showAll: "Показати всі",
          filter: "Фільтр",
          chooseLanguage: "На якій мові вам зручно бачити сайт?",
          popupTitle: "Бажаєте розпочати навчання?",
          startLearning: "Розпочати",
          startyFirstTitle: "Говори мовами світу",
          levelonea: "Початковий",
          leveltwoa: "Елементарний",
          levevoneb: "Середній",
          lebeltwob: "Вище середнього",
          levelonec: "Високий",
          leveltwoc: "Професійний",
          levelBeginnerGroup: "Початковий",
          levelIntermediateGroup: "Середній",
          levelAdvancedGroup: "Високий",
          allLevelsOption: "Усі рівні",
          contButton: "Продовжити",
          pojasn: "Пояснення",
          pruklad: "Приклад застосування",
          showMore: "Показати більше",
          showLess: "Показати менше",
          searchPlaceholder: "Введіть назву відео",
          videoNotFound: 'Відео з назвою "" не знайдено',
          noVideosForFilters: "Відео не знайдено для вибраних фільтрів",
          allVideos: "Всі відео",
          grammar: {
            verb: "Дієслово",
            infinitive: "Інфінітив",
            thirdPersonSingular: "3 ос. одн.",
            pastTense: "Минулий час",
            pastParticiple: "Дієприкм. мин. часу",

            adjective: "Прикметник",
            adverb: "Прислівник",
            comparative: "Вищий ступінь",
            superlative: "Найвищий ступінь",

            pronoun: "Займенник",
            reflexiveForm: "Зворотна форма",
            objectForm: "Об'єктна форма",
            possessiveForm: "Присвійна форма",

            determiner: "Визначник",
            singular: "Однина",
            plural: "Множина",

            number: "Числівник",

            abbreviation: "Абревіатура",
            fullForm: "Повна форма",
            yes: "так",
            no: "ні",
          },
          "English": "Англійська",
          "Polski": "Польська",
          "Українська": "Українська",
          "Ukrainian": "Українська",
          "Polish": "Польська",
          "My learning": "Моє навчання",
          "All Videos": "Усі відео",
          "All videos": "Усі відео",
          "Words learned": "Вивчено слів",
          "Videos completed": "Завершених відео",
          "Questions answered correctly": "Правильних відповідей на запитання",
          "Dialogues role played successfully": "Успішно виконаних діалогів",
          "All My Videos": "Усі мої відео",
          "In Progress": "У процесі",
          "Completed": "Завершено",
          "❤️ Favorites": "❤️ Вибране",
          "Favorites": "Улюблені",
          "words": "слів",
          "word": "слово",
          "Total Words": "Всього слів",
          "Words in Dictionary": "Слів у словнику",
          "Watch Video": "Дивись відео",
          "Watch the full lesson video": "Перегляньте повне відео уроку",
          "Study Words": "Вчити слова",
          "Learn vocabulary in context": "Вивчайте словниковий запас у контексті",
          "Check Understanding": "Перевірити розуміння",
          "Check your understanding": "Перевірити розуміння",
          "Test your comprehension": "Перевірте своє розуміння",
          "Practice Dialogues": "Практикувати діалоги",
          "Real-life conversations": "Розмови з реального життя",
          "Example": "Приклад",
          "Common Mistakes": "Поширені Помилки",
          "Log Out": "Вийти",
          "Log In": "Увійти",
          "days remaining": "днів залишилось",
          "Welcome back": "З поверненням",
          "Language level": "Рівень мови",
          "Travel": "Подорожі",
          "Education": "Освіта",
          "Work": "Робота",
          "Health": "Здоров'я",
          "News & Technology": "Новини та технології",
          "Leisure": "Дозвілля",
          "Daily Life": "Повсякденне життя",
          "Beginner": "Початковий",
          "Elementary": "Елементарний",
          "Intermediate": "Середній",
          "Upper-Intermediate": "Вище середнього",
          "Advanced": "Високий",
          "Proficiency": "Професійний",
          "INF": "ІНФ",
          "V2": "V2",
          "V3": "V3",
          "3 SG": "3 одн.",
          "SG": "одн.",
          "PL": "мн.",
          "BASE": "ОСНОВА",
          "COMP": "ПОРІВ",
          "SUP": "НАЙВ",
          "REFL": "ЗВОРОТ",
          "OBJ": "ОБ'ЄКТ",
          "POSS": "ПРИСВ",
          "FULL": "ПОВНА",
          "Master Your English!": "Виведіть свою англійську на новий рівень",
          "Start Testing": "Розпочати тест",
          "Choose your challenge:": "Оберіть тип завдання:",
          "Yes/No Questions": "Питання Так/Ні",
          "Text/Voice Response": "Відповідь текстом/голосом",
          "Drag & Drop": "Перетягування",
          "Attempts": "Спроб",
          "attempts": "спроби",
          "Click any question to jump directly to it!": "Натисніть на будь‑яке запитання, щоб перейти до нього",
          "View Results": "Переглянути результати",
          "Question": "Питання",
          "Hint": "Підказка",
          "of": "з",
          "Select your answer – it will be checked automatically": "Виберіть відповідь — її буде перевірено автоматично",
          "YES": "ТАК",
          "NO": "НІ",
          "Correct": "Правильно",
          "Incorrect": "Неправильно",
          "Partially Correct": "Частково правильно",
          "Next Question": "Наступне питання",
          "Answer by Text or Voice": "Відповідайте текстом або голосом",
          "Type your answer below or click the microphone to record your voice": "Введіть відповідь нижче або натисніть мікрофон, щоб записати свій голос",
          "Type your answer here…": "Введіть відповідь тут…",
          "Ready": "Готово",
          "Answered": "Відповів",
          "Check Answer": "Перевірити відповідь",
          "Recording...": "Триває запис…",
          "Your answer:": "Ваша відповідь:",
          "Drag the words to complete the sentence:": "Перетягніть слова, щоб доповнити речення:",
          "Your answer will be checked automatically when all gaps are filled": "Відповідь перевіриться автоматично, як тільки ви заповните всі пропуски",
          "Next Question": "Наступне питання",
          "Finish Test": "Завершити тест",
          "Please select at least one test type!": "Будь ласка, виберіть принаймні один тип тесту!",
          "No questions available!": "Немає доступних питань!",
          "Loading questions...": "Завантаження питань...",
          "This may take 5-10 seconds for new content": "Це може зайняти 5-10 секунд для нового контенту",
          "of": "з",
          "Try Again": "Спробувати ще раз",
          "Scroll down to see your detailed error analysis": "Прокрутіть униз, щоб переглянути детальний аналіз помилок",
          "Outstanding": "Відмінно!",
          "Keep Growing!": "Зростайте далі!",
          "Great Job!": "Чудова робота!",
          "Good Effort!": "Гарне зусилля!",
          "Error Analysis": "Аналіз помилок",
          "Understanding your mistakes helps you learn better": "Розуміння своїх помилок допомагає вчитися краще",
          "Key Areas for Improvement": "Ключові напрями для вдосконалення",
          "Incorrect Answers": "Неправильні відповіді",
          "Partially Correct Answers": "Частково правильні відповіді",
          "Correct answer:": "Правильна відповідь:",
          "You've mastered this material! Your understanding is exceptional.": "Ви опанували цей матеріал! Ваше розуміння — виняткове.",
          "Every expert was once a beginner. Keep practicing and you'll get there!": "Кожен експерт колись був початківцем. Продовжуйте практикуватися — і все вийде!",
          "You've completed your": "Ви використали",
          "You're doing really well! Keep up the excellent work.": "У тебе чудово виходить! Продовжуй у тому ж дусі.",
          "You're making progress! A little more practice will help you improve.": "Ти досягаєш прогресу! Трохи більше практики допоможе тобі стати кращим.",
          "Focus on careful reading - multiple Yes/No questions were missed. Pay attention to keywords like 'not', 'only', or 'all'.": "Зосередьтеся на уважному читанні — пропущено кілька питань Так/Ні. Звертайте увагу на ключові слова, як-от 'не', 'тільки' або 'всі'.",
          "Practice word order and grammar structures - drag & drop questions show gaps in understanding sentence construction.": "Практикуйте порядок слів і граматичні структури — завдання з перетягуванням показують прогалини в розумінні побудови речень.",
          "Work on expressing complete thoughts - text/voice answers need more detail and accuracy.": "Працюйте над вираженням повних думок — текстові/голосові відповіді потребують більше деталей і точності.",
          "Consider reviewing the material more thoroughly before attempting again. Take notes on key concepts.": "Розгляньте можливість більш ретельного вивчення матеріалу перед повторною спробою. Робіть нотатки з ключових концепцій.",
          "You're showing good understanding but need to refine some details. Focus on the specific areas mentioned above.": "Ви демонструєте гарне розуміння, але потрібно уточнити деякі деталі. Зосередьтеся на конкретних областях, згаданих вище.",
          "No answer": "Немає відповіді",
          "No answer provided": "Відповідь не надано",
          "N/A": "Н/Д",
          "See explanation": "Дивіться пояснення",
          "Review Your Answer": "Переглянути вашу відповідь",
          "See your answer and the explanation for this question": "Подивіться свою відповідь і пояснення до цього питання",
          "← Back to Results": "← Назад до результатів",
          "Review Mode": "Режим перегляду",
          "Review all your answers and explanations": "Переглянути всі ваші відповіді та пояснення",
          "Previous": "Попередній",
          "Next": "Наступний",
          "Next2": "Далі",
          "Please provide an answer!": "Будь ласка, надайте відповідь!",
          "Microphone access denied. Please type your answer.": "Доступ до мікрофона заборонено. Будь ласка, введіть відповідь.",
          "Mic denied": "Мікрофон заборонено",
          "Voice recording saved": "Голосовий запис збережено",
          "Failed to submit your recording. Please try again.": "Не вдалося надіслати ваш запис. Будь ласка, спробуйте ще раз.",
          "Failed to play recording": "Не вдалося відтворити запис",
          "Voice recording transcribed": "Голосовий запис розшифровано",
          "Voice recording submitted": "Голосовий запис надіслано",
          "Processing...": "Обробка...",
          "Welcome to Dialogue Studio!": "Ласкаво просимо до Dialogue Studio!",
          "firstPopDes": "Давай потренуємо діалог разом. Вам потрібно використати 5 слів з словника у нашій розмові.",
          "Yes, I'm Ready!": "ТАК, Я ГОТОВИЙ!",
          "FINISH SESSION": "ЗАВЕРШИТИ УРОК",
          "Word Treasury": "Слова",
          "YOUR PROGRESS": "ВАШ ПРОГРЕС",
          "Words Used": "Використані слова",
          "PRESS TO SPEAK": "НАТИСНІТЬ, ЩОБ ГОВОРИТИ",
          "Listening to you...": "Слухаю тебе...",
          "I don't understand the question": "Я не розумію питання",
          "I can't answer": "Я не можу відповісти",
          "Time Invested": "Витрачений час",
          "Time Spent": "Витрачено часу",
          "Welcome to your": "Ласкаво просимо до вашої",
          "restFirstMessageT": "практики діалогу! Я з нетерпінням хочу обговорити з вами цю тему. Спробуйте використати 5 слів, показаних праворуч.",
          "Exchanges": "Обміни",
          "Words Mastered": "Слів опановано",
          "Brilliant Session!": "Блискучий урок",
          "You've created something beautiful with words today": "Ви сьогодні створили щось прекрасне за допомогою слів",
          "Your Achievements": "Ваші досягнення",
          "Perfect! You used all 5 vocabulary words brilliantly!": "Чудово! Ви блискуче використали всі 5 слів зі словника!",
          "New Adventure": "Нова пригода",
          "Exit": "Вихід",
          "Welcome Back!": "З поверненням!",
          "You have an unfinished dialogue session for": "У вас є незакінчений діалог на тему",
          "You've used": "Ви використали",
          "out of 5 vocabulary words.": "слово з 5 слів словникового запасу",
          "Continue Session": "Продовжити діалог",
          "Start Over": "Почати спочатку",
          "In which language would you like to view the website?": "Якою мовою ви б хотіли переглядати сайт?",
          "Take the test — get a program personalized to your goal and level": "Пройдіть тест — отримаєте програму під вашу мету та рівень",
          "It will take less than 1 minute": "Це займе менше 1 хвилини",
          "Quick & Easy": "Швидко та легко",
          "Step 1 of 2": "Крок 1 з 2",
          "Step 2 of 2": "Крок 2 з 2",
          "What is your current English level?": "Який ваш поточний рівень англійської?",
          "What's your main goal with English?": "Яка ваша основна мета у вивченні англійської мови?",
          "Great! We've prepared your personalized learning path": "Чудово! Ми підготували ваш персоналізований шлях навчання",
          "Finish test": "Завершити тест",
          "English Learning Journey": "Подорож вивчення англійської",
          "Lower Level": "Знизити рівень",
          "Add Plan": "Додати план",
          "Raise Level": "Підвищити рівень",
          "Learning Progress": "Прогрес навчання",
          "Current Level": "Поточний рівень",
          "Basics": "Основи",
          "Conversations": "Розмови",
          "Introduction": "Знайомство",
          "Greetings": "Привітання",
          "Practice": "Практика",
          "Daily Talk": "Щоденні розмови",
          "Questions": "Питання",
          "Social": "Соціальне",
          "Business": "Бізнес",
          "Emails": "Електронні листи",
          "Meetings": "Зустрічі",
          "Airport": "Аеропорт",
          "Hotels": "Готелі",
          "Dining": "Їжа",
          "Grammar": "Граматика",
          "Idioms": "Ідіоми",
          "Fluency": "Вільне володіння",
          "I want to choose the video myself": "Я хочу вибрати відео самостійно",
          "Continue Learning": "Продовжити навчання",
          "TRY 2-MIN DEMO": "Спробуй 2-хвилинну демо",
          "WHY CHOOSE AI LINGUA?": "Чому обрати AI Lingua?",
          "REAL-LIFE VIDEOS": "Відео з реального життя",
          "AI-POWERED PRACTICE": "Практика з ШІ",
          "ALL LEVELS WELCOME": "Для всіх рівнів",
          // Level descriptions
          "Preparatory course. Ideal for beginners": "Підготовчий курс. Ідеально для початківців",
          "I am starting to learn English.": "Я починаю вивчати англійську.",
          "I already know some words": "Я вже знаю деякі слова",
          "I can already speak a little": "Я вже можу трохи говорити",
          "I confidently speak on various topics": "Я впевнено говорю на різні теми",
          "I can discuss various topics in detail": "Я можу детально обговорювати різні теми",
          "Enter your credentials to access your account": "Введіть ваші дані для входу в систему",
          "coming soon": "дуже скоро",
          "Login successful": "Успішний вхід",
          "Login failed": "Помилка входу",
          "Create your account to get started": "Створіть акаунт, щоб розпочати",
          "Plans that fit your needs": "Оберіть план під свої потреби",
          "Simple, scalable pricing that grows with you.": "Прості й гнучкі тарифи, що зростають разом із вами.",
          "Free": "Безкоштовний",
          "Free for everyone": "Безкоштовно для всіх",
          "Watch learning videos": "Перегляд навчальних відео",
          "Add words to personal vocabulary": "Додавання слів до особистого словника",
          "Study & review words": "Вивчення та повторення слів",
          "Video comprehension checks": "Тести на розуміння відео",
          "AI voice dialogues": "Голосові діалоги зі ШІ",
          "Certificate upon completion": "Сертифікат після завершення",
          "Priority support": "Пріоритетна підтримка",
          "Sign Up": "Зареєструватися",
          "/month": "/місяць",
          "Plans that fit your needs": "Плани, що відповідають вашим потребам",
          "Simple, scalable pricing that grows with you.": "Просте масштабоване ціноутворення, яке зростає разом з вами",
          "Free": "Безкоштовно",
          "Free for everyone": "Безкоштовно для всіх",
          "Watch learning videos": "Перегляд навчальних відео",
          "Add words to personal vocabulary": "Додавання слів до особистого словника",
          "Study & review words": "Вивчення та повторення слів",
          "Video comprehension checks": "Тести на розуміння відео",
          "AI voice dialogues": "Голосові діалоги зі ШІ",
          "Certificate upon completion": "Сертифікат після завершення",
          "Priority support": "Пріоритетна підтримка",
          "For individuals & freelancers": "Для індивідуальних користувачів і фрилансерів",
          "7 days free trial": "7 днів безкоштовного пробного періоду",
          "AI voice dialogues — 10 per day": "Голосові діалоги зі ШІ — 10 на день",
          "Unlimited AI voice dialogues": "Необмежені голосові діалоги зі ШІ",
          "For teams & agencies": "Для команд і агенцій",
          "For schools, businesses, universities": "Для шкіл, компаній та університетів",
          "All Pro features included": "Усі можливості тарифу «Професійний»",
          "Per-user progress reports": "Звіти про прогрес для кожного користувача",
          "Training reminders for learners": "Нагадування про навчання для користувачів",
          "Custom branding options": "Налаштування фірмового стилю",
          "Dedicated account manager": "Персональний менеджер",
          "Volume discounts available": "Доступні знижки за обсяг",
          "API access & integrations": "Доступ до API та інтеграції",
          "Contact Us": "Зв'язатися з нами",
          "Get Started": "Почати",
          "Custom Pricing": "Індивідуальна ціна",
          "Pro": "Професійний",
          "Popular": "Популярний",
          "Cancel & Refund Policy": "Політика скасування та повернення коштів",
          "Pricing": "Тарифи",
          "All rights reserved": "Всі права захищені",
          "Terms of Use": "Умови використання",
          "Privacy Policy": "Політика конфіденційності",
          "Cookie Settings": "Налаштування cookie",
          "Terms of Use2": "Умови користування",
          "Last updated": "Останнє оновлення",
          "temrs1Text": "AI Lingua — онлайн-платформа для вивчення англійської мови (відеоуроки, словник, тести на розуміння, тренування діалогів зі штучним інтелектом). Доступ надається виключно в цифровій формі; фізичні товари не постачаються.",
          "terms2": "Платежі обробляє Paddle.com; інвойси/чеки та застосовні податки адмініструє Paddle.",
          "terms3": "Власник сервісу: ФОП Корчинська Альона Олександрівна (Korchynska Alona Oleksandrivna)",
          "terms4": "| Юрисдикція: Україна",
          "terms5": "Адреса для листування: м. Старокостянтинів, Хмельницька область, 31100, Україна",
          "terms6": "Мінімальний вік користувача — 13 років; особи молодші 13 не можуть користуватися сервісом. Якщо ви проживаєте у країні ЄС/ЄЕЗ або Великій Британії і вам менше 16 років, потрібна підтверджена згода батьків/опікунів (якщо закон вашої країни дозволяє нижчий вік згоди, ми це врахуємо). Користувач зобов'язаний забезпечувати конфіденційність облікових даних і не передавати доступ третім особам.",
          "terms7": "Paddle.com Acting as Merchant of Record.",
          "terms8": "Оплату приймає та інвойси/чеки виставляє Paddle.com як продавець/merchant of record, включно з розрахунком і стягненням застосовних податків/ПДВ. Плани та ціни публікуються на сторінці тарифів і можуть змінюватися з попереднім повідомленням, якщо впливають на наступні періоди. Підписка авто-поновлюється, доки її не скасовано у кабінеті користувача (автопродовження вимикається; доступ діє до кінця оплаченого періоду).",
          "terms9": "Пробний період — 7 днів. Якщо підписку оформлено під час trial, оплачений доступ починається одразу, а пробний триває до завершення 7 днів (загальний доступ не подвоюється). Доступна безкоштовна версія з обмеженим функціоналом.",
          "terms10": "Повернення коштів після оплати підписки не надаються, включно з частковими/пропорційними сумами, за винятком випадків, прямо передбачених імперативними нормами застосовного законодавства або нашою політикою винятків.",
          "terms11": "Забороняються: порушення законодавства; агресивний, дискримінаційний або шкідливий контент; спроби несанкціонованого доступу, втручання в роботу сервісу або реверс-інжиніринг; автоматизований масовий збір даних; шахрайство з платежами; спільне використання одного акаунта кількома особами; завантаження або введення матеріалів, що порушують права ІВ третіх осіб. Акаунти, що порушують ці Умови, можуть бути обмежені або закриті після повідомлення, де це можливо.",
          "terms12": "Матеріали сервісу (зокрема відео, тести, програмний код, дизайн, тексти) захищені правами інтелектуальної власності. Користувачеві надається обмежена, невиключна, непередавана ліцензія на особисте некомерційне використання сервісу. Контент, завантажений користувачем, залишається його власністю; користувач надає сервісу обмежену ліцензію на використання такого контенту з метою надання та поліпшення сервісу.",
          "terms13": "Ми залучаємо сторонніх постачальників (хостинг, аналітика, LLM-моделі для діалогів зі ШІ). Дані обробляються лише для надання, підтримки та поліпшення сервісу. Ми не використовуємо ваш вміст для навчання загальних моделей провайдерів, якщо прямо не вкажемо інше і не отримаємо вашу згоду. Перелік ключових постачальників та місцезнаходження серверів наведено у Політиці конфіденційності.",
          "terms14": "Ми можемо оновлювати функції, ціни та умови. Про суттєві зміни, що впливають на оплату/доступ, повідомляємо щонайменше за 7 днів (e-mail/банер у акаунті). Продовження користування після дати набуття чинності означає згоду з оновленими умовами.",
          "terms15": "Сервіс може призупинити або припинити доступ користувача в разі порушення цих Умов або за наявності безпекових/правових підстав, із розумним повідомленням, коли це можливо. Після припинення доступу ви можете експортувати свої дані протягом 30 днів (крім випадків правових обмежень).",
          "terms16": "Сервіс надається «як є» та «як доступний». У межах, дозволених законом, не надаються будь-які неявні гарантії придатності чи відповідності конкретній меті. Сукупна відповідальність власника сервісу перед користувачем обмежується сумою платежів, сплачених таким користувачем за останні 12 місяців.",
          "terms17": "Ці Умови регулюються законодавством України; спори підвідомчі компетентним судам України, якщо інше не передбачено імперативними нормами.",
          "terms18": "Питання щодо сервісу та білінгу (включно з відмовою від підписки):",
          "About Us": "Про нас",
          "Accounts and Age": "Облікові записи та вік",
          "Subscriptions, Pricing, and Billing": "Підписки, ціни та білінг",
          "Trial Period and Free Version": "Пробний період і безкоштовна версія",
          "Refunds": "Повернення коштів",
          "Acceptable Use": "Прийнятне використання",
          "Intellectual Property Rights": "Права інтелектуальної власності",
          "Third-Party Technologies and AI": "Сторонні технології та ШІ",
          "Service Availability and Changes": "Доступність та зміни сервісу і цін",
          "Termination of Access": "Припинення доступу",
          "Warranty Disclaimer": "Відмова від гарантій та обмеження відповідальності",
          "Governing Law and Contact": "Право, юрисдикція та зв'язок",
          "October": "жовтня",
          "Who We Are": "Хто ми",
          "privacy1": "ФОП Корчинська Альона Олександрівна — контролер даних для AI Lingua. Контакти:",
          "Data We Process": "Дані, які ми обробляємо",
          "privacy2": "email, пароль (хешований), ім'я/псевдонім.",
          "privacy3": "прогрес, результати тестів, налаштування, журнали активності.",
          "privacy4": "обробляє Paddle.com (ми отримуємо статус транзакції/підписки, Order ID; не зберігаємо повні реквізити карток).",
          "privacy5": "cookie/телеметрія для роботи сайту, безпеки, аналітики.",
          "Purposes": "Для чого",
          "privacy6": "Надання сервісу, білінг, підтримка, безпека, аналітика/поліпшення, виконання правових обов'язків.",
          "Legal Bases": "Правові підстави",
          "privacy7": "Виконання договору; законний інтерес; згода (де потрібно); правовий обов'язок.",
          "Data Sharing": "Передача даних",
          "privacy8": "Постачальникам інфраструктури/аналітики та Paddle.com — з належними гарантіями.",
          "privacy8.1": "Постачальникам інфраструктури/аналітики та",
          "privacy8.2": "— з належними гарантіями.",
          "Retention": "Зберігання",
          "privacy9": "Поки активний акаунт; окремі записи — довше, якщо цього вимагає закон (напр., фінзвітність).",
          "Data Subject Rights": "Права суб'єкта даних",
          "privacy10": "Запити щодо доступу/видалення/перенесення/заперечення надсилайте на ailinguaservice@gmail.com. Ми відповідаємо протягом 30 днів. Ви також маєте право звернутися зі скаргою до Уповноваженого ВРУ з прав людини або до наглядового органу у вашій країні проживання.",
          "International Transfers": "Міжнародні передачі",
          "privacy11": "Коли ми передаємо дані за межі України/ЄС, ми використовуємо стандартні договірні положення (SCC) або інші належні гарантії. Перелік основних постачальників і країни обробки наводяться у відповідному розділі/додатку.",
          "Cookies": "Cookies",
          "privacy12": "Ми застосовуємо необхідні cookies для роботи сайту та аналітичні/маркетингові — лише за вашою згодою. Ви можете змінити вибір у банері згоди у будь-який момент.",
          "Account": "Акаунт",
          "Learning": "Навчання",
          "Payments": "Платежі",
          "Technical": "Технічні",
          "Cancellation and Refund Policy": "Політика скасування та повернення коштів",
          "refund1": "7 днів. Якщо оформлено підписку під час trial, пробний доступ діє до завершення 7 днів.",
          "refund2": "списання через Paddle; підписка автопродовжується до скасування.",
          "refund3": "будь-коли у вашому кабінеті/через Paddle; після скасування доступ зберігається до кінця вже оплаченого періоду.",
          "refund4": "не надаються після оплати підписки (включно з частковими/пропорційними), за винятком випадків, які прямо вимагає чинне законодавство.",
          "refund5": "Контакти з питань білінгу/скасування:",
          "Trial period:": "Пробний період:",
          "Payment and auto-renewal:": "Оплата і автопродовження:",
          "CNCL": "Скасування:",
          "RFND": "Повернення коштів:",
          "app-header-text": "Зараз попрактикуємо діалог з відео. Говоримо так само, як у ролику: ті ж слова й та сама тема. Починаємо.",
          "Try saying it like this:": "Спробуй сказати так:",
          "Keep practicing!": "Продовжуйте практикуватися!",
          "Not bad!": "Непогано!",
          "Good job!": "Молодець!",
          "Excellent result!": "Відмінний результат!",
          "Skip": "Пропустити",
          "Take a break and review!": "Зробімо паузу та повторимо!",
          "You\'ve tried five times already - that\'s great persistence! But it seems like it would be worth refreshing the material so the dialogue goes easier.": "Ви вже п'ять разів спробували — це класна наполегливість! Але здається, варто освіжити матеріал, щоб діалог пішов легше.",
          "Mistakes are part of learning": "Помилки – це частина навчання",
          "Nothing scary, it happens!": "Нічого страшного, буває!",
          "It seems difficult to answer by voice for now. Let\'s first review the material again - after that it will be much easier!": "Здається, поки складно відповідати голосом. Давайте спершу ще раз переглянемо матеріал — після цього буде набагато простіше!",
          "One step back is two steps forward": "Один крок назад - це два кроки вперед",
          "We recommend returning to:": "Рекомендуємо повернутися до:",
          "Learn Words2": "Вчити слів",
          "Review key words and phrases from the lesson": "Повторити ключові слова та фрази уроку",
          "Watch Video2": "Дивитись відео",
          "Watch the dialogue again with subtitles": "Переглянути діалог ще раз з субтитрами",
          "I want to continue the dialogue": "Хочу продовжити діалог",
          "Lesson completed": "Урок завершено",
          "Great! Lesson": "Чудово! Урок",
          "completed!": "пройдено!",
          "You\'ve completed the dialogue practice for this video. You can now move on to the next lesson or review this one again.": "Ти успішно відпрацював діалог і вже можеш переходити до наступного уроку. Так тримати!",
          "Repeat Lesson": "Повторити урок",
          "Next Lesson": "Наступний урок",
          "Almost there!": "Майже вийшло!",
          "Don't be sad": "Не засмучуйся",
          "Every attempt": "кожна спроба",
          "is a step forward": "наближає до успіху",
          "This time the lesson": "Цього разу урок",
          "was not completed — but that's okay. Mistakes are part of learning. Repeat the lesson or move on: your choice!": "не вдалося завершити — але це нормально. Помилки — це частина навчання. Повтори урок або рухайся далі: вибір за тобою!",
          "Awesome plan for you": "Чудовий план для тебе",
          "Access to 30 video pack": "Доступ до пакету з 30 відео",
          "Subscriptions": "Підписки",
          "Sign in to manage your subscription": "Увійдіть, щоб керувати своєю підпискою",
          "Please log in to view and manage your subscription details, billing information, and account settings.": "Будь ласка, увійдіть, щоб переглянути та керувати інформацією про підписку, платіжною інформацією та налаштуваннями облікового запису.",
          "You can manage your billing information and subscription here": "Ви можете керувати своєю платіжною інформацією та підпискою тут",
          "You're on the": "Ви на",
          "plan": "плані",
          "Next renewal:": "Наступне оновлення:",
          "Plan cost": "Вартість плану",
          "Status": "Статус",
          "Auto-renewal": "Автопродовжування",
          "Cancel Subscription": "Відмінити підписку",
          "Upgrade your plan": "Покращити ваш план",
          "Processing payment": "Обробка оплати",
          "We are waiting for confirmation from the payment provider...": "Очікуємо підтвердження від платіжного провайдера...",
          "Your subscription plan": "Тарифний план",
          "Activation progress": "Прогрес активації",
          "Do not close this page - we will notify you immediately": "Не закривайте цю сторінку — ми повідомимо вас одразу",
          "Successfully activated!": "Успішно активовано!",
          "Your subscription plan": "Ваш тарифний план",
          "Do not waste time - let's learn together! All features of the plan": "Не гайте часу — нумо вчитись разом! Всі функції плану",
          "are already available in your account.": "доступні у вашому акаунті.",
          "Thank you for trusting AI Lingua!": "Дякуємо за довіру до AI Lingua!",
          "Subscription": "Підписка",
          "Tel": "Тел",
          "Стандарт": "Стандарт",
          "Premium": "Преміум",
          "After registration, you'll get your personalized course and be able to track your progress.": "Після реєстрації ви отримаєте персоналізований курс і зможете відстежувати свій прогрес",
          "Start your language learning journey with AI-powered lessons tailored just for you!": "Почніть свою подорож вивчення мови з уроків на базі штучного інтелекту, розроблених спеціально для вас!",
          "Welcome Back, aliona!": "З поверненням, Альона!",
          "Let's continue studying together": "Давайте продовжувати навчання разом",
          "Learned Words": "Вивчених слів",
          "Completed Videos": "Завершених відео",
          "Correct Answers": "Правильних відповідей",
          "Successful Dialogues": "Успішних діалогів",
          "My Courses": "Мої курси",
          "View all courses": "Переглянути всі курси",
          "Business English": "Ділова англійська",
          "Intermediate": "Середній",
          "24 lessons": "24 уроків",
          "Progress": "Прогрес",
          "lessons done": "уроків виконано",
          "lessons left": "уроків залишилося",
          "Conversational English": "Розмовна англійська",
          "30 lessons": "30 уроків",
          "Travel English": "Англійська для подорожей",
          "15 lessons": "15 уроків",
          "My Videos": "Мої відео",
          "View all": "Переглянути всі",
          "Name": "Ім'я",
          "Email": "Email",
          "Phone": "Телефон",
          "Message": "Повідомлення",
          "Submit": "Надіслати",
          "Please fill in all the fields!": "Будь ласка, заповніть усі поля!",
          "Completed Dialogs": "Завершених діалогів",
          "Введіть коректну адресу електронної пошти.": "Введіть коректну адресу електронної пошти.",
          "The email address and/or password you specified are not correct.": "Вказані вами адреса електронної пошти та/або пароль неправильні.",
          "Choose a username": "Виберіть ім'я користувача",
          "Це поле обов'язкове.": "Це поле обов'язкове.",
          "A user is already registered with this email address.": "Користувач вже зареєстрований з цією адресою електронної пошти.",
          "Register to save your progress": "Зареєструйтесь, щоб зберегти свій прогрес",
          "Register": "Зареєструватись",
          "Previous Lesson": "Попередній урок",
          "Lesson Completed": "Урок завершено",
          "Lesson Not Completed": "Урок не завершено",
          "Email must contain @": "Електронна адреса повинна містити @",
          "Email must contain . (dot)": "Електронна адреса повинна містити . (крапку)",
          "Invalid email format (example@domain.com)": "Недійсний формат електронної пошти (example@domain.com)",
          "At least 8 characters": "Принаймні 8 символів",
          "Must contain letters": "Повинно містити літери",
          "Must contain numbers": "Має містити цифри",
          "Connecting...": "Підключення...",
          "Please wait while we establish the connection.": "Будь ласка, зачекайте, поки ми встановлюємо з'єднання.",
          "Home": "Головна",
          "Got it": "Зрозуміло",
          "Partial": "Частково",
          "Demo Limit Reached": "Ви досягли ліміт демо",
          "Demo limit reached (5/5 dialogs today). Please register to continue.": "Досягнуто ліміту демоверсій (5/5 діалогів сьогодні). Будь ласка, зареєструйтесь, щоб продовжити.",
          "Loading subscription details...": "Завантаження деталей підписки...",
          "No videos found": "Видео не знайдені",
          "AI-powered English platform": "Платформа для вивчення англійської мови з AI",
          "Learn English with": "Вивчайте англійську за допомогою",
          "real-life videos": "відео з реального життя",
          "and AI practice": "та практики з AI",
          "Choose a short lesson, create a personal plan, or learn at your own pace.": "Оберіть короткий урок, створіть персональний план або навчайтеся у власному темпі.",
          "Video": "Відео",
          "Words": "Слова",
          "Quiz": "Тест",
          "Speaking": "Розмова",
          "Choose how to start learning": "Оберіть, як почати навчання",
          "2 minutes · No registration": "2 хвилини · Без реєстрації",
          "Try a 2-minute lesson": "Спробуйте 2-хвилинний урок",
          "Take a short real-life lesson and see how AI Lingua works — with no commitment.": "Пройдіть короткий урок із реального життя та дізнайтеся, як працює AI Lingua, без жодних зобов’язань.",
          "Start quick lesson": "Розпочати швидкий урок",
          "Recommended": "Рекомендовано",
          "Get a personal plan": "Отримайте персональний план",
          "Answer a few questions about your goal and level to receive a structured course created specifically for you.": "Дайте відповідь на кілька запитань щодо вашої цілі та рівня й отримайте структурований курс, створений спеціально для вас.",
          "Create my plan": "Створити мій план",
          "Learn without a plan": "Навчання без плану",
          "Browse videos and choose topics to practice. Learn at a time that suits you.": "Переглядайте відео та обирайте теми для практики. Навчайтеся у зручний для вас час.",
          "Browse videos": "Переглянути відео",
          "Two ways to learn": "Два способи навчання",
          "Both paths include real-life video lessons and AI speaking practice.": "Обидва формати включають відеоуроки з реального життя та практику розмови з AI.",
          "Personal Plan": "Персональний план",
          "Structured lessons in a clear order": "Структуровані уроки у зрозумілій послідовності",
          "Course based on your goal & level": "Курс відповідно до вашої цілі та рівня",
          "Level test available if you need it": "За потреби можна визначити рівень",
          "Track your progress over time": "Відстежуйте свій прогрес",
          "Switch": "Перемкнутися",
          "anytime": "можна будь-коли",
          "Learn Without a Plan": "Навчання без плану",
          "Choose any video you like": "Обирайте будь-яке відео",
          "Practice any topic freely": "Практикуйте будь-які теми",
          "No fixed order or schedule": "Без фіксованого порядку або розкладу",
          "Switch to a personal plan anytime": "Перейти до персонального плану можна будь-коли",
          "What happens after the 2-minute lesson?": "Що буде після 2-хвилинного уроку?",
          "Complete a quick demo, then choose your path forward.": "Пройдіть короткий пробний урок, а потім оберіть, як навчатися далі.",
          "Try quick lesson": "Спробуйте швидкий урок",
          "2 minutes": "2 хвилины",
          "Continue learning on my own": "Продовжити самостійне навчання",
          "Back to Home": "Повернутися на головну",
          "Trial Lesson": "Пробний урок",
          "Trial 2-minute lesson": "Пробний 2-хвилинний урок",
          "Step": "Крок",
          "of": "з",
          "What to do now": "Що робити зараз",
          "Watch the video": "Дивись відео",
          'Watch the short dialogue, then click "Next: words" to continue.': 'Перегляньте короткий діалог, а потім натисніть «Далі: слова», щоб продовжити',
          "Study the words": "Вчи слова",
          'Learn new words from the video. Then click "Next".': 'Вивчіть нові слова з відео. Потім натисніть «Далі».',
          "Далі": "Далі",
          "Check Understanding": "Перевір розуміння",
          'Check your understanding. Then click "Next".': 'Перевірте своє розуміння. Потім натисніть кнопку «Далі».',
          "Practice Dialogue": "Практикуй діалог",
          "Practice the dialogue": "Практикуйте розмову",
          "Talk to AI in English. This is the last step of the trial lesson!": "Поговоріть зі штучним інтелектом англійською. Це останній крок пробного уроку!",
          "Далі: слова": "Далі: слова",
          "Після перегляду переходьте до слів": "Після перегляду переходьте до слів",
          "Lesson steps": "Кроки уроку",
          "Watch a short real-life dialogue in English.": "Переглянь короткий діалог з реального життя англійською.",
          "Current Step": "Поточний крок",
          "Learn new words and phrases from videos in context.": "Вивчай нові слова та фрази з відео у контексті.",
          "Take a short test to check what you remember.": "Пройди короткий тест, щоб перевірити, що запам'ятав.",
          "Talk to AI in English in a real dialogue.": "Поговори з AI англійською в реальному діалозі.",
          "How does AI Lingua work?": "Як працює AI Lingua?",
          "Save progress?": "Зберегти прогрес?",
          "In the full course, each lesson has the same structure: Video → Words → Quiz → Speaking.": "У повному курсі кожен урок має таку ж структуру: Video → Words → Quiz → Speaking.",
          "Register so you don't lose your result.": "Зареєструйтесь, щоб не втратити результат",
          "Success": "Успіх",
          "You have successfully logged out.": "Ви успішно вийшли з системи.",
          "Notice": "Увага",
          "Session has already ended or is invalid.": "Сесія вже закінчена або недійсна.",
          "Error": "Помилка",
          "Failed to log out.": "Не вдалося вийти з системи.",
          "An error occurred during logout.": "Виникла помилка під час виходу з системи.",
          "Failed to add word to vocabulary": "Не вдалося додати слово до словника",
          "Failed to remove word from vocabulary": "Не вдалося видалити слово зі словника",
          "Change level: higher": "Змінити рівень: вище",
          "Change level: lower": "Змінити рівень: нижче",
          "Change learning topic": "Змінити тему навчання",
          "Study with tutor": "Займатися з викладачем",
          "Soon": "Скоро",
          "Active": "Акване",
          "Cancel": "Відмінити",
          "Upgrade": "Покращити",
          "Активна": "Активна",
          "Fill in the blanks question": "Заповніть пропуски у питанні",
          "You were on the right track but needed more precision.": "Ви були на правильному шляху, але потребували більшої точності.",
          "Choose the correct meaning of the word.": "Оберіть правильне значення слова.",
          "Profile updated successfully": "Профіль оновлено!",
          "Error saving profile": "Помилка збереження профілю",
          "Please fill in all fields": "Заповніть усі поля",
          "Passwords do not match": "Паролі не збігаються",
          "Password must be at least 8 characters": "Пароль має бути не менше 8 символів",
          "Password changed successfully": "Пароль змінено!",
          "Error changing password": "Помилка зміни паролю",
          "My profile": "Мій профіль",
          "Subscription": "Підписка",
          "Support": "Підтримка",
          "Log Out": "Вийти",
          "Personal cabinet": "Персональний кабінет",
          "Manage your profile, subscription and support requests": "Керуйте профілем, підпискою та зверненнями до підтримки.",
          "Name": "Ім'я",
          "Interface language": "Мова інтерфейсу",
          "English level": "Рівень англійської",
          "Edit profile": "Редагувати профіль",
          "Change password": "Змінити пароль",
          "No active subscription": "Немає активної підписки",
          "days remaining": "Днів залишилось",
          "Change plan": "Оновити тариф",
          "Get a plan": "Обрати тариф",
          "Write to us if you have questions about lessons, subscription or technical issues": "Напишіть нам, якщо маєте запитання щодо уроків, підписки або технічної проблеми.",
          "Subject": "Тема звернення",
          "Subscription question": "Питання щодо підписки",
          "Payment issue": "Проблема з оплатою",
          "Lesson issue": "Проблема з уроком",
          "Technical issue": "Технічна проблема",
          "Other": "Інше",
          "Message": "Повідомлення",
          "Describe your question or issue": "Опишіть ваше запитання або проблему…",
          "Send": "Надіслати",
          "Thank you": "Дякуємо!",
          "We received your request and will reply to your email": "Ми отримали ваше звернення і відповімо на вашу пошту.",
          "Report an issue": "Повідомити про проблему",
          "What is wrong with this video?": "Що не так із цим відео?",
          "Incorrect translation": "Некоректний переклад",
          "Incorrect video level": "Неправильно вказаний рівень відео",
          "Video does not work": "Відео не працює",
          "Describe the issue (optional)": "Опишіть проблему (необов'язково)",
          "Thank you! We will check this video.": "Дякуємо! Ми перевіримо це відео.",
          "Update your personal details.": "Оновіть ваші персональні дані.",
          "Email cannot be changed": "Email не може бути змінений",
          "Name cannot be changed": "Ім'я не може бути змінено",
          "Cancel": "Скасувати",
          "Save": "Зберегти",
          "Saving...": "Збереження...",
          "Enter your current and new password.": "Введіть поточний і новий пароль.",
          "Current password": "Поточний пароль",
          "New password": "Новий пароль",
          "Repeat new password": "Повторіть новий пароль",
          "Update password": "Оновити пароль",
          "Log out of account?": "Вийти з акаунта?",
          "You can return to learning after logging in again": "Ви зможете повернутися до навчання після повторного входу.",
          "Continue learning from where you left off.": "Продовжуйте навчання з того місця, де зупинилися.",
          "Enter a valid email address": "Введіть правильну адресу електронної пошти",
          "Enter your password": "Введіть пароль",
          "Forgot your password?": "Забули пароль?",
          "Don't have an account?": "Немає акаунта?",
          "What you get after registration": "Що ви отримаєте після реєстрації",
          "A course tailored to your goal and level.": "Курс відповідно до вашої цілі та рівня.",
          "Real-life lessons": "Уроки з реального життя",
          "Each lesson: Video → Words → Quiz → AI Speaking.": "Кожен урок: Відео → Слова → Тест → Розмова з AI.",
          "AI Speaking": "Розмова з AI",
          "Practice dialogues with AI based on videos.": "Практикуйте діалоги з AI на основі відео.",
          "Personal dictionary": "Особистий словник",
          "Save words you learn and review them anytime.": "Зберігайте слова з діалогів і повторюйте їх.",
          "Learning progress": "Прогрес навчання",
          "Track lessons, words, videos, and your learning streak.": "Відстежуйте уроки, слова, відео та дні навчання поспіль.",
          "Your password": "Ваш пароль",
          'Create Account': 'Створити акаунт',
          "Already have an account?": "Вже маєте акаунт?",
          "Register to save your progress and get a personal learning plan.": "Зареєструйтесь, щоб зберігати прогрес і отримати персональний план навчання.",
          "Your name": "Ваше ім'я",
          "Enter your name": "Введіть ваше ім'я",
          "Minimum 8 characters.": "Мінімум 8 символів.",
          "Password must contain at least 8 characters": "Пароль має містити щонайменше 8 символів",
          "I agree to the": "Я погоджуюсь з",
          "Terms of Use": "Умовами використання",
          "Terms of Use2": "Умовами використання",
          "and": "та",
          "Privacy Policy": "Політикою конфіденційності",
          "Privacy Policy2": "Політикою конфіденційності",
          'You must agree to the Terms of Use and Privacy Policy': 'Потрібно погодитися з Умовами використання та Політикою конфіденційності',
          'Creating account…': 'Створюємо аккаунт…',
          'Logging in…': 'Входимо…',
          "Created based on your goal and level": "Створено відповідно до вашої цілі та рівня",
          "lessons": "уроків",
          "hours": "годин",
          "Manage plan": "Керувати планом",
          "Course completed": "Курсу пройдено",
          "Lessons completed": "Завершено уроків",
          "Lessons remaining": "Уроків залишилося",
          "Day streak": "Днів підряд",
          "Lesson": "Урок",
          "You stopped at the step": "Ви зупинилися на кроці",
          "We will return you to where you left off.": "Ми повернемо вас до місця, де ви зупинилися.",
          "Learning path": "Навчальний шлях",
          "The next lesson unlocks after you pass the previous one.": "Наступний урок відкривається після зарахування попереднього.",
          "Repeat": "Повторити",
          "Blocked": "Заблоковано",
          "Continue": "Продовжити",
          "You are here": "Ви тут",
          "Complete lesson": "Пройдіть урок",
          "Would you like to learn without a fixed plan?": "Хочете навчатися без фіксованого плану?",
          "Go to self-study": "Перейти до самостійного навчання",
          "Available after completing the lesson": "Доступний після проходження уроку",
          "Quiz progress": "Прогрес тесту",
          "Score": "Бал",
          "Type": "Тип",
          "Lesson steps": "Кроки уроку",
          "completed": "завершено",
          "in progress": "в процесі",
          "next": "далі",
          "Fill in the blank": "Заповніть пропуск",
          "Word meaning": "Значення слова",
          "True / False": "Правда / Хибно",
          "Open Answer": "Відкрита відповідь",
          "Build the phrase": "Складіть фразу",
          "Choose the word that correctly completes the sentence.": "Оберіть слово, яке правильно доповнює речення.",
          "Choose the correct meaning of the word.": "Оберіть правильне значення слова.",
          "Determine if the statement is correct.": "Визначте, чи твердження правильне.",
          "Answer the question.": "Дайте відповідь на запитання.",
          "Tap the words in the correct order to build the English phrase.": "Натисніть слова у правильному порядку, щоб скласти англійську фразу.",
          "Tap the words below to build the phrase.": "Натисніть слова нижче, щоб скласти фразу.",
          "Your phrase": "Ваша фраза",
          "Check phrase": "Перевірити фразу",
          "Checking...": "Перевірка...",
          "Clear": "Очистити",
          "Correct!": "Правильно!",
          "Not quite": "Не зовсім",
          "Correct answer": "Правильна відповідь",
          "Finish quiz": "Завершити тест",
          "Next question": "Наступне питання",
          "Choose an answer": "Оберіть відповідь",
          "means": "означає",
          "Submit answer": "Надіслати відповідь",
          "Great job!": "Чудова робота!",
          "Try rearranging the words in a different order.": "Спробуйте розташувати слова в іншому порядку.",
          "Try to review the video material again.": "Спробуйте ще раз переглянути відеоматеріал.",
          "No questions available.": "Немає доступних питань.",
          "reportProblemText": "Проблема з уроком? Повідомити",
          "Personal learning plans with level-based progress.": "Персональні навчальні плани з прогресом за рівнями.",
          "Would you like more structure?": "Хочете більше структури?",
          "A personal plan will help you complete lessons in the right order and track your progress by level.": "Персональний план допоможе проходити уроки у правильному порядку та бачити прогрес за рівнями.",
          "Create plan": "Створити план",
          "Self-study will remain available": "Самостійне навчання залишиться доступним",
          "Start": "Почати",
          "AI says": "AI говорить",
          "Repeat the phrases from the video. AI will check your pronunciation and the content of your answer.": "Повторіть фрази з відео. AI перевірить вашу вимову та зміст відповіді.",
          "Finish lesson": "Завершити урок",
          "Your answer": "Ваша відповідь",
          "Record answer": "Записати відповідь",
          "Click to start recording": "Натисніть, щоб почати запис",
          "Try saying:": "Спробуйте сказати:",
          "Plans tailored to your needs": "Плани, що відповідають вашим потребам",
          "Choose your learning plan": "Оберіть план для вашого навчання",
          "Start for free, unlock full access to lessons, or choose AI Lingua for your team.": "Почніть безкоштовно, отримайте повний доступ до уроків або підключіть AI Lingua для команди.",
          "Most popular": "Найпопулярніший",
          "For individual learning": "Для індивідуального навчання",
          "UAH / month": "грн / місяць",
          "billed monthly": "оплата щомісячна",
          "Personal learning plan": "Персональний план навчання",
          "All video lessons": "Усі відеоуроки",
          "2-minute trial lesson": "Пробний 2-хвилинний урок",
          "Limited access to video lessons": "Обмежений доступ до відеоуроків",
          "Add words to dictionary": "Додавання слів у словник",
          "Basic progress saving": "Базове збереження прогресу",
          "AI Speaking — limited": "Розмова з AI — обмежено",
          "Personal plan — unavailable": "Персональний план — недоступний",
          "Full catalog — unavailable": "Повний каталог — недоступний",
          "AI dialogue practice": "Практика діалогів з AI",
          "Personal dictionary": "Особистий словник",
          "Progress saving": "Збереження прогресу",
          "Review completed lessons": "Повторення пройдених уроків",
          "Self-study without a plan": "Самостійне навчання без плану",
          "Saved videos and statistics": "Обрані відео та статистика",
          "To try the platform": "Щоб спробувати платформу",
          "UAH": "грн",
          "free forever": "безкоштовно назавжди",
          "Start for free": "Почати безкоштовно",
          "For companies, schools, and universities": "Для компаній, шкіл та університетів",
          "Custom pricing": "Індивідуальна ціна",
          "tailored to your team's needs": "відповідно до потреб вашої команди",
          "All Premium features": "Усі можливості Premium",
          "Access for a group of users": "Доступ для групи користувачів",
          "Each learner's progress": "Прогрес кожного учня",
          "Admin reports": "Звіти для адміністратора",
          "Learning tailored to company goals": "Навчання відповідно до цілей компанії",
          "Dedicated manager support": "Підтримка менеджера",
          "Volume discounts": "Знижки залежно від кількості користувачів",
          "Contact us": "Зв'язатися з нами",
          "Subscribe": "Оформити підписку",
          "Renew subscription": "Поновити підписку",
          "Plan comparison": "Порівняння планів",
          "Feature": "Функція",
          "Group access": "Груповий доступ",
          "Admin reports": "Звіти для адміністратора",
          "Dedicated manager support": "Підтримка менеджера",
          "limited": "обмежено",
          "basic": "базовий",
          "Frequently asked questions": "Часті запитання",
          "Can I start for free?": "Чи можна почати безкоштовно?",
          "What is included in Premium?": "Що входить у Premium?",
          "Can I cancel my subscription?": "Чи можна скасувати підписку?",
          "What is Business?": "Що таке Business?",
          "Will my progress be saved after changing plans?": "Чи збережеться прогрес після зміни тарифу?",
          "Yes. You can try the platform for free and take a trial lesson. Registration does not require payment.": "Так, ви можете спробувати платформу безкоштовно та пройти пробний урок. Для реєстрації не потрібна оплата.",
          "Premium includes a personal plan, all video lessons, AI speaking practice, a dictionary, progress saving, and detailed learning statistics.": "Premium відкриває персональний план, усі відеоуроки, розмовну практику з AI, словник, збереження прогресу та детальну статистику навчання.",
          "Yes. You can cancel your subscription at any time in your account. Access will remain active until the end of the paid period.": "Так, підписку можна скасувати в будь-який момент в особистому кабінеті. Доступ збережеться до кінця оплаченого періоду.",
          "Business offers custom terms for companies, schools, and universities, including group access, reports, and dedicated manager support.": "Business — це індивідуальні умови для компаній, шкіл та університетів: груповий доступ, звіти й підтримка менеджера.",
          "Yes. Your progress is saved in your account regardless of your plan.": "Так, ваш прогрес зберігається в акаунті незалежно від тарифного плану.",
          "Choose any videos, complete lessons at your own pace, and practice speaking with AI": "Обирайте будь-які відео, проходьте уроки у власному темпі та практикуйте розмову з AI.",
          "There is no fixed order in this mode — you choose what to learn.": "У цьому режимі немає фіксованого порядку — ви самі обираєте, що вивчати.",
          "Would you like a structured learning plan?": "Хочете навчатися за структурованим планом?",
          "Get a personal plan tailored to your goal and level": "Отримайте персональний план відповідно до вашої цілі та рівня",
          "Learn with a teacher": "Займатися з викладачем",
          "A teacher will help you practice words, pronunciation, and video dialogues.": "Викладач допоможе розібрати слова, вимову та діалоги з відео.",
          "Search videos": "Пошук відео",
          "Level": "Рівень",
          "All": "Усі",
          "Topics": "Теми",
          "Clear filters": "Скинути фільтри",
          "This is self-study: you choose the videos yourself. To follow a structured path, create a personal plan.": "Це самостійне навчання: ви самі обираєте відео. Якщо хочете навчатися за планом, створіть персональний план.",
          "No video found. Try changing filters.": "Відео не знайдено. Спробуйте змінити фільтри.",
          "Watch a short real-life dialogue, then move on to the words.": "Перегляньте короткий діалог з реального життя, а потім перейдіть до слів.",
          "Practice dialogue": "Практикувати розмову",
          "Add words from the lesson and review them.": "Додавайте слова з уроку та повторюйте їх.",
          'Learn new words from the video, then click "Next".': "Вивчіть нові слова з відео, потім натисніть «Далі».",
          'Check your understanding, then click "Next."': 'Перевірте своє розуміння, потім натисніть «Далі».',
          "Speak to AI in English. This is the last step of the lesson!": "Розмовляйте з AI англійською. Це останній крок уроку!",
          "Next: Quiz": "Далі: Quiz",
          "Next: Words": "Далі: Words",
          "Next: Speaking": "Далі: Speking",
          "Save progress": "Зберегти прогрес",
          "Practice dialogue": "Практикувати розмову",
          "Recommended order: Video → Words → Quiz → Speaking. Complete the steps in order.": "Рекомендований порядок: Video → Words → Quiz → Speaking. Проходьте кроки по черзі.",
          "words": "слів",
          "My dictionary": "Мій словник",
          "Add words from the lesson and review them.": "Додавайте слова з уроку та повторюйте їх.",
          "Open": "Відкрити",
          "Video transcript": "Текст з відео",
          "Click an underlined word to see its translation and an example, and add it to your dictionary.": "Натисніть на підкреслене слово, щоб побачити переклад, приклад і додати його у словник.",
          "from this lesson": "з цього уроку",
          "from the entire course": "з усього курсу",
          "No results found": "Нічого не знайдено",
          "Try another word or change the filter.": "Спробуйте інше слово або змініть фільтр.",
          "Search for a word...": "Пошук слова...",
          "Words you added during lessons.": "Слова, які ви додали під час уроків.",
          "Back to transcript": "Назад до тексту",
          "All from course": "Всі з курсу",
          "From this lesson": "З цього уроку",
          "All self-study words": "Всі слова вивчені самостійно",
          "From this video": "З цього відео",
          "Click the bookmark to save the word": "Натисніть на закладку, щоб зберегти слово",
          "In dictionary": "У словнику",
          "No transcript available for this lesson.": "Немає транскрипції для цього уроку.",
          "Translation not available": "Переклад відсутній",
          "Example not available": "Приклад відсутній",
          "Explanation not available": "Пояснення відсутнє",
          "Error fetching data": "Помилка при запиті",
          "Translation": "Переклад",
          "Listen to word": "Прослухати слово",
          "Remove from dictionary": "Прибрати зі словника",
          "Add to dictionary": "Додати у словник",
          "Close": "Закрити",
          "Translation language": "Мова перекладу",
          "Current lesson": "Поточний урок",
          "Another lesson": "Інший урок",
          "CSRF token is missing": "CSRF токен відсутній",
          "Failed to receive data": "Не вдалося отримати дані",
          "Search words in section": "Пошук слів у розділі",
          "Loading...": "Завантаження...",
          "It": "Воно",
          "Search word...": "Шукай слово...",
          "Take a short 10-question quiz to check what you remember from the video.": "Пройдіть короткий тест із 10 питань, щоб перевірити, що ви запам’ятали з відео.",
          "10 questions": "10 питань",
          "3 question types": "3 типи завдань",
          "3–5 minutes": "3–5 хвилин",
          "What the quiz includes": "Що буде в тесті",
          "Word meaning": "Значення слова",
          "Choose the meaning of a word or phrase.": "Оберіть значення слова або фрази.",
          "\"from\" means \"from\" or \"because\"": "\"from\" означає \"з\" чи \"бо\"",
          "Fill in the blank": "Заповніть пропуск",
          "Fill in the missing word.": "Вставте пропущене слово.",
          "\"My ___ is Anna.\"": "\"My ___ is Anna.\"",
          "Build the phrase": "Складіть фразу",
          "Build the English phrase from the given words.": "Складіть англійську фразу з готових слів.",
          "\"Check, please\" → Check / please / Card": "«Рахунок, будь ласка» → Check / please / Card",
          "Start quiz": "Почати тест",
          "The quiz includes several question types and will take a few minutes.": "Тест містить різні типи завдань і займе кілька хвилин.",
          "Choose the correct meaning of the word.": "Оберіть правильне значення слова.",
          "means": "означає",
          "Choose the word that correctly completes the sentence.": "Оберіть слово, яке правильно доповнює речення.",
          "Tap the words in the correct order to build the English phrase.": "Натисніть слова у правильному порядку, щоб скласти англійську фразу.",
          "Your phrase": "Ваша фраза",
          "Tap the words below to build the phrase.": "Натисніть слова нижче, щоб скласти фразу.",
          "Words": "Слова",
          "Clear": "Очистити",
          "Checking...": "Перевірка...",
          "Check phrase": "Перевірити фразу",
          "True / False": "Правда / Хибно",
          "Determine if the statement is correct.": "Визначте, чи твердження правильне.",
          "Open Answer": "Відкрита відповідь",
          "Answer the question.": "Дайте відповідь на запитання.",
          "Type your answer here...": "Введіть відповідь тут...",
          "Submit answer": "Надіслати відповідь",
          "Correct!": "Правильно!",
          "Not quite": "Не зовсім",
          "Correct answer": "Правильна відповідь",
          "Great job!": "Чудова робота!",
          "Try rearranging the words in a different order.": "Спробуйте розташувати слова в іншому порядку.",
          "Try to review the video material again.": "Спробуйте ще раз переглянути відеоматеріал.",
          "Finish quiz": "Завершити тест",
          "Next question": "Наступне питання",
          "Choose an answer": "Оберіть відповідь",
          "Review mode": "Режим перегляду",
          "Back to current": "Повернутися до поточного",
          "No questions available.": "Немає доступних питань.",
          "Replay": "Повторити",
          "Slower": "Повільніше",
          "Translate": "Перекласти",
          "Save your progress!": "Збережіть свій прогрес!",
          "Save your progress": "Збережіть свій прогрес",
          "You are currently learning as a guest. Create a free account to save learned words, completed lessons, and your personal plan.": "Ви зараз навчаєтеся як гість. Створіть безкоштовний акаунт, щоб зберегти вивчені слова, пройдені уроки та персональний план.",
          "Personal account": "Особистий кабінет",
          "Personal plan": "Персональний план",
          "Progress saving": "Збереження прогресу",
          "Register for free": "Зареєструватися безкоштовно",
          "Continue as guest": "Продовжити як гість",
          "Creating your personal plan": "Створення персонального плану",
          "This will take less than 1 minute. Your answers will help us create the right plan.": "Це займе менше ніж 1 хвилину. Ваші відповіді допоможуть створити відповідний план.",
          "Step {{step}} of {{total}}": "Крок {{step}} з {{total}}",
          "Which language would you like to use for the interface?": "Якою мовою показувати інтерфейс?",
          "Choose the interface language for learning.": "Оберіть мову інтерфейсу для навчання.",
          "Back": "Назад",
          "Why are you learning English?": "Для чого ви вивчаєте англійську?",
          "We will select lesson topics based on your goal.": "Ми підберемо теми уроків відповідно до вашої цілі.",
          "Airport, hotel, café, and meeting people abroad.": "Аеропорт, готель, кафе, знайомства за кордоном.",
          "Job interviews, meetings, correspondence, and workplace dialogues.": "Співбесіди, зустрічі, листування, робочі діалоги.",
          "Educational topics, explanations, and academic vocabulary.": "Освітні теми, пояснення, академічна лексика.",
          "Socializing": "Спілкування",
          "Small talk, meeting people, and everyday conversations.": "Small talk, знайомства, щоденні розмови.",
          "Everyday topics, hobbies, and light practice.": "Теми з життя, хобі та легка практика.",
          "Choose the level to start learning.": "Оберіть рівень, з якого почати навчання.",
          "Loading levels...": "Завантаження рівнів...",
          "Failed to load levels. Please try again.": "Не вдалося завантажити рівні. Спробуйте ще раз.",
          "Not sure? Choose an approximate level — you can change it later.": "Не впевнені? Оберіть приблизний рівень — його можна змінити пізніше.",
          "Failed to save results. Please try again.": "Не вдалося зберегти результати. Спробуйте ще раз.",
          "Your personal plan is ready": "Ваш персональний план готовий",
          "We created a course based on your goal and level.": "Ми створили курс відповідно до вашої цілі та рівня.",
          "Goal": "Ціль",
          "Start first lesson": "Почати перший урок",
          "Change answers": "Змінити відповіді",
          "You can change the level or learning topic later in the plan settings.": "Ви зможете змінити рівень або тему навчання пізніше в налаштуваннях плану.",
          "Study": "Навчання",
          "For yourself": "Для себе",
          "Create an account to save words, videos, and personal plans.": "Створіть акаунт, щоб зберігати слова, відео та персональні плани.",
          "In the full course, every lesson follows the same structure: Video → Words → Quiz → AI Speaking.": "У повному курсі кожен урок має таку саму структуру: Відео → Слова → Тест → Розмова з AI.",
          "Great job! You completed the trial lesson.": "Ви блискуче пройшли пробний урок!",
          "Now choose how you would like to continue learning.": "Тепер оберіть, як хочете навчатися далі.",
          "We will create a course based on your goal, level, and learning pace.": "Ми створимо курс відповідно до вашої цілі, рівня та темпу навчання.",
          "If you do not know your level, we will offer a short test while creating your plan.": "Якщо ви не знаєте свій рівень, ми запропонуємо короткий тест під час створення плану.",
          "You can switch between these modes later.": "Ви завжди зможете перейти між цими режимами пізніше.",
          "Payment successful!": "Оплата успішна!",
          "Your Premium plan has been activated. All AI Lingua features are now available.": "Ваш тариф Premium активовано. Тепер вам доступні всі можливості AI Lingua.",
          "Subscription details": "Деталі підписки",
          "Plan": "Тариф",
          "Active": "Активна",
          "Amount": "Сума",
          "299 UAH / month": "299 грн / міс",
          "Next charge": "Наступне списання",
          "Payment method": "Оплата",
          "Account2": "Кабінет",
          "Manage": "Керувати",
          "How would you like to start learning?": "Як хочете почати навчання?",
          "Choose a convenient format: a personal plan or self-study with videos.": "Оберіть зручний формат: персональний план або самостійне навчання з відео.",
          "Recommended": "Рекомендовано",
          "Get a personal plan": "Отримати персональний план",
          "Create a course based on your goal and level. We will select the lessons and their order.": "Створіть курс під вашу ціль і рівень. Ми підберемо уроки та порядок навчання.",
          "This will take less than 1 minute": "Це займе менше 1 хвилини",
          "Create my plan": "Створити мій план",
          "Learn without a plan": "Навчатися без плану",
          "Choose any videos and practice at your own pace without a fixed order.": "Обирайте будь-які відео та практикуйтеся у власному темпі без фіксованого порядку.",
          "You can create a plan later at any time.": "Ви завжди зможете створити план пізніше.",
          "Go to all videos": "Перейти до всіх відео",
          "You can switch between these modes at any time.": "Ви зможете перемикатися між цими режимами в будь-який момент.",
          "What is available now": "Що тепер доступно",
          "Personal plan": "Персональний план",
          "A course based on your goal and level.": "Курс під вашу ціль і рівень.",
          "All video lessons": "Усі відеоуроки",
          "Full video catalog without limits.": "Повний каталог відео без обмежень.",
          "Practice dialogues with AI.": "Практикуйте діалоги з AI.",
          "Personal dictionary": "Особистий словник",
          "Save words and review them.": "Зберігайте слова та повторюйте.",
          "Learning progress": "Прогрес навчання",
          "Lessons, words, videos, and streak.": "Уроки, слова, відео та streak.",
          "Self-study": "Самостійне навчання",
          "Any videos without a plan.": "Будь-які відео без плану.",
          "Questions about payment?": "Питання щодо оплати?",
          "Contact support": "Зв'язатися з підтримкою",
          "All rights reserved.": "Усі права захищені.",
          "Terms of Use": "Умови використання",
          "Privacy Policy": "Політика конфіденційності",
          "Refund policy": "Політика повернення коштів",
          "Manage subscription": "Керувати підпискою",
          "Payment failed": "Оплата не пройшла",
          "We could not activate Premium. Check your payment details or try another method.": "Не вдалося активувати Premium. Перевірте дані оплати або спробуйте інший спосіб.",
          "If you were charged, contact support — we will help.": "Якщо кошти були списані, зверніться до підтримки — ми допоможемо.",
          "Payment attempt details": "Деталі спроби оплати",
          "Attempt": "Спроба",
          "Not paid": "Не оплачено",
          "Reason: the payment was not confirmed by the bank": "Причина: платіж не підтверджено банком",
          "Try again": "Спробувати ще раз",
          "Choose another payment method": "Обрати інший спосіб оплати",
          "Return to pricing": "Повернутися до тарифів",
          "What could have happened?": "Що могло статися?",
          "Insufficient funds on the card": "Недостатньо коштів на картці",
          "The bank declined the payment": "Банк відхилив платіж",
          "Incorrect card details": "Неправильні дані картки",
          "Payment confirmation was not completed (3D Secure)": "Не пройдено підтвердження оплати (3D Secure)",
          "Temporary payment system error": "Тимчасова помилка платіжної системи",
          "Need help?": "Потрібна допомога?",
          "Contact us if the payment fails again or if you were charged.": "Напишіть нам, якщо оплата не проходить повторно або якщо кошти були списані.",
          "Continue without Premium": "Продовжити без Premium",
          "Support request": "Звернення до підтримки",
          "Describe the payment issue and we will help.": "Опишіть проблему з оплатою, і ми допоможемо.",
          "Subject: Payment issue": "Тема: Проблема з оплатою",
          "Describe what happened with the payment…": "Опишіть, що сталося з оплатою…",
          "Thank you! We received your request.": "Дякуємо! Ми отримали звернення.",
          "Password recovery": "Відновлення пароля",
          "Enter your email, and we will send password recovery instructions.": "Введіть email, і ми надішлемо інструкції для відновлення пароля.",
          "We will send an email if an account with this email exists.": "Ми надішлемо лист, якщо акаунт із таким email існує.",
          "Send instructions": "Надіслати інструкції",
          "Return to login": "Повернутися до входу",
          "Sending...": "Надсилаємо...",
          "Quiz progress": "Прогрес тесту",
          "Question": "Питання",
          "Result": "Результат",
          "Type": "Тип",
          "Review this question": "Переглянути це питання",
          "Lesson steps": "Кроки уроку",
          "Video": "Відео",
          "completed": "завершено",
          "Words": "Слова",
          "Quiz": "Тест",
          "in progress": "в процесі",
          "Speaking": "Розмова",
          "next": "далі",
          "Quiz completed!": "Тест завершено!",
          "Great job! You checked your understanding of the video.": "Чудова робота! Ви перевірили своє розуміння відео.",
          "Continue to Speaking": "Продовжити до Speaking",
          "Review answers": "Переглянути відповіді",
          "Result": "Результат",
          "Review this question": "Переглянути це питання",
          "Almost correct": "Майже правильно",
          "Build the English phrase from the given words. Click the words in the correct order.": "Складіть англійську фразу з готових слів. Натискайте слова у правильному порядку.",
          "Click the words below to build the phrase.": "Натисніть слова нижче, щоб скласти фразу.",
          "Correct answer:": "Правильна відповідь:",
          "Congratulations! Your account has been created": "Вітаємо! Ваш акаунт створено",
          "Congratulations,": "Вітаємо,",
          "Your account has been created": "Ваш акаунт створено",
          "Your progress, dictionary, and learning plans will now be saved in your account.": "Тепер ваш прогрес, словник і навчальні плани будуть зберігатися в акаунті.",
          "Choose how you would like to start learning.": "Оберіть, як хочете почати навчання.",
          "How would you like to learn?": "Як хочете навчатися?",
          "You can start with a structured plan or choose videos yourself.": "Можете почати зі структурованого плану або обирати відео самостійно.",
          "Structured lesson path": "Структурований шлях уроків",
          "Progress and results are saved": "Прогрес і результати зберігаються",
          "Any topic": "Будь-яка тема",
          "No fixed order": "Без фіксованого порядку",
          "You can switch to a plan later": "Можна перейти до плану пізніше",
          "You can change the mode later.": "Ви можете змінити режим пізніше.",
          "If you start without a plan, you can create a personal course at any time.": "Якщо почнете без плану, зможете створити персональний курс у будь-який момент.",
          "If you create a plan, you can still watch videos independently.": "Якщо створите план, зможете також дивитися відео самостійно.",
          "Great job! Lesson passed": "Чудова робота! Урок зараховано",
          "You did a great job — the next lesson is now unlocked.": "Ви чудово впоралися — наступний урок уже відкрито.",
          "One more step toward confident English.": "Ще один крок до впевненої англійської.",
          "Required to pass:": "Потрібно для зарахування:",
          "Passed": "Пройдено",
          "Next lesson unlocked": "Наступний урок відкрито",
          "Go": "Перейти",
          "Watched": "Переглянуто",
          "Learned words": "Вивчені слова",
          "All words from this lesson dialogue.": "Усі слова з діалогу цього уроку.",
          "Words in dictionary": "Слова у словнику",
          "Words added to your dictionary.": "Слова, додані до вашого словника.",
          "Return to plan": "Повернутися до плану",
          "Was this lesson useful?": "Чи був цей урок корисним?",
          "Almost there!": "Майже вийшло!",
          "To pass the lesson, you need to meet two requirements. See what to repeat.": "Щоб зарахувати урок, потрібно виконати дві умови. Подивіться, що потрібно повторити.",
          "Not passed": "Не пройдено",
          "You need at least": "Потрібно мінімум",
          "correct answers": "правильних відповідей",
          "You need": "Потрібно",
          "correct replies": "правильних реплік",
          "Repeat quiz": "Повторити тест",
          "Repeat AI Speaking": "Повторити розмову з AI",
          "Return to course": "Повернутися до курсу",
          "That is okay!": "Це нормально!",
          "Repetition is the best way to remember. Repeat the required steps, and the lesson will be passed.": "Повторення — найкращий спосіб запам'ятати. Пройдіть те, що потрібно повторити, і урок буде зараховано.",
          // Course Complete
          "Congratulations! Course completed": "Вітаємо! Курс завершено",
          "You successfully completed Travel English A0 → A1 and took a big step towards confident English.": "Ви успішно пройшли Travel English A0 → A1 і зробили великий крок до впевненої англійської.",
          "This is not the end — it is a new level of your English.": "Це не фінал — це новий рівень вашої англійської.",
          "Average score": "Середній бал",
          "Dialogues": "Діалогів",
          "Days": "Днів",
          "What next?": "Що далі?",
          "Raise level": "Підвищити рівень",
          "Continue Travel English at A1 → A2. New topics, vocabulary, and speaking.": "Продовжте Travel English на рівні A1 → A2. Нові теми, лексика та speaking.",
          "Start A1 → A2": "Почати A1 → A2",
          "Learn a new topic": "Вивчати нову тему",
          "Choose another area: work, study, socializing, or something new.": "Оберіть інший напрям: робота, навчання, спілкування або щось нове.",
          "Choose a topic": "Обрати тему",
          "Watch something interesting": "Подивитися щось цікаве",
          "Browse videos on different topics and practice without a plan at your own pace.": "Переглядайте відео на різні теми та практикуйтеся без плану — у своєму темпі.",
          "Choose a video": "Обрати відео",
    
          // Create Course
          "What would you like to learn next?": "Що хочете вивчати далі?",
          "Choose a topic and level for the new course. Completed courses will remain in your account.": "Оберіть тему та рівень для нового курсу. Завершені курси залишаться у вашому кабінеті.",
          "Which topic would you like to study?": "Яку тему хочете вивчати?",
          "We will select lessons based on your new learning area.": "Ми підберемо уроки відповідно до нового напряму навчання.",
          "Socializing": "Спілкування",
          "Small talk, meeting people, and everyday conversations.": "Small talk, знайомства, щоденні розмови.",
          "For yourself": "Для себе",
          "Everyday topics, hobbies, and light practice.": "Теми з життя, хобі та легка практика.",
          "News & Tech": "News & Tech",
          "Current topics, technology, news, and discussions.": "Сучасні теми, технології, новини та обговорення.",
          "Doctor visits, wellbeing, pharmacy, and basic situations.": "Лікар, самопочуття, аптека, базові ситуації.",
          "Plans, weekends, leisure, and meetings.": "Плани, вихідні, розваги та зустрічі.",
          "Which level should this course start from?": "З якого рівня почати цей курс?",
          "Choose a level — you can change it later in the course settings.": "Оберіть рівень — його можна змінити пізніше в налаштуваннях курсу.",
          "Not sure? Choose an approximate level — you can change it later in the course settings.": "Не впевнені? Оберіть приблизний рівень — його можна змінити пізніше в налаштуваннях курсу.",
          "New course": "Новий курс",
          "Topic": "Тема",
          "Approximately": "Орієнтовно",
          "18 lessons": "18 уроків",
          "The course will be added to “My courses”. Completed courses will remain available.": "Курс буде додано до «Мої курси». Завершені курси залишаться доступними.",
          "Failed to create course. Please try again.": "Не вдалося створити курс. Спробуйте ще раз.",
          "Create course": "Створити курс",
          "Click underlined words in the text to see their translation and add them to your dictionary.": "Натискайте на підкреслені слова в тексті, щоб побачити переклад і додати їх до словника.",
          "Explanation": "Пояснення",
          "Your answer sounds good.": "Відповідь звучить добре.",
          "Accepted": "Зараховано",
          "Stop": "Зупинити",
          "Report an issue": "Повідомити про проблему",
          "Choose what needs to be checked.": "Оберіть, що саме потрібно перевірити.",
          "Issue with the video": "Проблема з відео",
          "Issue with the word": "Проблема зі словом",
          "Issue with the question": "Проблема із завданням",
          "Issue with AI Speaking": "Проблема з розмовою з AI",
          "Other issue": "Інша проблема",
          "What exactly is wrong?": "Що саме не так?",
          "Video does not load": "Відео не завантажується",
          "Video does not play": "Відео не відтворюється",
          "No sound": "Немає звуку",
          "Subtitles are not displayed": "Субтитри не відображаються",
          "Incorrect subtitles": "Некоректні субтитри",
          "Incorrect translation": "Некоректний переклад",
          "Translation is not displayed": "Переклад не відображається",
          "Incorrect explanation": "Некоректне пояснення",
          "Incorrect example": "Некоректний приклад",
          "Audio does not work": "Не працює озвучення",
          "Incorrect question": "Некоректне питання",
          "Incorrect answer marked as correct": "Некоректна правильна відповідь",
          "Incorrect answer options": "Некоректні варіанти відповіді",
          "Translation error": "Помилка в перекладі",
          "Question does not work": "Завдання не працює",
          "Voice recording does not work": "Не працює запис голосу",
          "Recording does not stop": "Не зупиняється запис",
          "Recording does not play": "Не відтворюється запис",
          "AI incorrectly recognized": "AI неправильно розпізнав",
          "AI incorrectly assessed": "AI некоректно оцінив",
          "Incorrect hint": "Некоректна підказка",
          "Technical error": "Технічна помилка",
          "Page does not load": "Сторінка не завантажується",
          "Something is displayed incorrectly": "Щось відображається некоректно",
          "Which word?": "Яке слово?",
          "Type the word…": "Впишіть слово…",
          "Question text": "Текст питання",
          "Describe or type the question…": "Опишіть або впишіть питання…",
          "AI phrase": "Фраза AI",
          "Type the phrase…": "Впишіть фразу…",
          "Comment — optional": "Коментар — необов'язково",
          "Describe what needs to be fixed…": "Опишіть, що саме потрібно виправити…",
          "We received your report and will investigate the issue.": "Ми отримали повідомлення та перевіримо проблему.",
          "Lesson": "Урок",
          "Continue self-study from where you left off.": "Продовжуйте самостійне навчання з того місця, де зупинилися.",
          "Start learning": "Почніть навчання",
          "Pick a lesson to start with": "Оберіть перший урок",
          "Browse the video catalog and choose a topic": "Перегляньте каталог відео та оберіть тему",
          "Go to videos": "Перейти до відео",
          "Videos you've added to your account.": "Відео, які ви додали до свого кабінету.",
          "No videos in progress": "Немає відео в процесі",
          "No completed videos": "Немає завершених відео",
          "No favorite videos": "Немає улюблених відео",
          "No added videos": "Немає доданих відео",
          "Like": "Подобається",
          "Dislike": "Не подобається",
          "Remove from my videos": "Видалити з моїх відео",
          "Remove video from cabinet?": "Видалити відео з кабінету?",
          "The video will be removed from the 'My videos' section. You can find it again on the 'All videos' page.": "Відео буде видалено з розділу «Мої відео». Ви зможете знайти його знову на сторінці «Усі відео».",
          "Cancel": "Скасувати",
          "Delete": "Видалити",
          "Total lessons": "Всього уроків",
          "Completed lessons": "Завершених уроків",
          "Choose the level for the next course. We will change your current plan.": "Оберіть рівень наступного курсу. Ми змінимо ваш поточний план.",
          "Current course": "Поточний курс",
          "Not sure? Take a short test": "Не впевнені? Пройдіть короткий тест",
          "Change level": "Змінити рівень",
          "Choose a course that better matches your current level. We will change your current plan.": "Оберіть курс, який краще відповідає вашому поточному рівню. Ми змінимо ваш поточний план.",
          "Choose a new topic": "Оберіть нову тему",
          "We will change the goal of your current course.": "Ми змінимо ціль вашого поточного курсу.",
          "Next: choose level": "Далі: обрати рівень",
          "Which level to start from?": "З якого рівня почати?",
          "Choose a level for the new topic.": "Оберіть рівень для нової теми.",
          "Not sure? Take a test": "Не впевнені? Пройдіть тест",
          "Updated plan": "Оновлений план",
          "Your progress on the current course will be saved, only the topic/level of the plan will change.": "Ваш прогрес по поточному курсу збережеться, зміниться лише тема/рівень плану.",
          "Change course": "Змінити курс",
          "All self-learned words": "Усі самостійно вивчені слова",
          "Back to text": "Повернутися до тексту",
          "Confirming your email…": "Підтверджуємо вашу пошту…",
          "This will only take a moment": "Це займе лише мить",
          "Email confirmed": "Пошту підтверджено",
          "You're signed in, taking you to the app…": "Ви увійшли в акаунт, переходимо до застосунку…",
          "Continue to the app": "Перейти до застосунку",
          "Sign in to start learning": "Увійдіть, щоб почати навчання",
          "Sign in": "Увійти",
          "This link doesn't work": "Це посилання не працює",
          "The link is broken or has expired – request a new confirmation email and try again":
          "Посилання пошкоджене або термін його дії минув – запросіть новий лист для підтвердження та спробуйте ще раз",
          "Back to home": "На головну",
        },
      },
      pl: {
        translation: {
          welcome: "Witamy! Wybierz swój język:",
          level: "Jaki jest Twój poziom angielskiego?",
          purpose: "Dlaczego uczysz się angielskiego?",
          videos: "Oto kilka filmów dla Ciebie:",
          register: "Zarejestruj się, aby kontynuować",
          options: {
            beginner: "Jeszcze nic nie wiem",
            elementary: "Podstawowy",
            intermediate: "Średnio zaawansowany",
            advanced: "Zaawansowany",
            travel: "Przygotowanie do podróży",
            job: "Na rozmowy kwalifikacyjne",
            education: "Cele edukacyjne",
            communication: "Aby komunikować się z ludźmi",
            fun: "Dla zabawy",
          },
          aboutUs: "O nas",
          contact: "Kontakt",
          services: "Usługi",
          blog: "Blog",
          catalog: "Katalog",
          buyNow: "Kup teraz",
          addToCart: "Dodaj do koszyka",
          checkout: "Zamówienie",
          totalPrice: "Łączna cena",
          search: "Szukaj",
          enterYourEmail: "Wpisz swój email",
          subscribe: "Subskrybuj",
          latestNews: "Najnowsze wiadomości",
          readMore: "Czytaj więcej",
          sendMessage: "Wyślij wiadomość",
          name: "Imię",
          email: "Email",
          message: "Wiadomość",
          submit: "Prześlij",
          loading: "Ładowanie...",
          "Loading...": "Ładowanie...",
          success: "Sukces!",
          error: "Wystąpił błąd. Spróbuj ponownie.",
          signin: "Zaloguj się",
          "Password": "Hasło",
          forgotpassword: "Zapomniałeś hasła",
          oro: "lub",
          account: "Nie masz konta?",
          register: "Rejestracja",
          login: "Zaloguj się",
          loading: "Ładowanie",
          signup: "Rejestracja",
          username: "Nazwa użytkownika",
          confirmpassword: "Potwierdź hasło",
          haveac: "Masz już konto?",
          logout: "Wyloguj się",
          registerforfree: "Zarejestruj się za darmo",
          "Start speaking with confidence from day one": "Zacznij mówić pewnie od pierwszego dnia",
          "Start Learning Free": "ZACZNIJ NAUKĘ ZA DARMO",
          "Choose your English level and topics that interest you": "Wybierz swój poziom angielskiego i tematy, które Cię interesują",
          "All Categories": "Wszystkie kategorie",
          "All Levels": "Wszystkie poziomy",
          "Search videos by title": "Szukaj filmów po tytule",
          "Immerse yourself in authentic content featuring real-life videos with practical, everyday vocabulary you'll actually use.": "Zanurz się w autentycznych treściach z prawdziwymi filmami i praktycznym, codziennym słownictwem, którego naprawdę użyjesz.",
          "Learn Words": "Ucz się słów",
          "Focus your energy efficiently by studying only the words from videos that are new to you, maximizing your learning time.": "Skup swoją energię efektywnie, ucząc się tylko tych słów z filmów, które są dla Ciebie nowe, maksymalizując czas nauki.",
          "understanding2": "Sprawdź zrozumienie",
          "Assess your comprehension through interactive questions, voice-based answers, and targeted review of new vocabulary.": "Oceń swoje zrozumienie dzięki interaktywnym pytaniom, odpowiedziom głosowym i ukierunkowanemu powtarzaniu nowego słownictwa.",
          "practiceDialogues2": "Ćwicz dialogi",
          "Apply your knowledge in realistic conversations based on the videos you've watched, building confidence for real-world interactions": "Zastosuj swoją wiedzę w realistycznych rozmowach opartych na obejrzanych filmach, budując pewność siebie w prawdziwych sytuacjach.",
          watch: "Ucz się nowych słów",
          watchbig:
            "Twórz własny słownik lub pozwól AI dobrać najważniejsze słowa dla Ciebie.",
          learn: "Oglądaj filmy",
          learnBig:
            "Zanurz się w autentyczne dialogi dopasowane do Twojego poziomu i celów.",
          speak: "Dyskutuj",
          speakBig:
            "Ćwicz konwersacje z AI – tekstowo lub głosowo, jak w prawdziwej rozmowie.",
          discuss: "Otrzymaj informację zwrotną na swoje odpowiedzi",
          discussBig:
            "AI sprawdza Twoje odpowiedzi, wyjaśnia błędy i pomaga Ci się rozwijać.",
          popularVideo: "Popularne wideo",
          allLevels: "Wszystkie poziomy",
          showAll: "Pokaż wszystko",
          filter: "Filtr",
          chooseLanguage: "W jakim języku wygodnie jest Ci przeglądać stronę?",
          popupTitle: "Czy chcesz rozpocząć naukę?",
          startLearning: "Rozpocznij",
          startyFirstTitle: "Mów językami świata",
          levelonea: "Początkujący",
          leveltwoa: "Podstawowy",
          levevoneb: "Średnio zaawansowany",
          lebeltwob: "Wyższy średnio zaawansowany",
          levelonec: "Zaawansowany",
          leveltwoc: "Biegły",
          levelBeginnerGroup: "Początkujący",
          levelIntermediateGroup: "Średnio zaawansowany",
          levelAdvancedGroup: "Zaawansowany",
          allLevelsOption: "Wszystkie poziomy",
          contButton: "Kontynuuj",
          pojasn: "Wyjaśnienie",
          pruklad: "Przykład użycia",
          showMore: "Pokaż więcej",
          showLess: "Pokaż mniej",
          searchPlaceholder: "Wpisz tytuł wideo",
          videoNotFound: 'Nie znaleziono wideo o tytule ""',
          noVideosForFilters: "Nie znaleziono wideo dla wybranych filtrów",
          allVideos: "Wszystkie filmy",
          "English": "Angielski",
          "Polski": "Polski",
          "Українська": "Ukraiński",
          "Ukrainian": "Ukraiński",
          "Polish": "Polski",
          "My learning": "Moja nauka",
          "All Videos": "Wszystkie filmy",
          "All videos": "Wszystkie filmy",
          "Words learned": "Poznane słowa",
          "Videos completed": "Ukończonych filmów",
          "Questions answered correctly": "Poprawnych odpowiedzi na pytania",
          "Dialogues role played successfully": "Pomyślnie odegranych dialogów",
          "All My Videos": "Wszystkie moje filmy",
          "In Progress": "W toku",
          "Completed": "Ukończono",
          "❤️ Favorites": "❤️ Ulubione",
          "Favorites": "Ulubione",
          "words": "słów",
          "word": "słowo",
          "Total Words": "Łączna słów",
          "Words in Dictionary": "Słowa w słowniku",
          "Watch Video": "Oglądaj film",
          "Watch the full lesson video": "Obejrzyj cały film z lekcją",
          "Study Words": "Uczyć się słówek",
          "Learn vocabulary in context": "Ucz się słownictwa w kontekście",
          "Check Understanding": "Sprawdzić zrozumienie",
          "Test your comprehension": "Sprawdź swoje zrozumienie",
          "Practice Dialogues": "Ćwiczyć dialogi",
          "Real-life conversations": "Rozmowy w prawdziwym życiu",
          "Example": "Przykład",
          "Common Mistakes": "Typowe Błędy",
          "Log Out": "Wyloguj się",
          "Log In": "Zaloguj się",
          "days remaining": "pozostało dni",
          "Welcome back": "Witamy ponownie",
          "Language level": "Poziom języka",
          "Travel": "Podróże",
          "Education": "Edukacja",
          "Work": "Praca",
          "Health": "Zdrowie",
          "News & Technology": "Wiadomości i technologia",
          "Leisure": "Czas wolny",
          "Daily Life": "Codzienne życie",
          "Beginner": "Początkujący",
          "Elementary": "Podstawowy",
          "Intermediate": "Średnio zaawansowany",
          "Upper-Intermediate": "Wyższy średnio zaawansowany",
          "Advanced": "Zaawansowany",
          "Proficiency": "Biegły",
          "INF": "INF",
          "V2": "PS",
          "V3": "PP",
          "3 SG": "3 os.l.poj.",
          "SG": "l.poj.",
          "PL": "l.mn.",
          "BASE": "PODST",
          "COMP": "STOP.WYŻ",
          "SUP": "STOP.NAJW",
          "REFL": "ZWROT",
          "OBJ": "DOPEŁN",
          "POSS": "DZIERŻ",
          "FULL": "PEŁNA",
          "Master Your English!": "Podnieś swój angielski na wyższy poziom",
          "Start Testing": "Rozpocznij test",
          "Choose your challenge:": "Wybierz rodzaj zadania:",
          "Yes/No Questions": "Pytania Tak/Nie",
          "Text/Voice Response": "Odpowiedź tekstem/głosem",
          "Drag & Drop": "Przeciągnij i upuść",
          "Attempts": "Próby",
          "attempts": "próby",
          "Click any question to jump directly to it!": "Kliknij dowolne pytanie, aby przejść bezpośrednio do niego",
          "View Results": "Wyświetl wyniki",
          "Question": "Pytanie",
          "Hint": "Podpowiedź",
          "of": "z",
          "Select your answer – it will be checked automatically": "Wybierz odpowiedź — zostanie sprawdzona automatycznie",
          "YES": "TAK",
          "NO": "NIE",
          "Correct": "Poprawnie",
          "Partially Correct": "Częściowo poprawne",
          "Incorrect": "Niepoprawnie",
          "Next Question": "Następne pytanie",
          "Answer by Text or Voice": "Odpowiadaj tekstem lub głosem",
          "Type your answer below or click the microphone to record your voice": "Wpisz odpowiedź poniżej lub kliknij mikrofon, aby nagrać swój głos",
          "Type your answer here…": "Wpisz odpowiedź tutaj…",
          "Ready": "Gotowe",
          "Answered": "Odpowiedziano",
          "Check Answer": "Sprawdź odpowiedź",
          "Recording...": "Trwa nagrywanie…",
          "Your answer:": "Twoja odpowiedź:",
          "Drag the words to complete the sentence:": "Przeciągnij słowa, aby uzupełnić zdanie:",
          "Your answer will be checked automatically when all gaps are filled": "Twoja odpowiedź zostanie sprawdzona automatycznie, gdy uzupełnisz wszystkie luki",
          "Next Question": "Następne pytanie",
          "Finish Test": "Zakończ test",
          "Please select at least one test type!": "Proszę wybrać co najmniej jeden typ testu!",
          "No questions available!": "Brak dostępnych pytań!",
          "Loading questions...": "Ładowanie pytań...",
          "This may take 5-10 seconds for new content": "To może potrwać 5-10 sekund dla nowej zawartości",
          "of": "z",
          "Try Again": "Spróbuj ponownie",
          "Scroll down to see your detailed error analysis": "Przewiń w dół, aby zobaczyć szczegółową analizę błędów",
          "Outstanding!": "Znakomicie!",
          "Keep Growing!": "Rozwijaj się dalej!",
          "Great Job!": "Świetna robota!",
          "Good Effort!": "Dobra robota!",
          "Error Analysis": "Analiza błędów",
          "Understanding your mistakes helps you learn better": "Zrozumienie błędów pomaga uczyć się lepiej",
          "Key Areas for Improvement": "Kluczowe obszary do poprawy",
          "Incorrect Answers": "Błędne odpowiedzi",
          "Partially Correct Answers": "Częściowo poprawne odpowiedzi",
          "Correct answer:": "Prawidłowa odpowiedź:",
          "You've mastered this material! Your understanding is exceptional.": "Ten materiał masz opanowany! Twoje zrozumienie jest wyjątkowe.",
          "Every expert was once a beginner. Keep practicing and you'll get there!": "Każdy ekspert kiedyś był początkujący. Ćwicz dalej, a osiągniesz cel!",
          "You've completed your": "Wykorzystano",
          "You're doing really well! Keep up the excellent work.": "Świetnie ci idzie! Kontynuuj tę wspaniałą pracę.",
          "You're making progress! A little more practice will help you improve.": "Robisz postępy! Trochę więcej praktyki pomoże ci się poprawić.",
          "Focus on careful reading - multiple Yes/No questions were missed. Pay attention to keywords like 'not', 'only', or 'all'.": "Skup się na uważnym czytaniu — pominięto kilka pytań Tak/Nie. Zwracaj uwagę na słowa kluczowe, takie jak 'nie', 'tylko' lub 'wszystkie'.",
          "Practice word order and grammar structures - drag & drop questions show gaps in understanding sentence construction.": "Ćwicz kolejność słów i struktury gramatyczne — zadania przeciągnij i upuść pokazują luki w zrozumieniu budowy zdań.",
          "Work on expressing complete thoughts - text/voice answers need more detail and accuracy.": "Pracuj nad wyrażaniem pełnych myśli — odpowiedzi tekstowe/głosowe wymagają więcej szczegółów i dokładności.",
          "Consider reviewing the material more thoroughly before attempting again. Take notes on key concepts.": "Rozważ dokładniejsze przejrzenie materiału przed ponowną próbą. Rób notatki z kluczowych pojęć.",
          "You're showing good understanding but need to refine some details. Focus on the specific areas mentioned above.": "Wykazujesz dobre zrozumienie, ale musisz dopracować niektóre szczegóły. Skup się na konkretnych obszarach wymienionych powyżej.",
          "No answer": "Brak odpowiedzi",
          "No answer provided": "Nie podano odpowiedzi",
          "N/A": "N/D",
          "See explanation": "Zobacz wyjaśnienie",
          "Review Your Answer": "Przejrzyj swoją odpowiedź",
          "See your answer and the explanation for this question": "Zobacz swoją odpowiedź i wyjaśnienie do tego pytania",
          "← Back to Results": "← Powrót do wyników",
          "Review Mode": "Tryb przeglądu",
          "Review all your answers and explanations": "Przejrzyj wszystkie swoje odpowiedzi i wyjaśnienia",
          "Previous": "Poprzedni",
          "Next": "Następny",
          "Next2": "Dalej",
          "Please provide an answer!": "Proszę podać odpowiedź!",
          "Microphone access denied. Please type your answer.": "Odmówiono dostępu do mikrofonu. Proszę wpisać odpowiedź.",
          "Mic denied": "Mikrofon odmówiony",
          "Voice recording saved": "Nagranie głosowe zapisane",
          "Failed to submit your recording. Please try again.": "Nie udało się przesłać nagrania. Spróbuj ponownie.",
          "Failed to play recording": "Nie udało się odtworzyć nagrania",
          "Voice recording transcribed": "Nagranie głosowe przepisane",
          "Voice recording submitted": "Nagranie głosowe przesłane",
          "Processing...": "Przetwarzanie...",
          "Welcome to Dialogue Studio!": "Witaj w Dialogue Studio!",
          "firstPopDes": "Poćwiczmy dialog razem. Musisz użyć 5 słów ze słownika w naszej rozmowie.",
          "Yes, I'm Ready!": "TAK, JESTEM GOTOWY!",
          "FINISH SESSION": "ZAKOŃCZ LEKCJĘ",
          "Word Treasury": "Słowa",
          "YOUR PROGRESS": "TWÓJ POSTĘP",
          "Words Used": "Użyte słowa",
          "PRESS TO SPEAK": "NACIŚNIJ, ABY MÓWIĆ",
          "Listening to you...": "Słucham cię...",
          "I don't understand the question": "Nie rozumiem pytania",
          "I can't answer": "Nie mogę odpowiedzieć",
          "Time Invested": "Zainwestowany czas",
          "Time Spent": "Czas spędzony",
          "Welcome to your": "Witaj w swojej",
          "restFirstMessageT": "praktyce dialogowej! Cieszę się, że mogę omówić z tobą ten temat. Spróbuj użyć 5 słów pokazanych po prawej stronie.",
          "Exchanges": "Wymiany",
          "Words Mastered": "Opanowane słowa",
          "Brilliant Session!": "Genialna lekcja",
          "You've created something beautiful with words today": "Stworzyłeś dziś coś pięknego słowami",
          "Your Achievements": "Twoje osiągnięcia",
          "Perfect! You used all 5 vocabulary words brilliantly!": "Świetnie! Użyłeś wszystkich 5 słówek znakomicie!",
          "New Adventure": "Nowa przygoda",
          "Exit": "Wyjście",
          "Welcome Back!": "Witamy ponownie!",
          "You have an unfinished dialogue session for": "Masz niedokończoną sesję dialogową na temat",
          "You've used": "Użyłeś",
          "out of 5 vocabulary words.": "z 5 słów ze słownictwa",
          "Continue Session": "Kontynuuj dialog",
          "Start Over": "Zacznij od nowa",
          "In which language would you like to view the website?": "W jakim języku chcesz przeglądać stronę?",
          "Take the test — get a program personalized to your goal and level": "Zrób test — otrzymasz program dopasowany do twojego celu i poziomu",
          "It will take less than 1 minute": "Zajmie to mniej niż 1 minutę",
          "Quick & Easy": "Szybko i łatwo",
          "Step 1 of 2": "Krok 1 z 2",
          "Step 2 of 2": "Krok 2 z 2",
          "What is your current English level?": "Jaki jest Twój obecny poziom angielskiego?",
          "What's your main goal with English?": "Jaki jest Twój główny cel z angielskim?",
          "Great! We've prepared your personalized learning path": "Świetnie! Przygotowaliśmy Twoją spersonalizowaną ścieżkę nauki",
          "Finish test": "Zakończ test",
          "English Learning Journey": "Podróż nauki angielskiego",
          "Lower Level": "Niższy poziom",
          "Add Plan": "Dodaj plan",
          "Raise Level": "Podnieś poziom",
          "Learning Progress": "Postęp nauki",
          "Current Level": "Obecny poziom",
          "Basics": "Podstawy",
          "Conversations": "Rozmowy",
          "Introduction": "Wprowadzenie",
          "Greetings": "Powitania",
          "Practice": "Praktyka",
          "Daily Talk": "Codzienne rozmowy",
          "Questions": "Pytania",
          "Social": "Społeczne",
          "Business": "Biznes",
          "Emails": "E-maile",
          "Meetings": "Spotkania",
          "Airport": "Lotnisko",
          "Hotels": "Hotele",
          "Dining": "Jedzenie",
          "Grammar": "Gramatyka",
          "Idioms": "Idiomy",
          "Fluency": "Płynność",
          "I want to choose the video myself": "Chcę sam wybrać wideo",
          "Continue Learning": "Kontynuuj naukę",
          "TRY 2-MIN DEMO": "Wypróbuj 2-minutowe demo",
          "WHY CHOOSE AI LINGUA?": "Dlaczego wybrać AI Lingua?",
          "REAL-LIFE VIDEOS": "Filmy z życia codziennego",
          "AI-POWERED PRACTICE": "Ćwiczenia z AI",
          "ALL LEVELS WELCOME": "Dla wszystkich poziomów",
          // Level descriptions
          "Preparatory course. Ideal for beginners": "Kurs przygotowawczy. Idealny dla początkujących",
          "I am starting to learn English.": "Zaczynam uczyć się angielskiego.",
          "I already know some words": "Już znam niektóre słowa",
          "I can already speak a little": "Już mogę trochę mówić",
          "I confidently speak on various topics": "Pewnie rozmawiam na różne tematy",
          "I can discuss various topics in detail": "Mogę szczegółowo omawiać różne tematy",
          "Enter your credentials to access your account": "Wprowadź swoje dane logowania, aby uzyskać dostęp do konta",
          "coming soon": "bardzo szybko",
          "Login successful": "Logowanie udane",
          "Login failed": "Błąd logowania",
          "Create your account to get started": "Utwórz konto, aby rozpocząć",
          "Plans that fit your needs": "Wybierz plan dopasowany do swoich potrzeb",
          "Simple, scalable pricing that grows with you.": "Prosty i elastyczny cennik, który skaluje się razem z Tobą.",
          "Free": "Bezpłatny",
          "Free for everyone": "Darmowy dla wszystkich",
          "Watch learning videos": "Oglądanie filmów szkoleniowych",
          "Add words to personal vocabulary": "Dodawanie słów do własnego słownika",
          "Study & review words": "Nauka i powtórki słówek",
          "Video comprehension checks": "Testy rozumienia wideo",
          "AI voice dialogues": "Dialogi głosowe z AI",
          "Certificate upon completion": "Certyfikat po ukończeniu",
          "Priority support": "Priorytetowe wsparcie",
          "Sign Up": "Zarejestruj się",
          "/month": "/miesiąc",
          "Plans that fit your needs": "Plany dopasowane do Twoich potrzeb",
          "Simple, scalable pricing that grows with you.": "Proste, skalowalne cenowanie, które rośnie wraz z Tobą",
          "Free": "Za darmo",
          "Free for everyone": "Bezpłatnie dla każdego",
          "Watch learning videos": "Oglądanie filmów szkoleniowych",
          "Add words to personal vocabulary": "Dodawanie słów do własnego słownika",
          "Study & review words": "Nauka i powtórki słówek",
          "Video comprehension checks": "Testy rozumienia wideo",
          "AI voice dialogues": "Dialogi głosowe z AI",
          "Certificate upon completion": "Certyfikat po ukończeniu",
          "Priority support": "Priorytetowe wsparcie",
          "For individuals & freelancers": "Dla osób indywidualnych i freelancerów",
          "7 days free trial": "7-dniowy bezpłatny okres próbny",
          "AI voice dialogues — 10 per day": "Dialogi głosowe z AI — 10 dziennie",
          "Unlimited AI voice dialogues": "Nielimitowane dialogi głosowe z AI",
          "For teams & agencies": "Dla zespołów i agencji",
          "For schools, businesses, universities": "Dla szkół, firm i uniwersytetów",
          "All Pro features included": "Wszystkie funkcje planu 'Profesjonalny'",
          "Per-user progress reports": "Raporty postępów dla każdego użytkownika",
          "Training reminders for learners": "Przypomnienia o nauce dla uczących się",
          "Custom branding options": "Opcje dostosowania brandingu",
          "Dedicated account manager": "Dedykowany opiekun konta",
          "Volume discounts available": "Dostępne rabaty ilościowe",
          "API access & integrations": "Dostęp do API i integracje",
          "Contact Us": "Skontaktuj się z nami",
          "Get Started": "Zacznij",
          "Custom Pricing": "Cena indywidualna",
          "Pro": "Profesjonalny",
          "Popular": "Popularny",
          "Cancel & Refund Policy": "Polityka rezygnacji i zwrotów",
          "Pricing": "Cennik",
          "All rights reserved": "Wszystkie prawa zastrzeżone",
          "Terms of Use": "Warunki użytkowania",
          "Privacy Policy": "Polityka prywatności",
          "Cookie Settings": "Ustawienia plików cookie",
          "Last updated": "Ostatnia aktualizacja",
          "Terms of Use2": "Regulamin korzystania",
          "temrs1Text": "AI Lingua to platforma online do nauki języka angielskiego (lekcje wideo, słownik, testy ze zrozumienia, ćwiczenia dialogów wspierane przez AI). Dostęp zapewniany jest wyłącznie w formie cyfrowej; towary fizyczne nie są dostarczane.",
          "terms2": "Płatności są przetwarzane przez Paddle.com; faktury/paragony oraz należne podatki administruje Paddle.",
          "terms3": "Właściciel usługi: Indywidualny Przedsiębiorca Alona Oleksandriwna Korchynska (FOP Korchynska Alona Oleksandrivna)",
          "terms4": "| Właściwość prawa: Ukraina",
          "Tel": "Tel",
          "terms5": "Adres korespondencyjny: Starokostiantyniw, obwód chmielnicki, 31100, Ukraina",
          "terms6": "Minimalny wiek użytkownika to 13 lat; osoby poniżej 13 lat nie mogą korzystać z Usługi. Jeśli mieszkasz w kraju UE/EOG lub w Zjednoczonym Królestwie i masz mniej niż 16 lat, wymagana jest potwierdzona zgoda rodzica/opiekuna (jeśli prawo Twojego kraju przewiduje niższy wiek zgody, będziemy to respektować). Użytkownik jest zobowiązany do zachowania poufności danych logowania i nieudostępniania dostępu osobom trzecim.",
          "terms7": "Paddle.com jako Merchant of Record.",
          "terms8": "Płatności są przyjmowane, a faktury/paragony wystawiane przez Paddle.com jako sprzedawcę/Merchant of Record, w tym obliczanie i pobór obowiązujących podatków/VAT. Plany i ceny są publikowane na stronie cennika i mogą ulec zmianie z uprzednim powiadomieniem, jeśli wpływają na przyszłe okresy rozliczeniowe. Subskrypcje odnawiają się automatycznie, chyba że zostaną anulowane w panelu użytkownika (po anulowaniu automatyczne odnowienie jest wyłączane; dostęp trwa do końca już opłaconego okresu).",
          "terms9": "Okres próbny wynosi 7 dni. Jeśli subskrypcję zakupiono w trakcie okresu próbnego, płatny dostęp zaczyna się natychmiast, a okres próbny trwa do końca 7 dni (łączny dostęp nie jest 'podwajany'). Dostępna jest wersja bezpłatna o ograniczonej funkcjonalności.",
          "terms10": "Zwroty po opłaceniu subskrypcji nie są udzielane, w tym częściowe/proporcjonalne, z wyjątkiem przypadków wymaganych przez bezwzględnie obowiązujące przepisy lub przewidzianych w naszej polityce wyjątków.",
          "terms11": "Zabronione są: naruszenia prawa; treści agresywne, dyskryminujące lub szkodliwe; próby nieuprawnionego dostępu, ingerencja w działanie Usługi lub inżynieria wsteczna; zautomatyzowane masowe pozyskiwanie danych; oszustwa płatnicze; współdzielenie jednego konta przez wiele osób; przesyłanie lub wprowadzanie materiałów naruszających prawa własności intelektualnej osób trzecich. Konta naruszające niniejszy Regulamin mogą zostać ograniczone lub zamknięte po uprzednim powiadomieniu, gdy jest to możliwe.",
          "terms12": "Materiały Usługi (w tym filmy, testy, kod oprogramowania, projekt, teksty) są chronione prawami własności intelektualnej. Użytkownikowi udzielana jest ograniczona, niewyłączna, nieprzenoszalna licencja na osobiste, niekomercyjne korzystanie z Usługi. Treści przesłane przez użytkownika pozostają jego własnością; użytkownik udziela Usłudze ograniczonej licencji na wykorzystanie takich treści w celu świadczenia i ulepszania Usługi.",
          "terms13": "Korzystamy z dostawców zewnętrznych (hosting, analityka oraz modele LLM dla dialogów AI). Dane są przetwarzane wyłącznie w celu świadczenia, utrzymania i ulepszania Usługi. Nie wykorzystujemy Twoich treści do trenowania ogólnych modeli dostawców, chyba że wyraźnie wskażemy inaczej i uzyskamy Twoją zgodę. Wykaz kluczowych dostawców i lokalizacji serwerów znajduje się w Polityce prywatności.",
          "terms14": "Możemy aktualizować funkcje, ceny i warunki. O istotnych zmianach wpływających na płatności lub dostęp informujemy z co najmniej 7-dniowym wyprzedzeniem (e‑mail/baner w koncie). Dalsze korzystanie po dacie wejścia zmian w życie oznacza akceptację zaktualizowanych warunków.",
          "terms15": "Możemy zawiesić lub zakończyć dostęp użytkownika w przypadku naruszenia niniejszego Regulaminu albo z przyczyn bezpieczeństwa/prawnych, z rozsądnym powiadomieniem, gdy to możliwe. Po zakończeniu dostępu możesz wyeksportować swoje dane w ciągu 30 dni (z wyjątkiem ograniczeń prawnych).",
          "terms16": "Usługa jest dostarczana 'w stanie takim, w jakim jest' i 'w miarę dostępności'. W zakresie dozwolonym przez prawo nie udziela się dorozumianych gwarancji przydatności czy dostosowania do określonego celu. Łączna odpowiedzialność właściciela Usługi wobec użytkownika jest ograniczona do kwoty opłat uiszczonych przez danego użytkownika w ciągu ostatnich 12 miesięcy.",
          "terms17": "Niniejszy Regulamin podlega prawu Ukrainy; spory podlegają właściwym sądom Ukrainy, chyba że bezwzględnie obowiązujące przepisy stanowią inaczej.",
          "terms18": "Pytania dotyczące Usługi i rozliczeń (w tym rezygnacji z subskrypcji):",
          "About Us": "O nas",
          "Accounts and Age": "Konta i wiek",
          "Subscriptions, Pricing, and Billing": "Subskrypcje, ceny i rozliczenia",
          "Trial Period and Free Version": "Okres próbny i wersja bezpłatna",
          "Refunds": "Zwroty",
          "Acceptable Use": "Dozwolone korzystanie",
          "Intellectual Property Rights": "Prawa własności intelektualnej",
          "Third-Party Technologies and AI": "Technologie stron trzecich i AI",
          "Service Availability and Changes": "Dostępność Usługi oraz zmiany Usługi i cen",
          "Termination of Access": "Zakończenie dostępu",
          "Warranty Disclaimer": "Wyłączenie gwarancji i ograniczenie odpowiedzialności",
          "Governing Law and Contact": "Prawo właściwe, jurysdykcja i kontakt",
          "October": "października",
          "Who We Are": "Kim jesteśmy",
          "privacy1": "Indywidualny Przedsiębiorca Alona Oleksandriwna Korchynska jest administratorem danych dla AI Lingua. Kontakt:",
          "Data We Process": "Jakie dane przetwarzamy",
          "privacy2": "e‑mail, hasło (zahashowane), imię/pseudonim.",
          "privacy3": "postępy, wyniki testów, ustawienia, dzienniki aktywności.",
          "privacy4": "przetwarzane przez Paddle.com (otrzymujemy status transakcji/subskrypcji i numer zamówienia; nie przechowujemy pełnych danych kart).",
          "privacy5": "pliki cookie/telemetria na potrzeby działania serwisu, bezpieczeństwa i analityki.",
          "Purposes": "Cele",
          "privacy6": "Świadczenie Usługi, rozliczenia, wsparcie, bezpieczeństwo, analityka/ulepszenia, wypełnianie obowiązków prawnych.",
          "Legal Bases": "Podstawy prawne",
          "privacy7": "Wykonanie umowy; uzasadniony interes; zgoda (gdzie wymagana); obowiązek prawny.",
          "Data Sharing": "Udostępnianie danych",
          "privacy8": "Dostawcom infrastruktury/analityki oraz Paddle.com — przy zachowaniu odpowiednich zabezpieczeń.",
          "privacy8.1": "Dostawcom infrastruktury/analityki oraz",
          "privacy8.2": "— przy zachowaniu odpowiednich zabezpieczeń.",
          "Retention": "Okres przechowywania",
          "privacy9": "Tak długo, jak konto jest aktywne; niektóre zapisy mogą być przechowywane dłużej, jeśli wymagają tego przepisy (np. sprawozdawczość finansowa).",
          "Data Subject Rights": "Prawa osoby, której dane dotyczą",
          "privacy10": "Żądania dostępu/usunięcia/przenoszenia/sprzeciwu prosimy kierować na adres: ailinguaservice@gmail.com. Odpowiadamy w ciągu 30 dni. Masz również prawo wnieść skargę do Rzecznika Praw Człowieka przy Parlamencie Ukrainy (ombudsman) lub do organu nadzorczego w kraju Twojego zamieszkania.",
          "International Transfers": "Transfery międzynarodowe",
          "privacy11": "W przypadku przekazywania danych poza Ukrainę/UE stosujemy Standardowe Klauzule Umowne (SCC) lub inne odpowiednie zabezpieczenia. Wykaz głównych dostawców i krajów przetwarzania podajemy w odpowiedniej sekcji/załączniku.",
          "Cookies": "Cookies",
          "privacy12": "Używamy niezbędnych plików cookie do działania serwisu oraz plików cookie analitycznych/marketingowych wyłącznie za Twoją zgodą. W wyborze możesz w każdej chwili wprowadzić zmiany w banerze zgody.",
          "Account": "Konto",
          "Learning": "Nauka",
          "Payments": "Płatności",
          "Technical": "Techniczne",
          "Cancellation and Refund Policy": "Polityka rezygnacji i zwrotów",
          "refund1": "7 dni. Jeśli subskrypcję zakupiono w trakcie okresu próbnego, dostęp próbny trwa do końca 7 dni.",
          "refund2": "obciążenie przez Paddle; subskrypcja odnawia się automatycznie do czasu rezygnacji.",
          "refund3": "w dowolnym momencie w Twoim panelu/przez Paddle; po rezygnacji dostęp trwa do końca już opłaconego okresu.",
          "refund4": "nie są udzielane po opłaceniu subskrypcji (w tym częściowe/proporcjonalne), z wyjątkiem przypadków wymaganych przez obowiązujące prawo.",
          "refund5": "Kontakt w sprawach rozliczeń/rezygnacji:",
          "Trial period:": "Okres próbny:",
          "Payment and auto-renewal:": "Płatność i automatyczne odnawianie:",
          "CNCL": "Rezygnacja:",
          "RFND": "Zwroty:",
          "app-header-text": "Teraz przećwiczymy dialog z filmu. Mówimy tak samo jak w nagraniu: te same słowa i ten sam temat. Zaczynamy.",
          "Try saying it like this:": "Spróbuj powiedzieć tak",
          "Keep practicing!": "Ćwicz dalej!",
          "Not bad!": "Nieźle!",
          "Good job!": "Dobra robota!",
          "Excellent result!": "Doskonały wynik!",
          "Skip": "Pomiń",
          "Зробіть перерву та перегляньте!": "Zrób sobie przerwę i przejrzyj!",
          "You\'ve tried five times already - that\'s great persistence! But it seems like it would be worth refreshing the material so the dialogue goes easier.": "Próbowałeś już pięć razy – to wielka wytrwałość! Ale wydaje się, że warto odświeżyć materiał, żeby dialogi były łatwiejsze.",
          "Mistakes are part of learning": "Błędy są częścią nauki",
          "Nothing scary, it happens!": "Nic strasznego, zdarza się!",
          "It seems difficult to answer by voice for now. Let\'s first review the material again - after that it will be much easier!": "Na razie trudno odpowiedzieć na głos. Najpierw przejrzyjmy materiał jeszcze raz – potem będzie o wiele łatwiej!",
          "One step back is two steps forward": "Jeden krok w tył to dwa kroki w przód",
          "We recommend returning to:": "Zalecamy powrót do:",
          "Learn Words2": "Nauka słów",
          "Review key words and phrases from the lesson": "Przejrzyj kluczowe słowa i zwroty z lekcji",
          "Watch Video2": "Obejrzyj wideo",
          "Watch the dialogue again with subtitles": "Obejrzyj dialog jeszcze raz z napisami",
          "I want to continue the dialogue": "Chcę kontynuować dialog.",
          "Lesson completed": "Lekcja ukończona",
          "Great! Lesson": "Świetnie! Lekcja",
          "completed!": "zakończony!",
          "You\'ve completed the dialogue practice for this video. You can now move on to the next lesson or review this one again.": "Ukończyłeś praktykę dialogową dla tego filmu. Możesz teraz przejść do następnej lekcji lub ponownie przejrzeć tę.",
          "Repeat Lesson": "Powtórz Lekcję",
          "Next Lesson": "Następna Lekcja",
          "Almost there!": "Już prawie!",
          "Don't be sad": "Nie bądź smutny",
          "Every attempt": "Każda próba",
          "is a step forward": "to krok naprzód",
          "This time the lesson": "Tym razem lekcja",
          "was not completed — but that's okay. Mistakes are part of learning. Repeat the lesson or move on: your choice!": "nie został ukończony — ale to nic. Błędy są częścią nauki. Powtórz lekcję albo idź dalej: twój wybór!",
          "Awesome plan for you": "Świetny plan dla Ciebie",
          "Access to 30 video pack": "Dostęp do pakietu 30 filmów",
          "Subscriptions": "Subskrypcje",
          "Sign in to manage your subscription": "Zaloguj się, aby zarządzać swoją subskrypcją",
          "Please log in to view and manage your subscription details, billing information, and account settings.": " Proszę zaloguj się, aby zobaczyć i zarządzać szczegółami swojej subskrypcji, informacjami rozliczeniowymi i ustawieniami konta.",
          "You can manage your billing information and subscription here": "Tutaj możesz zarządzać informacjami o rozliczeniach i subskrypcją",
          "You're on the": "Jesteś na",
          "plan": "planie",
          "Your subscription is active until": "Twoja subskrypcja jest aktywna do",
          "Next renewal:": "Następne odnowienie:",
          "Plan cost": "Koszt planu",
          "Status": "Status",
          "Auto-renewal": "Automatyczne odnawianie",
          "Cancel Subscription": "Anuluj subskrypcję",
          "Upgrade your plan": "Ulepsz swój plan",
          "Processing payment": "Obróbka płatności",
          "We are waiting for confirmation from the payment provider...": "Oczekujemy potwierdzenia od dostawcy płatności...",
          "Your subscription plan": "Twój plan subskrypcji",
          "Activation progress": "Postęp aktywacji",
          "Do not close this page - we will notify you immediately": "Nie zamykaj tej strony - powiadomimy Cię natychmiast",
          "Successfully activated!": "Pomyślnie aktywowano!",
          "Your subscription plan": "Twój plan subskrypcji",
          "Do not waste time - let's learn together! All features of the plan": "Nie martw się o czas - pozwólmy nauczyć się razem! Wszystkie funkcje planu",
          "are already available in your account.": "są już dostępne w Twoim koncie.",
          "Thank you for trusting AI Lingua!": "Dziękujemy za zaufanie do AI Lingua!",
          "Subscription": "Subskrypcja",
          "Стандарт": "Standard",
          "Premium": "Premium",
          "After registration, you'll get your personalized course and be able to track your progress.": "Po rejestracji otrzymasz spersonalizowany kurs i będziesz mógł śledzić swoje postępy.",
          "Start your language learning journey with AI-powered lessons tailored just for you!": "Rozpocznij naukę języka angielskiego dzięki lekcjom opartym na sztucznej inteligencji, dostosowanym do Twoich potrzeb!",
          "Welcome Back, aliona!": "Witamy ponownie, aliona!",
          "Let's continue studying together": "Kontynuujmy naukę razem",
          "Learned Words": "Nauczonych słów",
          "Completed Videos": "Ukończonych filmów",
          "Correct Answers": "Poprawnych odpowiedzi",
          "Successful Dialogues": "Ukończonych dialogów",
          "My Courses": "Moje kursy",
          "View all courses": "Zobacz wszystkie kursy",
          "Business English": "Angielski biznesowy",
          "Intermediate": "Pośredni",
          "24 lessons": "24 lekcje",
          "Progress": "Postęp",
          "lessons done": "lekcji ukończonych",
          "lessons left": "lekcji pozostałych",
          "Conversational English": "Angielski konwersacyjny",
          "30 lessons": "30 lekcji",
          "Travel English": "Angielski podróżny",
          "15 lessons": "15 lekcji",
          "My Videos": "Moje filmy",
          "View all": "Zobacz wszystkie",
          "Name": "Imię",
          "Email": "E-mail",
          "Phone": "Telefon",
          "Message": "Wiadomość",
          "Submit": "Wyślij",
          "Please fill in all the fields!": "Proszę wypełnić wszystkie pola!",
          "Completed Dialogs": "Ukończone dialogi",
          "Введіть коректну адресу електронної пошти.": "Wprowadź poprawny adres e-mail.",
          "The email address and/or password you specified are not correct.": "Podany adres e-mail i/lub hasło są niepoprawne.",
          "Choose a username": "Wybierz nazwę użytkownika",
          "Це поле обов'язкове.": "To pole jest wymagane.",
          "A user is already registered with this email address.": "Użytkownik jest już zarejestrowany z tym adresem e-mail.",
          "Register to save your progress": "Zarejestruj się, aby zapisać swoje postępy",
          "Register": "Zarejestruj się",
          "Previous Lesson": "Poprzednia lekcja",
          "Lesson Completed": "Lekcja ukończona",
          "Lesson Not Completed": "Lekcja nie ukończona",
          "Email must contain @": "E-mail musi zawierać @",
          "Email must contain . (dot)": "E-mail musi zawierać . (kropkę)",
          "Invalid email format (example@domain.com)": "Nieprawidłowy format e-mail (example@domain.com)",
          "At least 8 characters": "Co najmniej 8 znaków",
          "Must contain letters": "Musi zawierać litery",
          "Must contain numbers": "Musi zawierać cyfry",
          "Connecting...": "Łączenie...",
          "Please wait while we establish the connection.": "Proszę czekać, podczas gdy nawiązujemy połączenie.",
          "Home": "Strona główna",
          "Got it": "Zrozumiałem",
          "Partial": "Częściowy",
          "Demo Limit Reached": "Osiągnięto limit demo",
          "Demo limit reached (5/5 dialogs today). Please register to continue.": "Osiągnięto limit demo (5/5 dialogów dzisiaj). Proszę zarejestruj się, aby kontynuować.",
          "Loading subscription details...": "Ładowanie szczegółów subskrypcji...",
          "No videos found": "Nie znaleziono filmów",
          "AI-powered English platform": "Platforma do nauki języka angielskiego z AI",
          "Learn English with": "Ucz się angielskiego dzięki",
          "real-life videos": "filmom z codziennych sytuacji",
          "and AI practice": "i ćwiczeniom z AI",
          "Choose a short lesson, create a personal plan, or learn at your own pace.": "Wybierz krótką lekcję, utwórz spersonalizowany plan lub ucz się we własnym tempie.",
          "Video": "Wideo",
          "Words": "Słowa",
          "Quiz": "Quiz",
          "Speaking": "Mówienie",
          "Comprehension": "Zrozumienie",
          "Dialogues": "Dialogi",
          "Vocabulary": "Słownictwo",
          "Test": "Test",
          "Dialogue": "Dialog",
          "Виберіть, як почати": "Wybierz, jak zacząć",
          "2 minutes · No registration": "2 minuty · Bez rejestracji",
          "Try a 2-minute lesson": "Wypróbuj 2-minutową lekcję",
          "Take a short real-life lesson and see how AI Lingua works — with no commitment.": "Ukończ krótką lekcję opartą na codziennej sytuacji i zobacz, jak działa AI Lingua — bez zobowiązań.",
          "Start quick lesson": "Rozpocznij szybką lekcję",
          "Recommended": "Polecane",
          "Get a personal plan": "Otrzymaj spersonalizowany plan",
          "Answer a few questions about your goal and level to receive a structured course created specifically for you.": "Odpowiedz na kilka pytań o swój cel i poziom — otrzymaj ustrukturyzowany kurs stworzony specjalnie dla Ciebie.",
          "Create my plan": "Stwórz mój plan",
          "Browse videos and choose topics to practice. Learn at a time that suits you.": "Przeglądaj filmy i wybieraj tematy do ćwiczeń. Ucz się w dogodnym dla siebie czasie.",
          "Browse videos": "Przeglądaj filmy",
          "Two ways to learn": "Dwa sposoby nauki",
          "Both paths include real-life video lessons and AI speaking practice.": "Oba tryby obejmują lekcje wideo z codziennych sytuacji i ćwiczenia rozmów z AI.",
          "Personal Plan": "Plan osobisty",
          "Structured lessons in a clear order": "Uporządkowane lekcje w jasnej kolejności",
          "Course based on your goal & level": "Kurs dopasowany do Twojego celu i poziomu",
          "Level test available if you need it": "W razie potrzeby możesz określić poziom",
          "Track your progress over time": "Śledź swoje postępy",
          "Switch": "Możesz przełączyć",
          "anytime": "tryb w dowolnym momencie",
          "Learn Without a Plan": "Ucz się bez planu",
          "Choose any video you like": "Wybierz dowolny film",
          "Practice any topic freely": "Ćwicz dowolne tematy",
          "No fixed order or schedule": "Bez ustalonej kolejności ani harmonogramu",
          "Switch to a personal plan anytime": "Możesz w dowolnym momencie przejść do spersonalizowanego planu",
          "What happens after the 2-minute lesson?": "Co będzie po 2-minutowej lekcji?",
          "Complete a quick demo, then choose your path forward.": "Ukończ krótką lekcję próbną, a następnie wybierz dalszy sposób nauki.",
          "Try quick lesson": "Wypróbuj szybką lekcję",
          "2 minutes": "2 minuty",
          "Continue learning on my own": "Kontynuuj samodzielną naukę",
          "Back to Home": "Powrót do strony głównej",
          "Trial Lesson": "Lekcja próbna",
          "Trial 2-minute lesson": "2-minutowa lekcja próbna",
          "Step": "Krok",
          "of": "z",
          "What to do now": "Co teraz zrobić",
          "Watch the video": "Obejrzyj wideo",
          'Watch the short dialogue, then click "Next: words" to continue.': 'Obejrzyj krótki dialog, a następnie kliknij "Dalej: słowa", aby kontynuować.',
          "Study the words": "Studiuj słowa",
          'Learn new words from the video. Then click "Next".': 'Naucz się nowych słów z filmu. Następnie kliknij „Dalej”.',
          "Далі": "Dalej",
          "Check Understanding": "Sprawdzić zrozumienie",
          "Check your understanding": "Sprawdź rozumienie",
          'Check your understanding. Then click "Next".': 'Sprawdź, czy wszystko rozumiesz. Następnie kliknij „Dalej”',
          "Practice Dialogue": "Ćwicz dialog",
          "Practice the dialogue": "Ćwicz rozmowę",
          "Talk to AI in English. This is the last step of the trial lesson!": "Porozmawiaj ze sztuczną inteligencją po angielsku. To ostatni krok lekcji próbnej!",
          "Далі: слова": "Dalej: słowa",
          "Після перегляду переходьте до слів": "Po obejrzeniu przejdź do słów",
          "Lesson steps": "Etapy lekcji",
          "Watch a short real-life dialogue in English.": "Obejrzyj krótki dialog z życia wzięty w języku angielskim.",
          "Current Step": "Aktualny krok",
          "Learn new words and phrases from videos in context.": "Ucz się nowych słów i zwrotów z filmów w kontekście.",
          "Take a short test to check what you remember.": "Wykonaj krótki test, aby sprawdzić, co pamiętasz.",
          "Talk to AI in English in a real dialogue.": "Porozmawiaj ze sztuczną inteligencją po angielsku w prawdziwym dialogu.",
          "How does AI Lingua work?": "Jak działa AI Lingua?",
          "Save progress?": "Zapisać postęp?",
          "In the full course, each lesson has the same structure: Video → Words → Quiz → Speaking.": "W pełnym kursie każda lekcja ma taką samą strukturę: Wideo → Słowa → Quiz → Mówienie.",
          "Register so you don't lose your result.": "Zarejestruj się, aby nie stracić swojego wyniku.",
          "Success": "Sukces",
          "You have successfully logged out.": "Pomyślnie wylogowano cię.",
          "Notice": "Uwaga",
          "Session has already ended or is invalid.": "Sesja już się zakończyła lub jest nieprawidłowa.",
          "Error": "Błąd",
          "Failed to log out.": "Nie udało się wylogować.",
          "An error occurred during logout.": "Wystąpił błąd podczas wylogowywania.",
          "Failed to add word to vocabulary": "Nie udało się dodać słowa do słownika",
          "Failed to remove word from vocabulary": "Nie udało się usunąć słowa ze słownika",
          "Change level: higher": "Zmień poziom: wyższy",
          "Change level: lower": "Zmień poziom: niższy",
          "Change learning topic": "Zmień temat nauki",
          "Study with tutor": "Uczyć się z nauczycielem",
          "Soon": "Wkrótce",
          "Active": "aktywny",
          "Cancel": "Anuluj",
          "Upgrade": "Uaktualnij",
          "Активна": "Aktywny",
          "Fill in the blanks question": "Uzupełnij puste pola w pytaniu",
          "You were on the right track but needed more precision.": "Byłeś na dobrej drodze, ale potrzebowałeś większej precyzji.",
          "Choose the correct meaning of the word.": "Wybierz poprawne znaczenie słowa.",
          "Profile updated successfully": "Profil zaktualizowany pomyślnie",
          "Error saving profile": "Błąd zapisu profilu",
          "Please fill in all fields": "Proszę wypełnić wszystkie pola",
          "Passwords do not match": "Hasła się nie zgadzają",
          "Password must be at least 8 characters": "Hasło musi mieć co najmniej 8 znaków",
          "Password changed successfully": "Hasło zostało zmienione!",
          "Error changing password": "Błąd zmiany hasła",
          "My profile": "Mój profil",
          "Subscription": "Subskrypcja",
          "Support": "Wsparcie",
          "Log Out": "Wyloguj",
          "Personal cabinet": "Konto osobiste",
          "Manage your profile, subscription and support requests": "Zarządzaj swoim profilem, subskrypcją i prośbami o wsparcie.",
          "Name": "Imię",
          "Interface language": "Język interfejsu",
          "English level": "Poziom angielskiego",
          "Edit profile": "Edytuj profil",
          "Change password": "Zmień hasło",
          "No active subscription": "Brak aktywnej subskrypcji",
          "days remaining": "Pozostało dni",
          "Change plan": "Zmień plan",
          "Get a plan": "Wybierz plan",
          "Write to us if you have questions about lessons, subscription or technical issues": "Napisz do nas, jeśli masz pytania dotyczące lekcji, subskrypcji lub problemów technicznych.",
          "Subject": "Temat",
          "Subscription question": "Pytanie o subskrypcję",
          "Payment issue": "Problem z płatnością",
          "Lesson issue": "Problem z lekcją",
          "Technical issue": "Problem techniczny",
          "Other": "Inne",
          "Message": "Wiadomość",
          "Describe your question or issue": "Opisz swoje pytanie lub problem…",
          "Send": "Wyślij",
          "Thank you": "Dziękujemy!",
          "We received your request and will reply to your email": "Otrzymaliśmy twoją prośbę i odpowiemy na twój e-mail.",
          "Report an issue": "Zgłoś problem",
          "What is wrong with this video?": "Co jest nie tak z tym filmem?",
          "Incorrect translation": "Nieprawidłowe tłumaczenie",
          "Incorrect video level": "Nieprawidłowy poziom filmu",
          "Video does not work": "Film nie działa",
          "Describe the issue (optional)": "Opisz problem (opcjonalnie)",
          "Thank you! We will check this video.": "Dziękujemy! Sprawdzimy ten film.",
          "Update your personal details.": "Zaktualizuj swoje dane osobowe.",
          "Email cannot be changed": "Email nie może zostać zmieniony",
          "Name cannot be changed": "Imię nie może zostać zmienione",
          "Cancel": "Anuluj",
          "Save": "Zapisz",
          "Saving...": "Zapisywanie...",
          "Enter your current and new password.": "Wpisz obecne i nowe hasło.",
          "Current password": "Obecne hasło",
          "New password": "Nowe hasło",
          "Repeat new password": "Powtórz nowe hasło",
          "Update password": "Zaktualizuj hasło",
          "Log out of account?": "Wylogować z konta?",
          "You can return to learning after logging in again": "Możesz powrócić do nauki po ponownym zalogowaniu się.",
          "Continue learning from where you left off.": "Kontynuuj naukę od miejsca, w którym przerwano.",
          "Enter a valid email address": "Wpisz poprawny adres e-mail",
          "Enter your password": "Wpisz hasło",
          "Forgot your password?": "Nie pamiętasz hasła?",
          "Don't have an account?": "Nie masz konta?",
          "What you get after registration": "Co zyskasz po rejestracji",
          "A course tailored to your goal and level.": "Kurs dopasowany do Twojego celu i poziomu.",
          "Real-life lessons": "Lekcje z codziennych sytuacji",
          "Each lesson: Video → Words → Quiz → AI Speaking.": "Każda lekcja: Wideo → Słowa → Quiz → Rozmowa z AI.",
          "AI Speaking": "Rozmowa z AI",
          "Practice dialogues with AI based on videos.": "Ćwicz dialogi z AI na podstawie filmów.",
          "Personal dictionary": "Osobisty słownik",
          "Save words you learn and review them anytime.": "Zapisuj słowa z dialogów i powtarzaj je.",
          "Learning progress": "Postępy w nauce",
          "Track lessons, words, videos, and your learning streak.": "Śledź lekcje, słowa, filmy i liczbę dni nauki z rzędu.",
          "Your password": "Twoje hasło",
          'Create Account': 'Utwórz konto',
          "Already have an account?": "Masz już konto?",
          "Register to save your progress and get a personal learning plan.": "Zarejestruj się, aby zapisywać postępy i otrzymać spersonalizowany plan nauki.",
          "Your name": "Twoje imię",
          "Enter your name": "Wpisz swoje imię",
          "Minimum 8 characters.": "Co najmniej 8 znaków",
          "Password must contain at least 8 characters": "Hasło musi zawierać co najmniej 8 znaków",
          "I agree to the": "Zgadzam się z",
          "Terms of Use": "Warunkami korzystania",
          "Terms of Use2": "Warunkami korzystania",
          "and": "i",
          "Privacy Policy": "Polityką prywatności",
          "Privacy Polic2": "Polityką prywatności",
          'You must agree to the Terms of Use and Privacy Policy': 'Musisz zaakceptować Warunki korzystania i Politykę prywatności',
          'Creating account…': 'Tworzenie konta…',
          'Logging in…': 'Logowanie…',
          "Created based on your goal and level": "Utworzony zgodnie z Twoim celem i poziomem",
          "lessons": "lekcje",
          "completed": "ukończono",
          "hours": "godziny",
          "Manage plan": "Zarządzaj planem",
          "Course completed": "Ukończono kursu",
          "Lessons completed": "Ukończone lekcje",
          "Lessons remaining": "Pozostałe lekcje",
          "Day streak": "ni z rzędu",
          "Lesson": "Lekcja",
          "You stopped at the step": "Zatrzymano się na etapie",
          "Learning path": "Ścieżka nauki",
          "The next lesson unlocks after you pass the previous one.": "Następna lekcja odblokuje się po zaliczeniu poprzedniej.",
          "Repeat": "Powtórz",
          "Blocked": "Zablokowany",
          "Continue": "Kontynuować",
          "You are here": "Jesteś tutaj",
          "Complete lesson": "Ukończ lekcję",
          "Would you like to learn without a fixed plan?": "Chcesz uczyć się bez ustalonego planu?",
          "Go to self-study": "Przejdź do samodzielnej nauki",
          "Available after completing the lesson": "Dostępne po ukończeniu lekcji",
          "Personal learning plans with level-based progress.": "Spersonalizowane plany nauki z postępami według poziomu.",
          "Would you like more structure?": "Chcesz więcej struktury?",
          "A personal plan will help you complete lessons in the right order and track your progress by level.": "Spersonalizowany plan pomoże realizować lekcje we właściwej kolejności i śledzić postępy według poziomów.",
          "Create plan": "Utwórz plan",
          "Self-study will remain available": "Samodzielna nauka pozostanie dostępna",
          "Start": "Rozpocznij",
          "AI says": "AI mówi",
          "Repeat the phrases from the video. AI will check your pronunciation and the content of your answer.": "Powtórz frazy z filmu. AI sprawdzi Twoją wymowę i treść odpowiedzi.",
          "Finish lesson": "Zakończ lekcję",
          "Your answer": "Twoja odpowiedź",
          "Record answer": "Zapisz odpowiedź",
          "Click to start recording": "Kliknij, aby rozpocząć nagrywanie",
          "Try saying:": "Spróbuj powiedzieć:",
          "Plans tailored to your needs": "Plany dopasowane do Twoich potrzeb",
          "Choose your learning plan": "Wybierz plan nauki",
          "Start for free, unlock full access to lessons, or choose AI Lingua for your team.": "Zacznij bezpłatnie, uzyskaj pełny dostęp do lekcji lub wybierz AI Lingua dla zespołu.",
          "Most popular": "Najpopularniejszy",
          "For individual learning": "Do nauki indywidualnej",
          "UAH / month": "UAH / miesiąc",
          "billed monthly": "płatność miesięczna",
          "Personal learning plan": "Spersonalizowany plan nauki",
          "All video lessons": "Wszystkie lekcje wideo",
          "2-minute trial lesson": "2-minutowa lekcja próbna",
          "Limited access to video lessons": "Ograniczony dostęp do lekcji wideo",
          "Add words to dictionary": "Dodawanie słów do słownika",
          "Basic progress saving": "Podstawowe zapisywanie postępów",
          "AI Speaking — limited": "Rozmowa z AI — ograniczona",
          "Personal plan — unavailable": "Spersonalizowany plan — niedostępny",
          "Full catalog — unavailable": "Pełny katalog — niedostępny",
          "AI dialogue practice": "Ćwiczenie dialogów z AI",
          "Personal dictionary": "Słownik osobisty",
          "Progress saving": "Zapisywanie postępów",
          "Review completed lessons": "Powtarzanie ukończonych lekcji",
          "Self-study without a plan": "Samodzielna nauka bez planu",
          "Saved videos and statistics": "Zapisane filmy i statystyki",
          "To try the platform": "Aby wypróbować platformę",
          "UAH": "UAH",
          "free forever": "bezpłatnie na zawsze",
          "Start for free": "Zacznij bezpłatnie",
          "For companies, schools, and universities": "Dla firm, szkół i uczelni",
          "Custom pricing": "Cena indywidualna",
          "tailored to your team's needs": "dopasowana do potrzeb Twojego zespołu",
          "All Premium features": "Wszystkie funkcje Premium",
          "Access for a group of users": "Dostęp dla grupy użytkowników",
          "Each learner's progress": "Postępy każdego ucznia",
          "Admin reports": "Raporty dla administratora",
          "Learning tailored to company goals": "Nauka dopasowana do celów firmy",
          "Dedicated manager support": "Wsparcie opiekuna",
          "Volume discounts": "Rabaty zależne od liczby użytkowników",
          "Contact us": "Skontaktuj się z nami",
          "Subscribe": "Wybierz subskrypcję",
          "Renew subscription": "Odnów subskrypcję",
          "Plan comparison": "Porównanie planów",
          "Feature": "Funkcja",
          "Group access": "Dostęp grupowy",
          "Admin reports": "Raporty dla administratora",
          "Dedicated manager support": "Wsparcie opiekuna",
          "limited": "ograniczone",
          "basic": "opierać",
          "Frequently asked questions": "Często zadawane pytania",
          "Can I start for free?": "Czy można zacząć bezpłatnie?",
          "What is included in Premium?": "Co obejmuje Premium?",
          "Can I cancel my subscription?": "Czy można anulować subskrypcję?",
          "What is Business?": "Czym jest plan Business?",
          "Will my progress be saved after changing plans?": "Czy postępy zostaną zachowane po zmianie planu?",
          "Yes. You can try the platform for free and take a trial lesson. Registration does not require payment.": "Tak, możesz bezpłatnie wypróbować platformę i ukończyć lekcję próbną. Rejestracja nie wymaga płatności.",
          "Premium includes a personal plan, all video lessons, AI speaking practice, a dictionary, progress saving, and detailed learning statistics.": "Premium zapewnia spersonalizowany plan, wszystkie lekcje wideo, ćwiczenia rozmów z AI, słownik, zapisywanie postępów i szczegółowe statystyki nauki.",
          "Yes. You can cancel your subscription at any time in your account. Access will remain active until the end of the paid period.": "Tak, subskrypcję można anulować w dowolnym momencie na koncie użytkownika. Dostęp pozostanie aktywny do końca opłaconego okresu.",
          "Business offers custom terms for companies, schools, and universities, including group access, reports, and dedicated manager support.": "Business to indywidualne warunki dla firm, szkół i uczelni: dostęp grupowy, raporty i wsparcie opiekuna.",
          "Yes. Your progress is saved in your account regardless of your plan.": "Tak, Twoje postępy są zapisywane na koncie niezależnie od wybranego planu.",
          "Choose any videos, complete lessons at your own pace, and practice speaking with AI": "Wybieraj dowolne filmy, realizuj lekcje we własnym tempie i ćwicz rozmowy z AI.",
          "There is no fixed order in this mode — you choose what to learn.": "W tym trybie nie ma ustalonej kolejności — samodzielnie wybierasz, czego się uczyć.",
          "Would you like a structured learning plan?": "Chcesz uczyć się według uporządkowanego planu?",
          "Get a personal plan tailored to your goal and level": "Otrzymaj spersonalizowany plan dopasowany do Twojego celu i poziomu",
          "Learn with a teacher": "Ucz się z nauczycielem",
          "A teacher will help you practice words, pronunciation, and video dialogues.": "Nauczyciel pomoże Ci przećwiczyć słowa, wymowę i dialogi z filmów.",
          "Search videos": "Wyszukaj film",
          "Level": "Poziom",
          "All": "Wszystkie",
          "Topics": "Tematy",
          "Clear filters": "Wyczyść filtry",
          "This is self-study: you choose the videos yourself. To follow a structured path, create a personal plan.": "To nauka samodzielna: samodzielnie wybierasz filmy. Jeśli chcesz uczyć się według planu, utwórz spersonalizowany plan.",
          "No video found. Try changing filters.": "Nie znaleziono filmu. Spróbuj zmienić filtry.",
          "Watch a short real-life dialogue, then move on to the words.": "Obejrzyj krótki dialog z codziennego życia, a następnie przejdź do słów.",
          "Practice dialogue": "Ćwicz rozmowę",
          "Add words from the lesson and review them.": "Dodawaj słowa z lekcji i powtarzaj je.",
          'Learn new words from the video, then click "Next".': "Naucz się nowych słów z filmu, a następnie kliknij „Dalej”.",
          'Check your understanding, then click "Next."': 'Sprawdź, czy wszystko zrozumiałeś, a następnie kliknij „Dalej”.',
          "Speak to AI in English. This is the last step of the lesson!": "Porozmawiaj ze sztuczną inteligencją po angielsku. To ostatni krok lekcji!",
          "Next: Quiz": "Dalej: Quiz",
          "Next: Speaking": "Dalej: Speaking",
          "Next: Words": "Dalej: Words",
          "Save progress": "Zapisz postęp",
          "Practice dialogue": "Ćwicz rozmowę",
          "Recommended order: Video → Words → Quiz → Speaking. Complete the steps in order.": "Zalecana kolejność: Video → Words → Quiz → Speaking. Wykonuj kroki po kolei.",
          "words": "słów",
          "My dictionary": "Mój słownik",
          "Add words from the lesson and review them.": "Dodawaj słowa z lekcji i powtarzaj je.",
          "Open": "Otwórz",
          "Video transcript": "Tekst z filmu",
          "Click an underlined word to see its translation and an example, and add it to your dictionary.": "Kliknij podkreślone słowo, aby zobaczyć tłumaczenie i przykład oraz dodać je do słownika.",
          "from this lesson": "z tej lekcji",
          "from the entire course": "z całego kursu",
          "No results found": "Nie znaleziono wyników",
          "Try another word or change the filter.": "Wpisz inne słowo lub zmień filtr.",
          "Search for a word...": "Szukaj słowa...",
          "Words you added during lessons.": "Słowa dodane podczas lekcji",
          "Back to transcript": "Wróć do tekstu",
          "All from course": "Wszystkie z kursu",
          "From this lesson": "Z tej lekcji",
          "All self-study words": "Wszystkie słowa uczone samodzielnie",
          "From this video": "Z tego filmu",
          "Click the bookmark to save the word": "Kliknij zakładkę, aby zapisać słowo",
          "In dictionary": "W słowniku",
          "No transcript available for this lesson.": "Brak transkrypcji dla tej lekcji.",
          "Translation not available": "Brak tłumaczenia",
          "Example not available": "Brak przykładu",
          "Explanation not available": "Brak wyjaśnienia",
          "Error fetching data": "Błąd podczas żądania",
          "Translation": "Tłumaczenie",
          "Listen to word": "Posłuchaj słowa",
          "Remove from dictionary": "Usuń ze słownika",
          "Add to dictionary": "Dodaj do słownika",
          "Close": "Zamknij",
          "Translation language": "Język tłumaczenia",
          "Current lesson": "Bieżąca lekcja",
          "Another lesson": "Inna lekcja",
          "CSRF token is missing": "Brak tokena CSRF",
          "Failed to receive data": "Nie udało się pobrać danych",
          "Search words in section": "Szukaj słów w sekcji",
          "Loading...": "Ładowanie...",
          "It": "To",
          "Search word...": "Wyszukaj słowo...",
          "Take a short 10-question quiz to check what you remember from the video.": "Rozwiąż krótki quiz składający się z 10 pytań, aby sprawdzić, co zapamiętano z filmu.",
          "10 questions": "10 pytań",
          "3 question types": "3 typy zadań",
          "3–5 minutes": "3–5 minut",
          "What the quiz includes": "Co znajdzie się w quizie",
          "Word meaning": "Znaczenie słowa",
          "Choose the meaning of a word or phrase.": "Wybierz znaczenie słowa lub wyrażenia.",
          "\"from\" means \"from\" or \"because\"": "\"from\" oznacza \"z\" czy \"bo\"",
          "Fill in the blank": "Uzupełnij lukę",
          "Fill in the missing word.": "Wstaw brakujące słowo.",
          "\"My ___ is Anna.\"": "\"My ___ is Anna.\"",
          "Build the phrase": "Ułóż wyrażenie",
          "Build the English phrase from the given words.": "Ułóż angielskie wyrażenie z podanych słów.",
          "\"Check, please\" → Check / please / Card": "\"Check, please\" → Check / please / Card",
          "Start quiz": "Rozpocznij quiz",
          "The quiz includes several question types and will take a few minutes.": "Quiz zawiera różne typy zadań i zajmie kilka minut.",
          "Choose the correct meaning of the word.": "Wybierz poprawne znaczenie słowa.",
          "means": "oznacza",
          "Choose the word that correctly completes the sentence.": "Wybierz słowo, które poprawnie uzupełnia zdanie.",
          "Tap the words in the correct order to build the English phrase.": "Kliknij słowa w poprawnej kolejności, aby ułożyć angielskie wyrażenie.",
          "Your phrase": "Twoje wyrażenie",
          "Tap the words below to build the phrase.": "Kliknij słowa poniżej, aby ułożyć wyrażenie.",
          "Words": "Słowa",
          "Clear": "Wyczyść",
          "Checking...": "Sprawdzanie...",
          "Check phrase": "Sprawdź wyrażenie",
          "True / False": "Prawda / Fałsz",
          "Determine if the statement is correct.": "Określ, czy stwierdzenie jest poprawne.",
          "Open Answer": "Otwarta odpowiedź",
          "Answer the question.": "Odpowiedz na pytanie.",
          "Type your answer here...": "Wpisz swoją odpowiedź tutaj...",
          "Submit answer": "Wyślij odpowiedź",
          "Correct!": "Poprawnie!",
          "Not quite": "Nie do końca",
          "Correct answer": "Poprawna odpowiedź",
          "Great job!": "Świetna robota!",
          "Try rearranging the words in a different order.": "Spróbuj ułożyć słowa w innej kolejności.",
          "Try to review the video material again.": "Spróbuj ponownie przejrzeć materiał wideo.",
          "Finish quiz": "Zakończ quiz",
          "Next question": "Następne pytanie",
          "Choose an answer": "Wybierz odpowiedź",
          "Review mode": "Tryb przeglądu",
          "Back to current": "Powrót do bieżącego",
          "No questions available.": "Brak dostępnych pytań.",
          "Replay": "Powtórna rozgrywka",
          "Slower": "Wolniej",
          "Translate": "Przekładać",
          "Choose how to start learning": "Wybierz, jak rozpocząć naukę",
          "Learn without a plan": "Nauka bez planu",
          "Save your progress!": "Zapisz swoje postępy!",
          "Save your progress": "Zapisz swoje postępy",
          "You are currently learning as a guest. Create a free account to save learned words, completed lessons, and your personal plan.": "Uczysz się teraz jako gość. Utwórz bezpłatne konto, aby zapisać poznane słowa, ukończone lekcje i spersonalizowany plan.",
          "Personal account": "Konto użytkownika",
          "Personal plan": "Plan osobisty",
          "Progress saving": "Zapisywanie postępów",
          "Register for free": "Zarejestruj się bezpłatnie",
          "Continue as guest": "Kontynuuj jako gość",
          "Creating your personal plan": "Tworzenie spersonalizowanego planu",
          "This will take less than 1 minute. Your answers will help us create the right plan.": "Zajmie to mniej niż 1 minutę. Twoje odpowiedzi pomogą utworzyć odpowiedni plan.",
          "Step {{step}} of {{total}}": "Krok {{step}} z {{total}}",
          "Which language would you like to use for the interface?": "W jakim języku wyświetlać interfejs?",
          "Choose the interface language for learning.": "Wybierz język interfejsu do nauki.",
          "Back": "Wstecz",
          "Why are you learning English?": "Dlaczego uczysz się angielskiego?",
          "We will select lesson topics based on your goal.": "Dobierzemy tematy lekcji do Twojego celu.",
          "Airport, hotel, café, and meeting people abroad.": "Lotnisko, hotel, kawiarnia i poznawanie ludzi za granicą.",
          "Job interviews, meetings, correspondence, and workplace dialogues.": "Job interviews, meetings, correspondence, and workplace dialogues.",
          "Educational topics, explanations, and academic vocabulary.": "Tematy edukacyjne, wyjaśnienia i słownictwo akademickie.",
          "Socializing": "Rozmowy",
          "Small talk, meeting people, and everyday conversations.": "Small talk, poznawanie ludzi i codzienne rozmowy.",
          "Everyday topics, hobbies, and light practice.": "Codzienne tematy, hobby i lekka praktyka",
          "Choose the level to start learning.": "Wybierz poziom, od którego chcesz rozpocząć naukę.",
          "Loading levels...": "Ładowanie poziomów...",
          "Failed to load levels. Please try again.": "Nie udało się załadować poziomów. Spróbuj ponownie.",
          "Not sure? Choose an approximate level — you can change it later.": "Nie masz pewności? Wybierz przybliżony poziom — możesz go później zmienić.",
          "Failed to save results. Please try again.": "Nie udało się zapisać wyników. Spróbuj ponownie.",
          "Your personal plan is ready": "Twój spersonalizowany plan jest gotowy",
          "We created a course based on your goal and level.": "Utworzyliśmy kurs dopasowany do Twojego celu i poziomu.",
          "Goal": "Cel",
          "Start first lesson": "Rozpocznij pierwszą lekcję",
          "Change answers": "Zmień odpowiedzi",
          "You can change the level or learning topic later in the plan settings.": "Możesz później zmienić poziom lub temat nauki w ustawieniach planu.",
          "Study": "Nauka",
          "For yourself": "Dla siebie",
          "Create an account to save words, videos, and personal plans.": "Utwórz konto, aby zapisywać słowa, filmy i spersonalizowane plany.",
          "In the full course, every lesson follows the same structure: Video → Words → Quiz → AI Speaking.": "W pełnym kursie każda lekcja ma tę samą strukturę: Wideo → Słowa → Test → Rozmowa z AI.",
          "Great job! You completed the trial lesson.": "Świetnie! Lekcja próbna została ukończona.",
          "Now choose how you would like to continue learning.": "Wybierz, jak chcesz kontynuować naukę.",
          "We will create a course based on your goal, level, and learning pace.": "Utworzymy kurs dopasowany do Twojego celu, poziomu i tempa nauki.",
          "If you do not know your level, we will offer a short test while creating your plan.": "Jeśli nie znasz swojego poziomu, zaproponujemy krótki test podczas tworzenia planu.",
          "You can switch between these modes later.": "Później możesz w dowolnym momencie zmienić tryb nauki.",
          "Payment successful!": "Płatność zakończona pomyślnie!",
          "Your Premium plan has been activated. All AI Lingua features are now available.": "Twój plan Premium został aktywowany. Wszystkie funkcje AI Lingua są teraz dostępne.",
          "Subscription details": "Szczegóły subskrypcji",
          "Plan": "Plan",
          "Active": "Aktywny",
          "Amount": "Kwota",
          "299 UAH / month": "299 UAH / miesiąc",
          "Next charge": "Następna płatność",
          "Payment method": "Płatność",
          "Account2": "Konto",
          "Manage": "Zarządzaj",
          "How would you like to start learning?": "Jak chcesz rozpocząć naukę?",
          "Choose a convenient format: a personal plan or self-study with videos.": "Wybierz wygodny tryb: spersonalizowany plan lub samodzielną naukę z filmami.",
          "Recommended": "Polecane",
          "Get a personal plan": "Otrzymaj spersonalizowany plan",
          "Create a course based on your goal and level. We will select the lessons and their order.": "Utwórz kurs dopasowany do Twojego celu i poziomu. Dobierzemy lekcje i ich kolejność.",
          "This will take less than 1 minute": "Zajmie to mniej niż 1 minutę",
          "Create my plan": "Stwórz mój plan",
          "Learn without a plan": "Nauka bez planu",
          "Choose any videos and practice at your own pace without a fixed order.": "Wybieraj dowolne filmy i ćwicz we własnym tempie bez ustalonej kolejności.",
          "You can create a plan later at any time.": "Później możesz w dowolnym momencie utworzyć plan.",
          "Go to all videos": "Przejdź do wszystkich filmów",
          "You can switch between these modes at any time.": "Możesz przełączać się między tymi trybami w dowolnym momencie.",
          "What is available now": "Co jest teraz dostępne",
          "Personal plan": "Plan osobisty",
          "A course based on your goal and level.": "Kurs dopasowany do Twojego celu i poziomu.",
          "All video lessons": "Wszystkie lekcje wideo",
          "Full video catalog without limits.": "Pełny katalog filmów bez ograniczeń.",
          "Practice dialogues with AI.": "Ćwicz dialogi z AI.",
          "Personal dictionary": "Słownik osobisty",
          "Save words and review them.": "Zapisuj słowa i powtarzaj je.",
          "Learning progress": "Postępy w nauce",
          "Lessons, words, videos, and streak.": "Lekcje, słowa, filmy i streak.",
          "Self-study": "Samodzielna nauka",
          "Any videos without a plan.": "Dowolne filmy bez planu.",
          "Questions about payment?": "Pytania dotyczące płatności?",
          "Contact support": "Skontaktuj się z pomocą techniczną",
          "All rights reserved.": "Wszelkie prawa zastrzeżone.",
          "Terms of Use": "Warunki użytkowania",
          "Privacy Policy": "Polityka prywatności",
          "Refund policy": "Polityka zwrotów",
          "Manage subscription": "Zarządzaj subskrypcją",
          "Payment failed": "Nie udało się zrealizować płatności",
          "We could not activate Premium. Check your payment details or try another method.": "Nie udało się aktywować planu Premium. Sprawdź dane płatności lub wybierz inną metodę.",
          "If you were charged, contact support — we will help.": "Jeśli środki zostały pobrane, skontaktuj się z pomocą techniczną — pomożemy.",
          "Payment attempt details": "Szczegóły próby płatności",
          "Attempt": "Próba",
          "Not paid": "Płatność nie została zrealizowana",
          "Reason: the payment was not confirmed by the bank": "Powód: płatność nie została potwierdzona przez bank",
          "Try again": "Spróbuj ponownie",
          "Choose another payment method": "Wybierz inną metodę płatności",
          "Return to pricing": "Wróć do cennika",
          "What could have happened?": "Co mogło się stać?",
          "Insufficient funds on the card": "Niewystarczające środki na karcie",
          "The bank declined the payment": "Bank odrzucił płatność",
          "Incorrect card details": "Nieprawidłowe dane karty",
          "Payment confirmation was not completed (3D Secure)": "Nie ukończono potwierdzenia płatności (3D Secure)",
          "Temporary payment system error": "Tymczasowy błąd systemu płatności",
          "Need help?": "Potrzebujesz pomocy?",
          "Contact us if the payment fails again or if you were charged.": "Napisz do nas, jeśli płatność ponownie się nie powiedzie lub jeśli środki zostały pobrane.",
          "Continue without Premium": "Kontynuuj bez Premium",
          "Support request": "Zgłoszenie do pomocy technicznej",
          "Describe the payment issue and we will help.": "Opisz problem z płatnością, a my pomożemy.",
          "Subject: Payment issue": "Temat: Problem z płatnością",
          "Describe what happened with the payment…": "Opisz, co stało się z płatnością…",
          "Thank you! We received your request.": "Dziękujemy! Otrzymaliśmy Twoje zgłoszenie.",
          "Password recovery": "Resetowanie hasła",
          "Enter your email, and we will send password recovery instructions.": "Wpisz adres e-mail, a wyślemy instrukcje resetowania hasła.",
          "We will send an email if an account with this email exists.": "Wyślemy wiadomość, jeśli istnieje konto z tym adresem e-mail.",
          "Send instructions": "Wyślij instrukcje",
          "Return to login": "Wróć do logowania",
          "Sending...": "Przesyłka...",
          "Quiz progress": "Postęp testu",
          "Question": "Pytanie",
          "Result": "Wynik",
          "Type": "Typ",
          "Review this question": "Przeglądaj to pytanie",
          "Lesson steps": "Etapy lekcji",
          "Video": "Wideo",
          "completed": "ukończono",
          "Words": "Słowa",
          "Quiz": "Quiz",
          "in progress": "w toku",
          "Speaking": "Mówienie",
          "next": "następny",
          "Quiz completed!": "Quiz zakończony!",
          "Great job! You checked your understanding of the video.": "Świetna robota! Sprawdziłeś swoje zrozumienie filmu.",
          "Continue to Speaking": "Kontynuuj do Speaking",
          "Review answers": "Przeglądaj odpowiedzi",
          "Result": "Wynik",
          "Review this question": "Przeglądaj to pytanie",
          "Almost correct": "Prawie dobrze",
          "Build the English phrase from the given words. Click the words in the correct order.": "Ułóż angielskie wyrażenie z podanych słów. Klikaj słowa we właściwej kolejności.",
          "Click the words below to build the phrase.": "Kliknij poniższe słowa, aby ułożyć wyrażenie.",
          "Correct answer:": "Prawidłowa odpowiedź:",
          "Congratulations! Your account has been created": "Gratulacje! Twoje konto zostało utworzone",
          "Congratulations,": "Gratulacje,",
          "Your account has been created": "Twoje konto zostało utworzone",
          "Your progress, dictionary, and learning plans will now be saved in your account.": "Od teraz Twoje postępy, słownik i plany nauki będą zapisywane na koncie.",
          "Choose how you would like to start learning.": "Wybierz, jak chcesz rozpocząć naukę.",
          "How would you like to learn?": "Jak chcesz się uczyć?",
          "You can start with a structured plan or choose videos yourself.": "Możesz zacząć od uporządkowanego planu lub samodzielnie wybierać filmy.",
          "Structured lesson path": "Uporządkowana ścieżka lekcji",
          "Progress and results are saved": "Postępy i wyniki są zapisywane",
          "Any topic": "Dowolny temat",
          "No fixed order": "Bez ustalonej kolejności",
          "You can switch to a plan later": "Możesz później przejść do planu",
          "You can change the mode later.": "Możesz później zmienić tryb nauki.",
          "If you start without a plan, you can create a personal course at any time.": "Jeśli zaczniesz bez planu, możesz w dowolnym momencie utworzyć spersonalizowany kurs.",
          "If you create a plan, you can still watch videos independently.": "Jeśli utworzysz plan, nadal możesz samodzielnie oglądać filmy.",
          "Great job! Lesson passed": "Świetna robota! Lekcja zaliczona",
          "You did a great job — the next lesson is now unlocked.": "Zrobiłeś świetną robotę — kolejna lekcja jest już odblokowana.",
          "One more step toward confident English.": "Jeszcze jeden krok do swobodnego posługiwania się angielskim.",
          "Required to pass:": "Wymagane do zaliczenia:",
          "Passed": "Zaliczone",
          "Next lesson unlocked": "Kolejna lekcja odblokowana",
          "Go": "Przejdź",
          "Watched": "Obejrzano",
          "Learned words": "Poznane słowa",
          "All words from this lesson dialogue.": "Wszystkie słowa z dialogu w tej lekcji.",
          "Words in dictionary": "Słowa w słowniku",
          "Words added to your dictionary.": "Słowa dodane do Twojego słownika.",
          "Return to plan": "Wróć do planu",
          "Was this lesson useful?": "Czy ta lekcja była przydatna?",
          "Almost there!": "Prawie się udało!",
          "To pass the lesson, you need to meet two requirements. See what to repeat.": "Aby zaliczyć lekcję, trzeba spełnić dwa warunki. Sprawdź, co należy powtórzyć.",
          "Not passed": "Niezaliczone",
          "You need at least": "Potrzeba co najmniej",
          "correct answers": "prawidłowych odpowiedzi",
          "You need": "Potrzeba",
          "correct replies": "prawidłowych wypowiedzi",
          "Repeat quiz": "Powtórz test",
          "Repeat AI Speaking": "Powtórz rozmowę z AI",
          "Return to course": "Wróć do kursu",
          "That is okay!": "To normalne!",
          "Repetition is the best way to remember. Repeat the required steps, and the lesson will be passed.": "Powtarzanie to najlepszy sposób zapamiętywania. Powtórz wymagane elementy, aby zaliczyć lekcję.",
          // Course Complete
          "Congratulations! Course completed": "Gratulacje! Kurs został ukończony",
          "You successfully completed Travel English A0 → A1 and took a big step towards confident English.": "Pomyślnie ukończyłeś Travel English A0 → A1 i zrobiłeś wielki krok w kierunku pewnego angielskiego.",
          "This is not the end — it is a new level of your English.": "To nie koniec — to nowy poziom Twojego angielskiego.",
          "Average score": "Średni wynik",
          "Dialogues": "Dialogi",
          "Days": "Dni",
          "What next?": "Co dalej?",
          "Raise level": "Podnieś poziom",
          "Continue Travel English at A1 → A2. New topics, vocabulary, and speaking.": "Kontynuuj Travel English na poziomie A1 → A2. Nowe tematy, słownictwo i speaking.",
          "Start A1 → A2": "Rozpocznij A1 → A2",
          "Learn a new topic": "Ucz się nowego tematu",
          "Choose another area: work, study, socializing, or something new.": "Wybierz inny obszar: praca, nauka, rozmowy lub coś nowego.",
          "Choose a topic": "Wybierz temat",
          "Watch something interesting": "Obejrzyj coś ciekawego",
          "Browse videos on different topics and practice without a plan at your own pace.": "Oglądaj filmy na różne tematy i ćwicz bez planu we własnym tempie.",
          "Choose a video": "Wybierz film",
    
          // Create Course
          "What would you like to learn next?": "Czego chcesz uczyć się dalej?",
          "Choose a topic and level for the new course. Completed courses will remain in your account.": "Wybierz temat i poziom nowego kursu. Ukończone kursy pozostaną na Twoim koncie.",
          "Which topic would you like to study?": "Jakiego tematu chcesz się uczyć?",
          "We will select lessons based on your new learning area.": "Dobierzemy lekcje do nowego obszaru nauki.",
          "Socializing": "Rozmowy",
          "Small talk, meeting people, and everyday conversations.": "Small talk, poznawanie ludzi i codzienne rozmowy.",
          "For yourself": "Dla siebie",
          "Everyday topics, hobbies, and light practice.": "Codzienne tematy, hobby i lekka praktyka.",
          "News & Tech": "News & Tech",
          "Current topics, technology, news, and discussions.": "Współczesne tematy, technologie, wiadomości i dyskusje.",
          "Doctor visits, wellbeing, pharmacy, and basic situations.": "Wizyty u lekarza, samopoczucie, apteka i podstawowe sytuacje.",
          "Plans, weekends, leisure, and meetings.": "Plany, weekendy, rozrywka i spotkania.",
          "Which level should this course start from?": "Od którego poziomu rozpocząć ten kurs?",
          "Choose a level — you can change it later in the course settings.": "Wybierz poziom — możesz go później zmienić w ustawieniach kursu.",
          "Not sure? Choose an approximate level — you can change it later in the course settings.": "Nie masz pewności? Wybierz przybliżony poziom — możesz go później zmienić w ustawieniach kursu.",
          "New course": "Nowy kurs",
          "Topic": "Temat",
          "Approximately": "Około",
          "18 lessons": "18 lekcji",
          "The course will be added to “My courses”. Completed courses will remain available.": "Kurs zostanie dodany do sekcji „Moje kursy”. Ukończone kursy pozostaną dostępne.",
          "Failed to create course. Please try again.": "Nie udało się utworzyć kursu. Spróbuj ponownie.",
          "Create course": "Utwórz kurs",
          "Click underlined words in the text to see their translation and add them to your dictionary.": "Click underlined words in the text to see their translation and add them to your dictionary.",
          "Explanation": "Wyjaśnienie",
          "Your answer sounds good.": "Odpowiedź brzmi dobrze.",
          "Accepted": "Zaliczone",
          "Stop": "Stop",
          "reportProblemText": "Problem z lekcją? Zgłoś",
          "Report an issue": "Zgłoś problem",
          "Choose what needs to be checked.": "Wybierz, co należy sprawdzić.",
          "Issue with the video": "Problem z filmem",
          "Issue with the word": "Problem ze słowem",
          "Issue with the question": "Problem z zadaniem",
          "Issue with AI Speaking": "Problem z rozmową z AI",
          "Other issue": "Inny problem",
          "What exactly is wrong?": "Co dokładnie jest nie tak?",
          "Video does not load": "Film się nie ładuje",
          "Video does not play": "Film się nie odtwarza",
          "No sound": "Brak dźwięku",
          "Subtitles are not displayed": "Napisy nie są wyświetlane",
          "Incorrect subtitles": "Nieprawidłowe napisy",
          "Incorrect translation": "Nieprawidłowe tłumaczenie",
          "Translation is not displayed": "Tłumaczenie nie jest wyświetlane",
          "Incorrect explanation": "Nieprawidłowe wyjaśnienie",
          "Incorrect example": "Nieprawidłowy przykład",
          "Audio does not work": "Wymowa nie działa",
          "Incorrect question": "Nieprawidłowe pytanie",
          "Incorrect answer marked as correct": "Nieprawidłowa odpowiedź oznaczona jako poprawna",
          "Incorrect answer options": "Nieprawidłowe opcje odpowiedzi",
          "Translation error": "Błąd w tłumaczeniu",
          "Question does not work": "Zadanie nie działa",
          "Voice recording does not work": "Nagrywanie głosu nie działa",
          "Recording does not stop": "Nagrywanie nie zatrzymuje się",
          "Recording does not play": "Nagranie nie odtwarza się",
          "AI incorrectly recognized": "AI nieprawidłowo rozpoznał",
          "AI incorrectly assessed": "AI nieprawidłowo ocenił",
          "Incorrect hint": "Nieprawidłowa podpowiedź",
          "Technical error": "Błąd techniczny",
          "Page does not load": "Strona się nie ładuje",
          "Something is displayed incorrectly": "Coś wyświetla się nieprawidłowo",
          "Which word?": "Jakie słowo?",
          "Type the word…": "Wpisz słowo…",
          "Question text": "Tekst pytania",
          "Describe or type the question…": "Opisz lub wpisz pytanie…",
          "AI phrase": "Fraza AI",
          "Type the phrase…": "Wpisz frazę…",
          "Comment — optional": "Komentarz — opcjonalnie",
          "Describe what needs to be fixed…": "Opisz, co należy poprawić…",
          "We received your report and will investigate the issue.": "Otrzymaliśmy zgłoszenie i sprawdzimy problem.",
          "Lesson": "Lekcja",
          "Continue self-study from where you left off.": "Kontynuuj samodzielną naukę od miejsca, w którym przerwano.",
          "Start learning": "Zacznij się uczyć",
          "Pick a lesson to start with": "Wybierz lekcję, od której chcesz zacząć",
          "Browse the video catalog and choose a topic": "Przeglądaj katalog wideo i wybierz temat",
          "Go to videos": "Przejdź do filmów",
          "Videos you've added to your account.": "Filmy dodane do Twojego konta.",
          "No videos in progress": "Brak filmów w toku",
          "No completed videos": "Brak ukończonych filmów",
          "No favorite videos": "Brak ulubionych filmów",
          "No added videos": "Brak dodanych filmów",
          "Like": "Tak jak",
          "Dislike": "Nie lubić",
          "Remove from my videos": "Usuń z moich filmów",
          "Remove video from cabinet?": "Usunąć wideo z konta?",
          "The video will be removed from the 'My videos' section. You can find it again on the 'All videos' page.": "Wideo zostanie usunięte z sekcji «Moje wideo». Będziesz mógł znaleźć je ponownie na stronie «Wszystkie filmy».",
          "Cancel": "Anuluj",
          "Delete": "Usuń",
          "Total lessons": "Łączna liczba lekcji",
          "Completed lessons": "Ukończone lekcje",
          "Choose the level for the next course. We will change your current plan.": "Wybierz poziom następnego kursu. Zmienimy Twój obecny plan.",
          "Current course": "Obecny kurs",
          "Not sure? Take a short test": "Nie masz pewności? Zdaj krótki test",
          "Change level": "Zmień poziom",
          "Choose a course that better matches your current level. We will change your current plan.": "Wybierz kurs, który lepiej odpowiada Twojemu obecnemu poziomowi. Zmienimy Twój obecny plan.",
          "Choose a new topic": "Wybierz nowy temat",
          "We will change the goal of your current course.": "Zmienimy cel Twojego obecnego kursu.",
          "Next: choose level": "Dalej: wybierz poziom",
          "Which level to start from?": "Od jakiego poziomu zacząć?",
          "Choose a level for the new topic.": "Wybierz poziom dla nowego tematu.",
          "Not sure? Take a test": "Nie masz pewności? Zdaj test",
          "Updated plan": "Zaktualizowany plan",
          "Your progress on the current course will be saved, only the topic/level of the plan will change.": "Twoje postępy w obecnym kursie zostaną zapisane, zmieni się tylko temat/poziom planu.",
          "Change course": "Zmień kurs",
          "All self-learned words": "Wszystkie samodzielnie przyswojone słowa",
          "Back to text": "Powrót do tekstu",
          "Confirming your email…": "Potwierdzamy Twój e-mail…",
          "This will only take a moment": "To potrwa tylko chwilę",
          "Email confirmed": "E-mail potwierdzony",
          "You're signed in, taking you to the app…": "Jesteś zalogowany, przenosimy Cię do aplikacji…",
          "Continue to the app": "Przejdź do aplikacji",
          "Sign in to start learning": "Zaloguj się, aby zacząć naukę",
          "Sign in": "Zaloguj się",
          "This link doesn't work": "Ten link nie działa",
          "The link is broken or has expired – request a new confirmation email and try again":
          "Link jest uszkodzony lub wygasł – poproś o nowy e-mail potwierdzający i spróbuj ponownie",
          "Back to home": "Na stronę główną",
        },
      },
    },
    supportedLngs: ["en", "uk", "pl"],
    fallbackLng: "uk",
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
